import type { ILang } from '@core/interfaces/ILang';

const lang: ILang = {
  alert: {
    abort: 'Ακύρωση',
    buy: 'Αγορά',
    cancel: 'Ακύρωση',
    caption: 'Σφάλμα',
    close: 'Κλείσιμο',
    confirm: 'Επιβεβαίωση',
    dont_save: 'Μην αποθηκεύσετε',
    dont_show_again: 'Να μην εμφανιστεί ξανά',
    duplicated_preset_name: 'Όνομα προεπιλογής υπάρχει ήδη',
    error: 'Σφάλμα',
    info: 'ΠΛΗΡΟΦΟΡΙΕΣ',
    instruction: 'Οδηγία',
    learn_more: 'Μάθετε περισσότερα',
    no: 'Όχι',
    ok: 'Εντάξει',
    ok2: 'Εντάξει',
    oops: 'Ωχ...',
    retry: 'Επανάληψη',
    save: 'Αποθήκευση',
    stop: 'Σταματήστε',
    warning: 'ΠΡΟΕΙΔΟΠΟΙΗΣΗ',
    yes: 'Ναι',
  },
  auto_fit: {
    artwork_size: 'Μέγεθος έργου',
    error_tip1: '1. Είναι το έργο τοποθετημένο σωστά στο υλικό;',
    error_tip2: '2. Είναι τα περιγράμματα του υλικού αρκετά καθαρά για αναγνώριση;',
    failed_to_find_contour: 'Αποτυχία εύρεσης περιγράμματος για αυτόματη προσαρμογή',
    how_to_improve_accuracy: 'Πώς να βελτιώσετε την ακρίβεια ανίχνευσης;',
    how_to_improve_accuracy_url: 'https://support.flux3dp.com/hc/en-us/articles/15792349372687',
    learn_more: 'Προβολή οδηγού',
    learn_more_url: 'https://support.flux3dp.com/hc/en-us/articles/10273384373775',
    offset_x: 'Μετατόπιση X',
    offset_y: 'Μετατόπιση Y',
    pattern_size: 'Μέγεθος μοτίβου',
    position_artwork: 'Τοποθετήστε το έργο τέχνης',
    position_step1: 'Ρυθμίστε το μέγεθος και τη θέση του έργου τέχνης σας στο μοτίβο.',
    position_step2: 'Κάντε κλικ στο «Εφαρμογή» για να εφαρμόσετε το Auto Fit σε αυτό το μοτίβο.',
    preview_first: 'Παρακαλώ εκτελέστε πρώτα την προεπισκόπηση της κάμερας.',
    reset_position: 'Επαναφορά θέσης',
    retake: 'Επανάληψη λήψης',
    retake_tooltip: 'Επανάληψη λήψης φωτογραφίας στη θέση κάθε αντικειμένου για καλύτερη ανίχνευση',
    retry_with_remove_bg: 'Αφαίρεση φόντου',
    retry_with_remove_bg_tooltip: 'Αφαίρεση φόντου από την εικόνα προεπισκόπησης για βελτίωση ανίχνευσης περιγράμματος',
    rotation: 'Περιστροφή',
    select_a_pattern: 'Επιλέξτε ένα μοτίβο',
    selected_artwork: 'Επιλεγμένο έργο τέχνης',
    step1: 'Επιλέξτε ένα μοτίβο όπου θέλετε να τοποθετήσετε το έργο τέχνης.',
    step2: 'Εάν δεν βρεθεί μοτίβο, προβάλετε ξανά την κάμερα και εφαρμόστε την Αυτόματη Προσαρμογή.',
    step3: 'Εάν εξακολουθεί να μην βρίσκει το σωστό μοτίβο, βεβαιωθείτε ότι το αντικείμενό σας αναγνωρίζεται καθαρά και ότι η περιοχή εργασίας είναι καθαρή από συντρίμμια.',
    title: 'Έξυπνη Τοποθέτηση',
    use_original_image: 'Χρήση αρχικής εικόνας',
    use_original_image_tooltip: 'Επαναφορά της αρχικής εικόνας προεπισκόπησης χωρίς αφαίρεση φόντου',
    warning_bg_removal: 'Αυτή η λειτουργία θα εκτελέσει τη δυνατότητα "Αφαίρεση φόντου", η οποία θα χρησιμοποιήσει 0,02 Credit. Θέλετε να συνεχίσετε;',
    warning_retake_preview: 'Αυτή η λειτουργία είναι μερική επανάληψη λήψης. Θα προστεθούν νέες εικόνες και φόντο. Θέλετε να συνεχίσετε;',
  },
  autosave: {
    open_settings: 'Άνοιγμα ρυθμίσεων',
    path_not_correct: 'Η τοποθεσία αυτόματης αποθήκευσης δεν υπάρχει πλέον.',
    path_not_correct_desc: 'Παρακαλώ επιλέξτε έναν νέο φάκελο στο <b>%(preferences)s > %(autosave)s > %(path)s</b> για να συνεχίσετε να αποθηκεύετε τη δουλειά σας.',
  },
  barcode_generator: {
    bar_height: 'Ύψος γραμμής',
    bar_width: 'Πλάτος γραμμής',
    barcode: {
      invalid_value: 'Η τιμή δεν είναι έγκυρη για την επιλεγμένη μορφή.',
    },
    font: 'Γραμματοσειρά',
    font_size: 'Μέγεθος γραμματοσειράς',
    hide_text: 'Απόκρυψη κειμένου',
    invert_color: 'Αντιστροφή χρώματος',
    text: 'Κείμενο',
    text_margin: 'Περιθώριο κειμένου',
  },
  beambox: {
    ai_generate: {
      dimensions: {
        more: 'Περισσότερα',
        ratio: 'Αναλογία',
        resolution: 'Ανάλυση',
        title: 'Διαστάσεις εικόνας',
      },
      error: {
        config_description: 'Αποτυχία φόρτωσης διαμόρφωσης AI',
        config_message: 'Αποτυχία φόρτωσης στυλ AI',
        generation_failed: 'Η δημιουργία απέτυχε',
        import_failed: 'Η εισαγωγή απέτυχε',
        insufficient_credits: 'Ανεπαρκή πιστωτικά μόρια',
      },
      form: {
        count: 'Αριθμός',
        credit_required: 'Απαιτούμενα πιστωτικά μόρια',
        editor: 'Επεξεργαστής',
        generate: 'Δημιουργία',
        laser_friendly: 'Φιλικό προς λέιζερ',
      },
      header: {
        history_tooltip: 'Ιστορικό',
        reset_tooltip: 'Επαναφορά όλων',
        title: 'AI Δημιουργία',
      },
      history: {
        detail: 'Λεπτομέρειες',
        empty_description: 'Δεν υπάρχει ακόμα ιστορικό δημιουργίας. Ξεκινήστε να δημιουργείτε!',
        error_message: 'Αποτυχία φόρτωσης ιστορικού',
        not_generated: '❌ Δεν δημιουργήθηκε',
        recreate: 'Αναδημιουργία',
        status_failed: 'Απέτυχε',
        status_generating: 'Δημιουργία σε εξέλιξη',
        status_success: 'Επιτυχία',
        storage_notice: 'Αποθηκεύονται έως 10 πρόσφατες εγγραφές. Οι δημιουργημένες εικόνες διατηρούνται για 3 ημέρες.',
        title: 'Ιστορικό δημιουργίας',
      },
      loading: {
        history: 'Φόρτωση ιστορικού...',
        styles: 'Φόρτωση στυλ AI...',
        tip_0: 'Εκκίνηση της δημιουργικής μηχανής…',
        tip_1: 'Γυάλισμα pixels… ✨',
        tip_2: 'Σχεδόν έτοιμο, βελτίωση λεπτομερειών',
        tip_3: 'Ακόμα σε δημιουργία, αυτό το μέρος χρειάζεται λίγο περισσότερο χρόνο',
        tip_4: 'Οι μεγάλες ιδέες χρειάζονται χρόνο, ευχαριστούμε για την υπομονή σας',
      },
      results: {
        download: 'Λήψη',
        import: 'Εισαγωγή',
        title: 'Αποτελέσματα',
      },
      retry: 'Επανάληψη',
      style: {
        apply: 'Εφαρμογή στυλ',
        choose: 'Επιλογή στυλ',
        custom_creation: 'Προσαρμοσμένη δημιουργία',
        customize: 'Προσαρμογή',
        select: 'Επιλογή στυλ δημιουργίας',
      },
      upload: {
        add: 'Προσθήκη',
        click_or_drag: 'Κάντε κλικ ή σύρετε εικόνες εδώ',
        error: 'Σφάλμα μεταφόρτωσης',
        file_size_error: '%s: Το μέγεθος αρχείου πρέπει να είναι μικρότερο από %sMB',
        file_type_error: '%s: Υποστηρίζονται μόνο εικόνες JPEG, PNG και WebP',
        from_history: 'Από το ιστορικό',
        images: 'Μεταφόρτωση εικόνων',
        max_images_error: 'Επιτρέπονται έως %s εικόνες',
        selected: '%s / %s επιλεγμένα',
        supported_formats: 'JPEG, PNG, WebP • Μέγιστο %s',
      },
      validation: {
        description_or_image_required: 'Παρακαλώ δώστε μια περιγραφή ή ανεβάστε τουλάχιστον μία εικόνα',
        field_exceeds_max_length: 'Το "%s" υπερβαίνει το μέγιστο μήκος %s χαρακτήρων.',
        field_required: 'Το "%s" είναι υποχρεωτικό. Παρακαλώ συμπληρώστε αυτό το πεδίο.',
        login_required: 'Παρακαλώ συνδεθείτε για να χρησιμοποιήσετε τη δημιουργία AI.',
        max_images: 'Επιτρέπονται έως %s εικόνες',
      },
    },
    announcement_panel: {
      title: 'Ανακοίνωση',
    },
    banner: {
      auto_feeder: 'Λειτουργία Αυτόματης Τροφοδοσίας',
      autofocus1: 'Λειτουργία Αυτόματης Εστίασης',
      autofocus2: 'Κάντε κλικ οπουδήποτε για να εκτελέσετε αυτόματη εστίαση.',
      camera_preview_borderless_mode: '(Ανοιχτός Πάτος)',
      curve_engraving: 'Λειτουργία Χάραξης Καμπύλης',
      pass_through: 'Λειτουργία Διέλευσης',
      rotary: 'Λειτουργία Περιστροφής',
    },
    bottom_right_panel: {
      convert_text_to_path_before_export: 'Μετατρέψτε το κείμενο σε μονοπάτι πριν από την εξαγωγή',
      export_file_error_ask_for_upload: 'Αποτυχία εξαγωγής εργασίας. Είστε πρόθυμοι να παρέχετε τη σκηνή εργασίας στην ομάδα ανάπτυξης για αναφορά σφαλμάτων;',
      retreive_image_data: 'Ανάκτηση δεδομένων εικόνας...',
    },
    context_menu: {
      copy: 'Αντιγραφή',
      cut: 'Αποκοπή',
      delete: 'Διαγραφή',
      duplicate: 'Αντιγραφή',
      group: 'Ομάδα',
      move_back: 'Μετακινήστε πίσω',
      move_down: 'Μετακινήστε κάτω',
      move_front: 'Μετακινήστε μπροστά',
      move_up: 'Μετακινήστε πάνω',
      paste: 'Επικόλληση',
      paste_in_place: 'Επικόλληση στη θέση',
      ungroup: 'Κατάργηση ομαδοποίησης',
    },
    document_panel: {
      add_on: 'Πρόσθετες λειτουργίες',
      auto_feeder: 'Αυτόματος τροφοδότης',
      auto_feeder_url: 'https://support.flux3dp.com/hc/en-us/articles/11688230498575',
      auto_shrink: 'Αυτόματη σμίκρυνση',
      auto_shrink_tooltip: 'Ισχύει μόνο για επίπεδα με ανάλυση μεγαλύτερη ή ίση με 250 DPI.',
      auto_shrink_url: 'https://support.flux3dp.com/hc/en-us/articles/12997377035919',
      borderless_mode: 'Ανοιχτό κάτω μέρος',
      current_position: 'Τρέχουσα Θέση',
      disable: 'Απενεργοποίηση',
      document_settings: 'Ρυθμίσεις εγγράφου',
      door_protect: 'Προστασία πόρτας',
      door_protect_desc: 'Διαθέσιμο μόνο με το Promark Safe+.',
      enable_autofocus: 'Αυτόματη εστίαση',
      enable_diode: 'Λέιζερ διόδου',
      enable_nozzle_refresh_area: 'Ενεργοποίηση περιοχής ανανέωσης ακροφυσίου',
      extend_y_area: 'Επέκταση περιοχής Y',
      frame_before_start: 'Πλαίσιο πριν από την εκτέλεση',
      frame_before_start_url: 'https://support.flux3dp.com/hc/en-us/articles/11494925637135',
      job_origin: 'Αφετηρία Εργασίας',
      laser_source: 'Πηγή λέιζερ',
      machine: 'Μηχανή',
      manual: 'Χειροκίνητο',
      notification: {
        changeFromPrintingWorkareaTitle: 'Θέλετε να μετατρέψετε τα επίπεδα εκτύπωσης σε επίπεδα λέιζερ;',
      },
      origin: 'Αρχή',
      pass_through: 'Διέλευση',
      pass_through_height_desc: 'Εισαγάγετε το μήκος του αντικειμένου για να επεκτείνετε την περιοχή εργασίας.',
      prespray_times: 'Φορές καθαρισμού',
      rotary_mode: 'Περιστροφική λειτουργία',
      scale: 'Skala',
      skip_prespray: 'Παράλειψη καθαρισμού',
      start_from: 'Ξεκινάει Από',
      start_position: 'Θέση Έναρξης',
      start_work_button: 'Κουμπί Εκτέλεσης',
      workarea: 'Περιοχή εργασίας',
    },
    elements_panel: {
      animals: 'Ζώο',
      arrow: 'Βέλος',
      avatar: 'Άβαταρ',
      basic: 'Βασικά',
      birds: 'Πουλί',
      browse_categories: 'Περιήγηση σε κατηγορίες',
      celebration: 'Εορτασμός',
      circular: 'Κυκλικό',
      cleaning_tools: 'Εργαλεία καθαρισμού',
      CNY: 'Κινεζική Πρωτοχρονιά',
      corner: 'Γωνία',
      decor: 'Διακόσμηση',
      doctor: 'Γιατρός',
      easter: 'Πάσχα',
      elements: 'Στοιχεία',
      environment: 'Περιβάλλον',
      gardening_tools: 'Εργαλεία κηπουρικής',
      graphics: 'Γραφικά',
      halloween: 'Απόκριες',
      hammer_wrench: 'Σφυρί και κλειδί',
      heart: 'Καρδιά',
      holidays: 'Αργίες',
      insect: 'Έντομο',
      kitchen_tools: 'Εργαλεία κουζίνας',
      label: 'Ετικέτα',
      land: 'Ξηρά',
      line: 'Γραμμή',
      load_more: 'Φόρτωση των επόμενων 100 αποτελεσμάτων',
      nature: 'Φύση',
      people: 'Άνθρωποι',
      photo: 'Φωτογραφία',
      plants: 'Φυτά',
      police: 'Αστυνομία',
      recently_used: 'Χρησιμοποιήθηκε πρόσφατα',
      ribbon: 'Κορδέλα',
      sea: 'Θάλασσα',
      search_examples: 'Παραδείγματα:',
      search_invalid_characters: 'Χρησιμοποιήθηκαν μη έγκυροι χαρακτήρες.',
      search_no_results: 'Δεν βρέθηκαν αποτελέσματα για το "%s". Ελέγξτε την ορθογραφία ή δοκιμάστε μια διαφορετική λέξη-κλειδί.',
      search_with_english: 'Επιτρέπονται μόνο αγγλικά γράμματα, αριθμοί, κόμματα και κενά.',
      shape: 'Σχήμα',
      sign_in: 'Συνδεθείτε για να αποκτήσετε περισσότερα από 10.000 δωρεάν εικονίδια',
      speech: 'Ομιλία',
      student: 'Φοιτητής',
      study_tools: 'Εργαλεία μελέτης',
      teacher: 'Δάσκαλος',
      text: 'Πλαίσιο κειμένου',
      title: 'Σχήματα',
      tools: 'Εργαλεία',
      valentines: 'Αγίου Βαλεντίνου',
      weather: 'Καιρός',
      Xmas: 'Χριστούγεννα',
      zodiac: 'Ζώδια',
    },
    image_trace_panel: {
      back: 'Πίσω',
      brightness: 'Φωτεινότητα',
      cancel: 'Ακύρωση',
      contrast: 'Αντίθεση',
      next: 'Επόμενο',
      okay: 'Εντάξει',
      threshold: 'Κατώφλι',
      tuning: 'Ρυθμίσεις',
    },
    layer_color_config_panel: {
      add: 'Προσθήκη',
      add_config: 'Προσθήκη χρώματος',
      color: 'Χρώμα',
      default: 'Επαναφορά στις προεπιλογές',
      in_use: 'Αυτό το χρώμα χρησιμοποιείται.',
      layer_color_config: 'Διαμορφώσεις χρωμάτων στρώσης',
      no_input: 'Παρακαλώ εισάγετε έγκυρο κωδικό χρώματος δεκαεξαδικού.',
      power: 'Ισχύς',
      repeat: 'Επανάληψη',
      speed: 'Ταχύτητα',
      sure_to_delete: 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή τη ρύθμιση χρώματος;',
      sure_to_reset: 'Θα χαθούν όλες οι προσαρμοσμένες ρυθμίσεις. Είστε σίγουροι ότι θέλετε επαναφορά στις προεπιλογές;',
    },
    left_panel: {
      borderless_blind_area: 'Μη χαρακτική περιοχή',
      borderless_preview: 'Προεπισκόπηση κάμερας ανοιχτής λειτουργίας κάτω μέρους',
      diode_blind_area: 'Τυφλή περιοχή υβριδικού laser προσθήκης',
      label: {
        adjust_height: 'Ρύθμιση ύψους',
        array: 'Πίνακας',
        boxgen: 'Boxgen',
        choose_camera: 'Κάμερα',
        clear_preview: 'Εκκαθάριση προεπισκόπησης',
        cursor: 'Επιλογή',
        curve_engraving: {
          clear_area: 'Εκκαθάριση επιλεγμένης περιοχής',
          exit: 'Έξοδος',
          preview_3d_curve: 'Προεπισκόπηση χάραξης καμπύλης',
          select_area: 'Επιλέξτε περιοχή',
          title: 'Χάραξη καμπύλης',
        },
        elements: 'Σχήματα',
        end_preview: 'Τέλος προεπισκόπησης',
        fit_text: 'Πλαίσιο κειμένου',
        line: 'Γραμμή',
        live_feed: 'Ζωντανή μετάδοση',
        my_cloud: 'Το Cloud μου',
        oval: 'Στρογγυλεμένο ορθογώνιο',
        pass_through: 'Διέλευση',
        pen: 'Πένα',
        photo: 'Εικόνα',
        polygon: 'Πολύγωνο',
        preview: 'Προεπισκόπηση κάμερας',
        preview_precise: 'Ακριβής προεπισκόπηση κάμερας',
        preview_wide_angle: 'Προεπισκόπηση κάμερας ευρείας γωνίας',
        qr_code: 'Κωδικός QR',
        rect: 'Ορθογώνιο',
        text: 'Κείμενο',
        trace: 'Ιχνηλάτηση εικόνας',
      },
      unpreviewable_area: 'Τυφλή περιοχή',
    },
    network_testing_panel: {
      average_response: 'Μέσος χρόνος απόκρισης',
      cannot_connect_1: '#840 Αποτυχία σύνδεσης στην IP διεύθυνση-στόχο.',
      cannot_connect_2: '#840 Αποτυχία σύνδεσης στην IP διεύθυνση-στόχο. Παρακαλώ βεβαιωθείτε ότι ο στόχος βρίσκεται στο ίδιο δίκτυο.',
      cannot_get_local: 'Αποτυχία πρόσβασης στην τοπική διεύθυνση IP.',
      connection_quality: 'Ποιότητα σύνδεσης',
      device_not_on_list: '#842 Το μηχάνημα δεν βρίσκεται στη λίστα, αλλά η ποιότητα σύνδεσης είναι >70 και ο μέσος χρόνος απόκρισης είναι <100ms',
      empty_ip: '#818 Παρακαλώ εισάγετε πρώτα τη διεύθυνση IP της συσκευής προορισμού.',
      end: 'Τέλος',
      fail_to_start_network_test: '#817 Αποτυχία έναρξης δοκιμής δικτύου.',
      hint_connect_camera_timeout: 'Χρονικό όριο συμβαίνει κατά την εκκίνηση της προεπισκόπησης κάμερας;',
      hint_connect_failed_when_sending_job: 'Αποτυχία σύνδεσης κατά την αποστολή εργασίας;',
      hint_device_often_on_list: 'Το μηχάνημα συχνά δεν βρίσκεται στη λίστα;',
      insert_ip: 'Διεύθυνση IP προορισμού:',
      invalid_ip: '#818 Μη έγκυρη διεύθυνση IP',
      ip_startswith_169: '#843 Η διεύθυνση IP του μηχανήματος ξεκινά με 169.254',
      link_connect_camera_timeout: 'https://support.flux3dp.com/hc/en-us/articles/360001791895',
      link_connect_failed_when_sending_job: 'https://support.flux3dp.com/hc/en-us/articles/360001841656',
      link_device_often_on_list: 'https://support.flux3dp.com/hc/en-us/articles/360001841636',
      linux_permission_hint: 'Αυτό το σφάλμα συνήθως προκύπτει λόγω ανεπαρκών δικαιωμάτων. \nΕυγενικά εκτελέστε "sudo beam-studio --no-sandbox" στο τερματικό για να λάβετε άδειες και να εκτελέσετε δοκιμή δικτύου.',
      local_ip: 'Τοπική Διεύθυνση IP:',
      network_testing: 'Δοκιμή Δικτύου',
      network_unhealthy: '#841 Ποιότητα σύνδεσης <70 ή μέσος χρόνος απόκρισης >100ms',
      start: 'Έναρξη',
      test_completed: 'Ολοκλήρωση δοκιμής',
      test_fail: 'Αποτυχία δοκιμής',
      testing: 'Έλεγχος Δικτύου...',
    },
    object_panels: {
      lock_desc: 'Διατήρηση του λόγου πλάτους και ύψους (SHIFT)',
      text_to_path: {
        check_thumbnail_warning: 'Ορισμένα κείμενα άλλαξαν σε άλλες γραμματοσειρές κατά τη μετατροπή κειμένων σε διαδρομές και ορισμένοι χαρακτήρες ενδέχεται να μην μετατραπούν κανονικά. \nΕλέγξτε ξανά την προεπισκόπηση εικόνας πριν στείλετε την εργασία.',
        error_when_parsing_text: 'Σφάλμα κατά τη μετατροπή κειμένου σε διαδρομή',
        font_substitute_pop: 'Το κείμενό σας περιέχει χαρακτήρες που δεν υποστηρίζονται από την τρέχουσα γραμματοσειρά. <br/>Θα θέλατε να χρησιμοποιήσετε το <strong>%s</strong> ως υποκατάστατο;',
        retry: 'Παρακαλώ δοκιμάστε αργότερα ή επιλέξτε άλλη γραμματοσειρά',
        use_current_font: 'Χρήση Τρέχουσας Γραμματοσειράς',
      },
      wait_for_parsing_font: 'Ανάλυση γραμματοσειράς... Παρακαλώ περιμένετε ένα δευτερόλεπτο',
    },
    path_preview: {
      current_position: 'Τρέχουσα θέση',
      cut_distance: 'Απόσταση κοπής',
      cut_time: 'Χρόνος κοπής',
      end_preview: 'Τέλος προεπισκόπησης',
      estimated_time: 'Συνολικός εκτιμώμενος χρόνος',
      invert: 'Αντιστροφή',
      pause: 'Παύση',
      play: 'Αναπαραγωγή',
      play_speed: 'Ταχύτητα αναπαραγωγής',
      preview_info: 'Πληροφορίες προεπισκόπησης',
      rapid_distance: 'Απόσταση μετακίνησης',
      rapid_time: 'Χρόνος μετακίνησης',
      remark: '* Όλες οι πληροφορίες είναι εκτιμήσεις για αναφορά.',
      size: 'Μέγεθος',
      start_here: 'Ξεκινήστε εδώ',
      stop: 'Σταμάτημα',
      travel_path: 'Διαδρομή μετακίνησης',
    },
    photo_edit_panel: {
      aspect_ratio: 'Αναλογία διαστάσεων',
      brightness: 'Φωτεινότητα',
      brightness_and_contrast: 'Φωτεινότητα / Αντίθεση',
      circumference: 'Περίμετρος',
      compare: 'Σύγκριση',
      contrast: 'Αντίθεση',
      crop: 'Περικοπή',
      curve: 'Καμπύλη',
      diameter: 'Διάμετρος',
      free: 'Ελεύθερο',
      invert: 'Αντιστροφή χρωμάτων',
      original: 'Αρχικό',
      phote_edit: 'Επεξεργασία φωτογραφίας',
      processing: 'Επεξεργασία',
      radius: 'Ακτίνα',
      rotary_warped: 'Περιστροφική Παραμόρφωση',
      rotary_warped_link: 'https://support.flux3dp.com/hc/en-us/articles/10828006201103',
      sharpen: 'Εστίαση',
      sharpness: 'Ευκρίνεια',
      start: 'Έναρξη',
      warp: 'Παραμόρφωση',
    },
    popup: {
      ai_credit: {
        buy_link: 'https://member.flux3dp.com/en-US/credit',
        insufficient_credit: 'Ανεπαρκής πίστωση',
        insufficient_credit_msg: 'Αυτή η λειτουργία απαιτεί %s πιστώσεις AI, αλλά έχετε μόνο %s πιστώσεις AI.\nΠαρακαλώ αγοράστε περισσότερες πιστώσεις και δοκιμάστε ξανά.',
        relogin_to_use: 'Παρακαλούμε συνδεθείτε ξανά για να χρησιμοποιήσετε αυτήν τη λειτουργία.',
      },
      auto_feeder_origin: 'Χρησιμοποιήστε την προεπισκόπηση πλαισίου για να ελέγξετε τη διαδρομή και την περιοχή της κεφαλής λέιζερ και στη συνέχεια προσαρμόστε τη θέση του υλικού ή τη θέση εκκίνησης της χάραξης βάσει των αποτελεσμάτων για να αποφύγετε συγκρούσεις κατά τη διαδικασία χάραξης.',
      auto_switch_tab: {
        message: 'Μια νέα επιλογή για αυτόματη εναλλαγή μεταξύ του πίνακα Επιπέδων και του πίνακα Αντικειμένων έχει προστεθεί στις Προτιμήσεις. Αυτή η επιλογή είναι απενεργοποιημένη από προεπιλογή. Θέλετε να ενεργοποιήσετε την αυτόματη εναλλαγή τώρα; <br/>Μπορείτε να αλλάξετε αυτήν τη ρύθμιση οποιαδήποτε στιγμή στις Προτιμήσεις.',
        title: 'Αυτόματη Εναλλαγή Πάνελ Επίπεδου και Αντικειμένου',
      },
      backend_connect_failed_ask_to_upload: '#802 Συνεχίζουν να προκύπτουν σφάλματα κατά τη σύνδεση με το backend. Θέλετε να μεταφορτώσετε την αναφορά σφαλμάτων;',
      backend_error_hint: 'Οι λειτουργίες ενδέχεται να μην λειτουργούν σωστά λόγω σφάλματος backend.',
      both_power_and_speed_too_high: 'Η χρήση χαμηλότερης ισχύος λέιζερ θα επεκτείνει τη διάρκεια ζωής του σωλήνα λέιζερ.  Επίσης, πολύ υψηλή ταχύτητα σε αυτή την ανάλυση μπορεί να έχει ως αποτέλεσμα χαμηλότερη ποιότητα χάραξης.',
      bug_report: 'Αναφορά σφαλμάτων',
      change_workarea_before_preview: 'Η περιοχή εργασίας του %s δεν ταιριάζει με την τρέχουσα περιοχή εργασίας που έχει οριστεί. Θέλετε να αλλάξετε την τρέχουσα περιοχή εργασίας;',
      convert_to_path_fail: 'Αποτυχία μετατροπής σε μονοπάτι.',
      disassemble_use: {
        clip_path_warning: 'Αυτό το αρχείο περιέχει μάσκα αποκοπής και δεν μπορεί να αποσυναρμολογηθεί.',
        execute_time_warning: 'Αυτό θα καταργήσει την ομαδοποίηση των εισαγόμενων DXF ή SVG. Επειδή το αρχείο ενδέχεται να περιέχει μεγάλο αριθμό στοιχείων, ενδέχεται να χρειαστεί χρόνος για την κατάργηση της ομαδοποίησης. Είστε σίγουροι ότι θέλετε να προχωρήσετε;',
      },
      dxf_bounding_box_size_over: 'Το μέγεθος του σχεδίου είναι εκτός της περιοχής εργασίας. Μετακινήστε το σχέδιό σας πιο κοντά στην αρχή στο λογισμικό CAD σας ή βεβαιωθείτε ότι η μονάδα έχει οριστεί σωστά.',
      dxf_paste_failed: 'Αποτυχία επικόλλησης DXF από το πρόχειρο. Βεβαιωθείτε ότι το αντιγραμμένο περιεχόμενο είναι έγκυρο DXF.',
      dxf_version_waring: 'Η έκδοση αυτού του αρχείου DXF δεν είναι 2013, ενδέχεται να υπάρχουν πιθανά προβλήματα ασυμβατότητας.',
      facebook_group_invitation: {
        already_joined: 'Ήδη μέλος',
        join_now: 'Μέσα',
        later: 'Ίσως αργότερα',
        message: 'Συμμετάσχετε στην επίσημη ομάδα μας στο Facebook για να συνδεθείτε με άλλους χρήστες, να συζητήσετε, να μοιραστείτε έργα και να ενημερωθείτε για τα νέα μας. Ανυπομονούμε να σας δούμε!',
        title: 'Συμμετοχή στην επίσημη ομάδα χρηστών',
      },
      failed_to_load_svg: 'Αδυναμία φόρτωσης δεδομένων SVG',
      import_file_contain_invalid_path: '#808 Το εισαγόμενο αρχείο SVG περιέχει μη έγκυρη διαδρομή εικόνας. Βεβαιωθείτε ότι όλα τα αρχεία εικόνας υπάρχουν ή ενσωματώστε την εικόνα στο αρχείο',
      import_file_error_ask_for_upload: 'Αποτυχία εισαγωγής αρχείου SVG. Θέλετε να παρέχετε το αρχείο στην ομάδα ανάπτυξης για αναφορά σφαλμάτων;',
      import_svg: {
        advice_message: 'Αυτό μπορεί να προκαλέσει σοβαρή καθυστέρηση ή αποτυχία εισαγωγής.',
        advice_message_2: 'Συνιστάται η απλοποίηση του αρχείου πριν την εισαγωγή.',
        confirmation_message: 'Θέλετε να συνεχίσετε;',
        element_count_warning: 'Αριθμός στοιχείων: %s (Συνιστάται: < %s).',
        file_size_warning: 'Μέγεθος αρχείου: %sMB (Συνιστάται: < %sMB).',
        intro_message: 'Το αρχείο μπορεί να είναι πολύ μεγάλο ή πολύπλοκο:',
        path_d_command_count_warning: 'Αριθμός εντολών: %s (Συνιστάται: < %s).',
        title: 'Προειδοποίηση εισαγωγής αρχείου',
      },
      layer_by_color: 'Χρώμα',
      layer_by_layer: 'Στρώμα',
      loading_image: 'Φόρτωση εικόνας, παρακαλώ περιμένετε...',
      more_than_two_object: 'Πάρα πολλά αντικείμενα. Υποστήριξη μόνο για 2 αντικείμενα',
      mouse: 'Ποντίκι',
      no_curve_engraving_with_modules: 'Αυτή η εργασία περιλαμβάνει χάραξη σε καμπύλη επιφάνεια, η οποία δεν μπορεί να χρησιμοποιηθεί μαζί με έγχρωμη εκτύπωση. Απενεργοποιήστε το επίπεδο έγχρωμης εκτύπωσης και στείλτε ξανά την εργασία.',
      no_support_text: 'Το Beam Studio δεν υποστηρίζει ετικέτες κειμένου αυτή τη στιγμή. Μεταφέρετε το κείμενο σε μονοπάτι πριν από την εισαγωγή.',
      nolayer: 'Μονό στρώμα',
      not_support_object_type: 'Μη υποστηριζόμενος τύπος αντικειμένου',
      or_turn_off_borderless_mode: ' Ή απενεργοποιήστε τη λειτουργία Ανοιχτό Κάτω Μέρος.',
      path_engine_upgrade: {
        caption: 'Διαθέσιμη ταχύτερη δημιουργία εργασιών',
        keep_current: 'Διατήρηση τρέχουσας',
        message: 'Αναβαθμίσαμε τη μηχανή υπολογισμού εργασιών για βελτίωση της απόδοσης και επιτάχυνση της δημιουργίας εργασιών.\nΘέλετε να μεταβείτε στη νέα επιταχυνόμενη μηχανή;\nΜπορείτε να την απενεργοποιήσετε ανά πάσα στιγμή στο %(preferences)s > %(editor)s > %(path_acceleration)s.',
      },
      pdf2svg: {
        error_pdf2svg_not_found: '#825 Σφάλμα: Η εντολή pdf2svg δεν βρέθηκε. Εγκαταστήστε το pdf2svg με τον διαχειριστή πακέτων σας (π.χ. "yum install pdf2svg" ή "apt-get install pdf2svg").',
        error_when_converting_pdf: '#824 Σφάλμα κατά τη μετατροπή του PDF σε SVG:',
      },
      progress: {
        calculating: 'Υπολογισμός',
        uploading: 'Μεταφόρτωση',
      },
      questionnaire: {
        caption: 'Βοηθήστε μας να βελτιώσουμε την εφαρμογή',
        message: 'Βοηθήστε μας να βελτιώσουμε την εφαρμογή συμπληρώνοντας το ερωτηματολόγιο',
        no_questionnaire_available: 'Δεν υπάρχει διαθέσιμο ερωτηματολόγιο αυτή τη στιγμή.',
        unable_to_get_url: 'Αποτυχία λήψης του συνδέσμου προς το ερωτηματολόγιο. Ελέγξτε τη σύνδεσή σας στο διαδίκτυο.',
      },
      reach_tab_count_limit: 'Έχει επιτευχθεί το όριο καρτελών',
      recommend_downgrade_software: 'Εντοπίσαμε μια παλαιότερη έκδοση υλικολογισμικού. Αντιμετωπίζουμε θέματα συμβατότητας, αλλά προς το παρόν συνιστούμε να επιστρέψετε στο Beam Studio 1.9.5.',
      recommend_upgrade_firmware: 'Εντοπίσαμε μια παλαιότερη έκδοση υλικολογισμικού. Αντιμετωπίζουμε θέματα συμβατότητας, αλλά προς το παρόν συνιστούμε την ενημέρωση στο τελευταίο υλικολογισμικό.',
      save_unsave_changed: 'Θέλετε να αποθηκεύσετε τις μη αποθηκευμένες αλλαγές;',
      select_at_least_two: 'Επιλέξτε δύο αντικείμενα για να συνεχίσετε',
      select_first: 'Επιλέξτε πρώτα ένα αντικείμενο.',
      select_import_method: 'Επιλέξτε στυλ στρώσης:',
      select_import_module: 'Επιλέξτε Μονάδα:',
      sentry: {
        message: 'Συμφωνείτε να μεταφορτώνουμε αυτόματα τις σχετικές πληροφορίες στην ομάδα ανάπτυξης όταν προκύπτουν σφάλματα;',
        title: 'Ας βελτιώσουμε το Beam Studio μαζί',
      },
      should_update_firmware_to_continue: '#814 Το υλικολογισμικό σας δεν υποστηρίζει αυτή την έκδοση του Beam Studio. Παρακαλώ ενημερώστε το υλικολογισμικό για να συνεχίσετε. (Μενού > Μηχάνημα > [Το μηχάνημά σας] > Ενημέρωση υλικολογισμικού)',
      speed_too_high_lower_the_quality: 'Η χρήση πολύ υψηλής ταχύτητας σε αυτή την ανάλυση μπορεί να έχει ως αποτέλεσμα χαμηλότερη ποιότητα χάραξης.',
      still_continue: 'Συνέχεια',
      successfully_uploaded: 'Η μεταφόρτωση του αρχείου ολοκληρώθηκε με επιτυχία.',
      svg_1_1_waring: 'Η έκδοση αυτού του αρχείου SVG είναι v 1.1, ενδέχεται να υπάρχουν πιθανά προβλήματα ασυμβατότητας.',
      svg_image_path_waring: 'Αυτό το αρχείο SVG περιέχει φόρτωση <image> από διαδρομή αρχείου. Αυτό ενδέχεται να προκαλέσει αποτυχίες κατά τη φόρτωση.\nΓια να αποφύγετε αυτόν τον κίνδυνο, χρησιμοποιήστε ενσωματωμένη εικόνα κατά την εξαγωγή SVG.',
      text_to_path: {
        caption: 'Μετατροπέας κειμένου σε μονοπάτι 2.0',
        message: "Το Beam Studio εισάγει τώρα έναν νέο μετατροπέα κειμένου σε μονοπάτι (Μετατροπέας 2.0), ο οποίος παράγει πιο αξιόπιστα αποτελέσματα! Θα θέλατε να τον ενεργοποιήσετε τώρα; \\nΜπορείτε επίσης να προσαρμόσετε αυτήν τη ρύθμιση αργότερα στην ενότητα 'Μετατροπέας κειμένου σε μονοπάτι' εντός των προτιμήσεων.",
      },
      too_fast_for_auto_feeder: 'Η χρήση πολύ υψηλής ταχύτητας σε στρώματα που περιέχουν αντικείμενα διαδρομής μπορεί να οδηγήσει σε μειωμένη ακρίβεια κατά την κοπή.\nΔεν συνιστούμε τη χρήση ταχύτητας μεγαλύτερης από %(limit)s κατά την κοπή με το Auto Feeder.',
      too_fast_for_auto_feeder_and_constrain: 'Τα παρακάτω στρώματα: %(layers)s \nπεριέχουν διανυσματικά μονοπάτια και έχουν ταχύτητα που υπερβαίνει το %(limit)s.\nΗ ταχύτητα κοπής για διανυσματικά μονοπάτια με το Auto Feeder θα περιοριστεί στο %(limit)s.\nΜπορείτε να καταργήσετε αυτό το όριο στις Ρυθμίσεις Προτιμήσεων.',
      too_fast_for_curve: 'Στη λειτουργία χάραξης καμπυλών, η τρέχουσα ταχύτητα μπορεί να είναι πολύ υψηλή και να επηρεάσει τις λεπτομέρειες χάραξης για τα στρώματα: %(layers)s.\nΣκεφτείτε να μειώσετε την ταχύτητα για καλύτερη ποιότητα.',
      too_fast_for_path: 'Η χρήση πολύ υψηλής ταχύτητας σε στρώματα που περιέχουν αντικείμενα διαδρομής μπορεί να έχει ως αποτέλεσμα χαμηλότερη ακρίβεια κατά την κοπή. Δεν συνιστούμε τη χρήση ταχύτητας ταχύτερη από %(limit)s κατά την κοπή.',
      too_fast_for_path_and_constrain: 'Τα ακόλουθα στρώματα: %(layers)s \nπεριέχουν αντικείμενα διανυσματικής διαδρομής και έχουν ταχύτητα που υπερβαίνει τα %(limit)s. Η ταχύτητα κοπής των αντικειμένων διανυσματικής διαδρομής θα περιοριστεί στα %(limit)s. Μπορείτε να καταργήσετε αυτόν τον περιορισμό στις Ρυθμίσεις.',
      touchpad: 'TouchPad',
      upload_failed: '#819 Η μεταφόρτωση του αρχείου απέτυχε.',
      upload_file_too_large: '#819 Το αρχείο είναι πολύ μεγάλο για αποστολή.',
      vectorize_shading_image: 'Οι εικόνες με διαβάθμιση χρώματος χρειάζονται περισσότερο χρόνο για να ιχνηλατηθούν και είναι επιρρεπείς στο θόρυβο. Απενεργοποιήστε τη διαβάθμιση της εικόνας πριν εκτελέσετε.',
    },
    rating_panel: {
      description: 'Αν σας αρέσει το Beam Studio, θα εκτιμούσαμε πολύ την αξιολόγησή σας.',
      thank_you: 'Ευχαριστώ!',
      title: 'Απολαμβάνετε το Beam Studio;',
    },
    right_panel: {
      laser_panel: {
        advanced: 'Προηγμένες',
        air_assist: 'Υποβοήθηση αέρα',
        am_density: 'Πυκνότητα κουκκίδων ράστερ',
        backlash: 'Οπίσθια κίνηση',
        bi_directional: 'Διπλής Κατεύθυνσης',
        by: 'Κατά',
        ce_z_high_speed: 'Άξονας Z υψηλής ταχύτητας',
        ce_z_high_speed_link: 'https://support.flux3dp.com/hc/en-us/articles/10364060644495',
        color_adjustment: 'Ρύθμιση καναλιού',
        color_adjustment_short: 'Κανάλι',
        color_strength: 'Δύναμη',
        cross_hatch: 'Διασταυρωμένη Σκίαση',
        custom_preset: 'Προσαρμοσμένο',
        cut: 'Κόψιμο',
        diode: 'Δίοδος λέιζερ',
        do_not_adjust_default_para: 'Οι προεπιλογές δεν μπορούν να τροποποιηθούν.',
        dottingTime: 'Χρόνος στίξης',
        dropdown: {
          inches: {
            abs_engraving: 'ABS - Χάραξη',
            acrylic_3mm_cutting: 'Aκρυλικό - 1/8″ Κοπή',
            acrylic_5mm_cutting: 'Aκρυλικό - 3/16″ Κοπή',
            acrylic_7mm_cutting: 'Aκρυλικό - 1/4″ Κοπή',
            acrylic_8mm_cutting: 'Aκρυλικό - 1/4″ Κοπή',
            acrylic_10mm_cutting: 'Aκρυλικό - 3/8″ Κοπή',
            acrylic_engraving: 'Ακρυλικό - Χάραξη',
            acrylic_printing: 'Aκρυλικό - Εκτύπωση',
            aluminum_engraving: 'Αλουμίνιο - Χάραξη',
            aluminum_light: 'Αλουμίνιο (ανοιχτό)',
            bamboo_2mm_cutting: 'Μπαμπού - 5/64″ Κοπή',
            bamboo_5mm_cutting: 'Μπαμπού - 3/16″ Κοπή',
            bamboo_printing: 'Μπαμπού - Εκτύπωση',
            black_abs: 'Μαύρο ABS',
            black_acrylic_3mm_cutting: 'Μαύρο ακρυλικό - 1/8″ Κοπή',
            black_acrylic_5mm_cutting: 'Μαύρο ακρυλικό - 3/16″ Κοπή',
            black_acrylic_engraving: 'Μαύρο ακρυλικό - Χάραξη',
            brass_dark: 'Ορείχαλκος (σκούρο)',
            brass_engraving: 'Ορείχαλκος - Χάραξη',
            brass_light: 'Ορείχαλκος (ανοιχτό)',
            canvas_fabric_printing: 'Υφασμάτινος καμβάς - Εκτύπωση',
            canvas_printing: 'Καμβάς - Εκτύπωση',
            cardboard_printing: 'Χαρτόνι - Εκτύπωση',
            cardstock_printing: 'Χαρτόνι - Εκτύπωση',
            copper: 'Χαλκός',
            cork_printing: 'Φελλός - Εκτύπωση',
            denim_1mm_cutting: 'Τζην - 1/32″ Κοπή',
            fabric_3mm_cutting: 'Ύφασμα - 1/8″ Κοπή',
            fabric_5mm_cutting: 'Ύφασμα - 3/16″ Κοπή',
            fabric_engraving: 'Ύφασμα - Χάραξη',
            fabric_printing: 'Ύφασμα - Εκτύπωση',
            flat_stone_printing: 'Επίπεδη Πέτρα - Εκτύπωση',
            glass_bw_engraving: 'Γυαλί - Χάραξη',
            glass_printing: 'Γυαλί - Εκτύπωση',
            gloss_leather_printing: 'Γυαλιστερό δέρμα - Εκτύπωση',
            gold_engraving: 'Χρυσός - Χάραξη',
            iron_engraving: 'Σίδηρος - Χάραξη',
            leather_3mm_cutting: 'Δέρμα - 1/8″ Κοπή',
            leather_5mm_cutting: 'Δέρμα - 3/16″ Κοπή',
            leather_engraving: 'Δέρμα - Χάραξη',
            leather_printing: 'Δέρμα - Εκτύπωση',
            mdf_3mm_cutting: 'MDF Νέας Ζηλανδίας - 1/8″ Κοπή',
            mdf_5mm_cutting: 'MDF Νέας Ζηλανδίας - 3/16″ Κοπή',
            mdf_7mm_cutting: 'MDF Νέας Ζηλανδίας - 1/4″ Κοπή',
            mdf_engraving: 'MDF Νέας Ζηλανδίας - Χάραξη',
            mdf_printing: 'MDF Νέας Ζηλανδίας - Εκτύπωση',
            metal_bw_engraving: 'Μέταλλο - Χάραξη',
            opaque_acrylic: 'Αδιαφανές ακρυλικό',
            pc_printing: 'Πολυκαρβονικό - Εκτύπωση',
            rubber_bw_engraving: 'Καουτσούκ - Χάραξη',
            silver_engraving: 'Ασήμι - Χάραξη',
            slate_engraving: 'Σχιστόλιθος - Χάραξη',
            stainless_steel_bw_engraving_diode: 'Ανοξείδωτος χάλυβας - Χάραξη (Δίοδος λέιζερ)',
            stainless_steel_dark: 'Ανοξείδωτο ατσάλι (σκούρο)',
            stainless_steel_engraving: 'Ανοξείδωτος χάλυβας - Χάραξη',
            stainless_steel_light: 'Ανοξείδωτο ατσάλι (ανοιχτό)',
            stainless_steel_printing: 'Ανοξείδωτος Χάλυβας - Εκτύπωση',
            steel_engraving_spray_engraving: 'Μέταλλο - Χάραξη',
            sticker_kiss_cut: 'Αυτοκόλλητο – ημι-κοπή',
            sticker_printing: 'Αυτοκόλλητο - Εκτύπωση',
            stone: 'Πέτρα',
            ti_engraving: 'Τιτάνιο - Χάραξη',
            titanium_dark: 'Τιτάνιο (σκούρο)',
            titanium_light: 'Τιτάνιο (ανοιχτό)',
            white_abs: 'Λευκό ABS',
            wood_3mm_cutting: 'Ξύλο - 1/8″ Κοπή',
            wood_5mm_cutting: 'Ξύλο - 3/16″ Κοπή',
            wood_7mm_cutting: 'Ξύλο - 1/4″ Κοπή',
            wood_8mm_cutting: 'Ξύλο - 1/4″ Κοπή',
            wood_10mm_cutting: 'Ξύλο - 3/8″ Κοπή',
            wood_engraving: 'Ξύλο - Χάραξη',
            wood_printing: 'Ξύλο - Εκτύπωση',
          },
          mm: {
            abs_engraving: 'ABS - Χάραξη',
            acrylic_3mm_cutting: 'Ακρυλικό - 3mm Κοπή',
            acrylic_5mm_cutting: 'Ακρυλικό - 5mm Κοπή',
            acrylic_7mm_cutting: 'Ακρυλικό - 7mm Κοπή',
            acrylic_8mm_cutting: 'Ακρυλικό - 8mm Κοπή',
            acrylic_10mm_cutting: 'Ακρυλικό - 10mm Κοπή',
            acrylic_engraving: 'Ακρυλικό - Χάραξη',
            acrylic_printing: 'Aκρυλικό - Εκτύπωση',
            aluminum_engraving: 'Αλουμίνιο - Χάραξη',
            aluminum_light: 'Αλουμίνιο (ανοιχτό)',
            bamboo_2mm_cutting: 'Μπαμπού - 2mm Κοπή',
            bamboo_5mm_cutting: 'Μπαμπού - 5mm Κοπή',
            bamboo_printing: 'Μπαμπού - Εκτύπωση',
            black_abs: 'Μαύρο ABS',
            black_acrylic_3mm_cutting: 'Μαύρο ακρυλικό - 3mm Κοπή',
            black_acrylic_5mm_cutting: 'Μαύρο ακρυλικό - 5mm Κοπή',
            black_acrylic_engraving: 'Μαύρο ακρυλικό - Χάραξη',
            brass_dark: 'Ορείχαλκος (σκούρο)',
            brass_engraving: 'Ορείχαλκος - Χάραξη',
            brass_light: 'Ορείχαλκος (ανοιχτό)',
            canvas_fabric_printing: 'Υφασμάτινος καμβάς - Εκτύπωση',
            canvas_printing: 'Καμβάς - Εκτύπωση',
            cardboard_printing: 'Χαρτόνι - Εκτύπωση',
            cardstock_printing: 'Χαρτόνι - Εκτύπωση',
            copper: 'Χαλκός',
            cork_printing: 'Φελλός - Εκτύπωση',
            denim_1mm_cutting: 'Τζην - 1mm Κοπή',
            fabric_3mm_cutting: 'Ύφασμα - 3mm Κοπή',
            fabric_5mm_cutting: 'Ύφασμα - 5mm Κοπή',
            fabric_engraving: 'Ύφασμα - Χάραξη',
            fabric_printing: 'Ύφασμα - Εκτύπωση',
            flat_stone_printing: 'Επίπεδη Πέτρα - Εκτύπωση',
            glass_bw_engraving: 'Γυαλί - Χάραξη',
            glass_printing: 'Γυαλί - Εκτύπωση',
            gloss_leather_printing: 'Γυαλιστερό δέρμα - Εκτύπωση',
            gold_engraving: 'Χρυσός - Χάραξη',
            iron_engraving: 'Σίδηρος - Χάραξη',
            leather_3mm_cutting: 'Δέρμα - 3mm Κοπή',
            leather_5mm_cutting: 'Δέρμα - 5mm Κοπή',
            leather_engraving: 'Δέρμα - Χάραξη',
            leather_printing: 'Δέρμα - Εκτύπωση',
            mdf_3mm_cutting: 'MDF - 3mm Κοπή',
            mdf_5mm_cutting: 'MDF - 5mm Κοπή',
            mdf_7mm_cutting: 'MDF - 7mm Κοπή',
            mdf_engraving: 'MDF - Χάραξη',
            mdf_printing: 'MDF - Εκτύπωση',
            metal_bw_engraving: 'Μέταλλο - Χάραξη',
            opaque_acrylic: 'Αδιαφανές ακρυλικό',
            pc_printing: 'Πολυκαρβονικό - Εκτύπωση',
            rubber_bw_engraving: 'Καουτσούκ - Χάραξη',
            silver_engraving: 'Ασήμι - Χάραξη',
            slate_engraving: 'Σχιστόλιθος - Χάραξη',
            stainless_steel_bw_engraving_diode: 'Ανοξείδωτος χάλυβας - Χάραξη (Δίοδος λέιζερ)',
            stainless_steel_dark: 'Ανοξείδωτο ατσάλι (σκούρο)',
            stainless_steel_engraving: 'Ανοξείδωτος χάλυβας - Χάραξη',
            stainless_steel_light: 'Ανοξείδωτο ατσάλι (ανοιχτό)',
            stainless_steel_printing: 'Ανοξείδωτος Χάλυβας - Εκτύπωση',
            steel_engraving_spray_engraving: 'Μέταλλο - Χάραξη',
            sticker_kiss_cut: 'Αυτοκόλλητο – ημι-κοπή',
            sticker_printing: 'Αυτοκόλλητο - Εκτύπωση',
            stone: 'Πέτρα',
            ti_engraving: 'Τιτάνιο - Χάραξη',
            titanium_dark: 'Τιτάνιο (σκούρο)',
            titanium_light: 'Τιτάνιο (ανοιχτό)',
            white_abs: 'Λευκό ABS',
            wood_3mm_cutting: 'Ξύλο - 3mm Κοπή',
            wood_5mm_cutting: 'Ξύλο - 5mm Κοπή',
            wood_7mm_cutting: 'Ξύλο - 7mm Κοπή',
            wood_8mm_cutting: 'Ξύλο - 8mm Κοπή',
            wood_10mm_cutting: 'Ξύλο - 10mm Κοπή',
            wood_engraving: 'Ξύλο - Χάραξη',
            wood_printing: 'Ξύλο - Εκτύπωση',
          },
          parameters: 'Προεπιλογές',
          save: 'Προσθήκη τρέχοντος παραμέτρων',
        },
        engrave: 'Χαράξτε',
        existing_name: 'Αυτό το όνομα έχει ήδη χρησιμοποιηθεί.',
        fill_angle: 'Γωνία Γεμίσματος',
        fill_interval: 'Διάστημα Γεμίσματος',
        fill_setting: 'Ρυθμίσεις Γέμισης',
        filled_path_only: 'Μόνο για διαδρομές πλήρωσης',
        focus_adjustment: 'Ρύθμιση εστίασης',
        frequency: 'Συχνότητα',
        gradient_only: 'Μόνο για εικόνες με διαβάθμιση',
        halftone: 'Μισοτόνος',
        halftone_link: 'https://support.flux3dp.com/hc/en-us/articles/9402670389647',
        height: 'Ύψος αντικειμένου',
        high_quality: 'Υψηλή ποιότητα',
        high_quality_desc: 'Ισχύει μόνο για γεμάτες διανυσματικές χαράξεις και αντικείμενα εικόνας. Η ενεργοποίηση θα μειώσει την επιτάχυνση χάραξης για πιο λεπτά αποτελέσματα.',
        ink_saturation: 'Κορεσμός',
        low_air_assist_warning: 'Συνιστάται να ρυθμίσετε την υποβοήθηση αέρα πάνω από 50% για να μειώσετε αποτελεσματικά τον κίνδυνο ανάφλεξης του υλικού.',
        low_power_warning: 'Χαμηλή ισχύς λέιζερ (κάτω από 10%) ενδέχεται να μην εκπέμπει το φως λέιζερ.',
        low_speed_warning: 'Η χαμηλή ταχύτητα μπορεί να προκαλέσει κάψιμο του υλικού.',
        lower_focus: 'Χαμηλώστε την Εστίαση',
        lower_focus_desc: 'Χαμήλωμα του ύψους εστίασης κατά συγκεκριμένη απόσταση μετά την εστίαση για βελτίωση της απόδοσης κοπής.',
        module: 'Μονάδα',
        more: 'Διαχείριση',
        multi_layer: 'Πολλαπλά στρώματα',
        para_in_use: 'Αυτή η παράμετρος χρησιμοποιείται.',
        parameters: 'Παράμετροι',
        preset_management: {
          add_new: 'Προσθήκη Νέου',
          delete: 'Διαγραφή',
          export: 'Εξαγωγή',
          export_preset_title: 'Εξαγωγή Προεπιλογών',
          import: 'Εισαγωγή',
          laser: 'Λέιζερ',
          lower_focus_by: 'Μείωση Εστίασης κατά',
          new_preset_name: 'Νέο Όνομα Προεπιλογής',
          preset: 'Προκαθορισμένο',
          print: 'Εκτύπωση',
          reset: 'Επαναφορά',
          save_and_exit: 'Αποθήκευση και Έξοδος',
          show_all: 'Εμφάνιση Όλων',
          sure_to_import_presets: 'Αυτό θα φορτώσει τη διάταξη των προεπιλογών και θα αντικαταστήσει τις εξατομικευμένες παραμέτρους. Είστε βέβαιοι ότι θέλετε να συνεχίσετε;',
          sure_to_reset: 'Αυτό θα διαγράψει τις εξατομικευμένες παραμέτρους σας και θα επαναφέρει όλες τις προεπιλογές. Είστε βέβαιοι ότι θέλετε να συνεχίσετε;',
          title: 'Διαχείριση Παραμέτρων',
          wobble_diameter: 'Διάμετρος ταλάντωσης',
          wobble_step: 'Μέγεθος βήματος ταλάντωσης',
        },
        preset_setting: 'Προκαθορισμένες ρυθμίσεις (%s)',
        presets: 'Προεπιλογή',
        print_multipass: 'Πολλαπλή διέλευση',
        promark_speed_desc: 'Οι παράμετροι ταχύτητας δεν ισχύουν για εικόνες διαβάθμισης.',
        pulse_width: 'Πλάτος Παλμού',
        pwm_advanced_desc: 'Ρυθμίστε μια ελάχιστη ισχύ για τη λειτουργία βάθους.',
        pwm_advanced_hint: 'Αυτή η ρύθμιση εφαρμόζεται συγκεκριμένα σε εικόνες κλίσης όταν χρησιμοποιείτε τη λειτουργία βάθους.',
        pwm_advanced_setting: 'Ρυθμίσεις Ισχύος Λειτουργίας Βάθους',
        refresh_interval: 'Διάστημα ανανέωσης',
        refresh_printer: 'Ανανέωση κεφαλής εκτύπωσης',
        repeat: 'Αριθμός Περασμάτων',
        single_color: 'Μονόχρωμο',
        single_color_desc: 'Ισχύει μόνο για πλήρως έγχρωμο στρώμα και δεν μπορεί να χρησιμοποιηθεί με επεκταμένο μονοχρωματικό στρώμα.',
        slider: {
          fast: 'Γρήγορα',
          high: 'Υψηλό',
          low: 'Χαμηλό',
          regular: 'Κανονικό',
          slow: 'Αργά',
          very_fast: 'Πολύ γρήγορα',
          very_high: 'Μέγιστο',
          very_low: 'Ελάχιστο',
          very_slow: 'Πολύ αργά',
        },
        speed: 'Ταχύτητα',
        speed_constrain_warning: 'Η ταχύτητα κοπής των διανυσμάτων θα περιοριστεί στα %(limit)s. Μπορείτε να καταργήσετε αυτό το όριο από τις Ρυθμίσεις.',
        speed_constrain_warning_auto_feeder: 'Η ταχύτητα κοπής των αντικειμένων Αυτόματης Τροφοδότησης θα περιοριστεί στο %(limit)s. Μπορείτε να καταργήσετε αυτόν τον περιορισμό στις Ρυθμίσεις Προτιμήσεων.',
        speed_constrain_warning_curve_engraving: 'Η ταχύτητα χάραξης καμπυλών θα περιοριστεί σε %(limit)s. Μπορείτε να καταργήσετε αυτό το όριο στις ρυθμίσεις προτιμήσεων.',
        speed_constrain_warning_module_addon: 'Κατά τη χρήση πρόσθετης μονάδας, αποφύγετε ταχύτητες άνω των %(limit)s για να διατηρήσετε την ποιότητα χάραξης.',
        stepwise_focusing: 'Βηματική Εστίαση',
        stepwise_focusing_desc: 'Σταδιακό χαμήλωμα της απόστασης εστίασης βάσει του ύψους του αντικειμένου κατά κάθε αριθμό περάσματος.',
        strength: 'Ισχύς',
        times: 'φορές',
        various_preset: 'Διάφορες Προεπιλογές',
        white_ink: 'Λευκή μελάνη',
        white_ink_settings: 'Ρυθμίσεις λευκής μελάνης',
        wobble: 'Κυματισμός',
        wobble_desc: 'Δημιουργεί μικρούς κύκλους κατά μήκος της διαδρομής, κάτι που είναι επωφελές για τις εργασίες κοπής. (Μόνο για αντικείμενα διαδρομής.)',
        wobble_diameter: 'Διάμετρος',
        wobble_step: 'Μέγεθος βήματος',
        z_step: 'Βήμα Z',
      },
      layer_panel: {
        current_layer: 'Τρέχον Στρώμα',
        layer1: 'Στρώμα 1',
        layer_bitmap: 'Χάρτης bit',
        layer_cutting: 'Κοπή',
        layer_engraving: 'Χάραξη',
        layers: {
          del: 'Διαγραφή Στρώματος',
          dupe: 'Διπλασιασμός Στρώματος',
          fullColor: 'Πλήρες χρώμα',
          layer: 'Στρώμα',
          layers: 'Στρώματα',
          lock: 'Κλείδωμα Στρώματος',
          merge_all: 'Συγχώνευση Όλων των Στρωμάτων',
          merge_down: 'Συγχώνευση με Κάτω Στρώμα',
          merge_selected: 'Συγχώνευση Επιλεγμένων Στρωμάτων',
          move_down: 'Μετακίνηση Στρώματος Κάτω',
          move_selected: 'Μετακινήστε τα επιλεγμένα στοιχεία σε διαφορετικό επίπεδο',
          move_up: 'Μετακίνηση Στρώματος Πάνω',
          new: 'Νέο Στρώμα',
          rename: 'Μετονομασία Στρώματος',
          splitFullColor: 'Διαίρεση επιπέδου πλήρους χρώματος',
          switchToFullColor: 'Μετάβαση σε επίπεδο πλήρους χρώματος',
          switchToSingleColor: 'Μετάβαση σε επίπεδο μονού χρώματος',
          unlock: 'Ξεκλείδωμα',
        },
        move_elems_to: 'Μετακίνηση στοιχείων σε:',
        notification: {
          dupeLayerName: 'Υπάρχει ήδη ένα στρώμα με αυτό το όνομα!',
          enterNewLayerName: 'Παρακαλώ εισάγετε το νέο όνομα στρώματος',
          enterUniqueLayerName: 'Παρακαλώ εισάγετε ένα μοναδικό όνομα στρώματος',
          layerHasThatName: 'Το στρώμα έχει ήδη αυτό το όνομα',
          mergeLaserLayerToPrintingLayerMsg: 'Λάβετε υπόψη ότι αν ολοκληρώσετε αυτήν τη λειτουργία, οι ρυθμίσεις του στρώματος λέιζερ θα αφαιρεθούν και θα οριστούν σύμφωνα με το τρέχον στρώμα.',
          mergeLaserLayerToPrintingLayerTitle: 'Θέλετε να συγχωνεύσετε αυτά τα στρώματα σε ένα στρώμα εκτύπωσης;',
          mergePrintingLayerToLaserLayerMsg: 'Λάβετε υπόψη ότι αν ολοκληρώσετε αυτήν τη λειτουργία, οι ρυθμίσεις χρώματος του στρώματος εκτύπωσης θα αφαιρεθούν και θα οριστούν σύμφωνα με το τρέχον στρώμα.',
          mergePrintingLayerToLaserLayerTitle: 'Θέλετε να συγχωνεύσετε αυτά τα στρώματα σε ένα στρώμα λέιζερ;',
          moveElemFromPrintingLayerMsg: 'Λάβετε υπόψη ότι αν ολοκληρώσετε αυτήν τη λειτουργία, οι ρυθμίσεις χρώματος του επιλεγμένου στοιχείου θα αφαιρεθούν και θα οριστούν σύμφωνα με το %s.',
          moveElemFromPrintingLayerTitle: 'Μετακινήστε το επιλεγμένο στοιχείο στο %s και μετατρέψτε το σε στοιχείο λέιζερ;',
          moveElemToPrintingLayerMsg: 'Λάβετε υπόψη ότι αν ολοκληρώσετε αυτήν τη λειτουργία, οι ρυθμίσεις του επιλεγμένου στοιχείου θα αφαιρεθούν και θα οριστούν σύμφωνα με το %s.',
          moveElemToPrintingLayerTitle: 'Μετακινήστε το επιλεγμένο στοιχείο στο %s και μετατρέψτε το σε στοιχείο εκτύπωσης;',
          newName: 'ΝΕΟ ΟΝΟΜΑ',
          QmoveElemsToLayer: "Μετακινήστε τα επιλεγμένα στοιχεία στο στρώμα '%s';",
          splitColorMsg: 'Λάβετε υπόψη ότι αν συνεχίσετε με αυτήν τη λειτουργία, δεν θα μπορείτε να επιστρέψετε στα αρχικά στρώματα χρωμάτων.',
          splitColorTitle: 'Θέλετε να επεκτείνετε το επιλεγμένο στρώμα σε στρώματα CMYK;',
        },
      },
      object_panel: {
        actions_panel: {
          ai_bg_removal: 'Αφαίρεση φόντου',
          ai_bg_removal_reminder: 'Πατώντας το κουμπί θα χρησιμοποιηθούν αμέσως 0,02 πιστώσεις, θέλετε να συνεχίσετε;',
          ai_bg_removal_short: 'Αφαίρεση φόντου',
          array: 'Πίνακας',
          auto_fit: 'Αυτόματη Προσαρμογή',
          bevel: 'Λοξοτομία',
          brightness: 'Φωτεινότητα',
          create_textpath: 'Δημιουργία κειμένου σε μονοπάτι',
          create_textpath_short: 'Μονοπάτι κειμένου',
          crop: 'Περικοπή',
          decompose_path: 'Αποσύνθεση',
          detach_path: 'Αποσύνθεση κειμένου από μονοπάτι',
          detach_path_short: 'Αποσυνθέτηση',
          disabled_by_gradient: 'Απενεργοποιήστε την διαβάθμιση πριν χρησιμοποιήσετε αυτήν τη λειτουργία.',
          disabled_by_infilled: 'Κλείστε τη συμπλήρωση πριν χρησιμοποιήσετε αυτήν τη λειτουργία.',
          disabled_by_infilled_and_variable_text: 'Κλείστε τη συμπλήρωση και το μεταβλητό κείμενο πριν χρησιμοποιήσετε αυτήν τη λειτουργία.',
          disabled_by_variable_text: 'Κλείστε το μεταβλητό κείμενο πριν χρησιμοποιήσετε αυτήν τη λειτουργία.',
          disassemble_use: 'Αποσυναρμολόγηση',
          disassembling: 'Αποσυναρμολόγηση...',
          edit_path: 'Επεξεργασία μονοπατιού',
          fetching_web_font: 'Λήψη διαδικτυακής γραμματοσειράς...',
          grading: 'Βαθμονόμηση',
          invert: 'Αντιστροφή',
          offset: 'Μετατόπιση',
          outline: 'Περίγραμμα',
          replace_with: 'Αντικατάσταση με...',
          replace_with_short: 'Αντικατάσταση',
          sharpen: 'Εστίαση',
          simplify: 'Απλοποίηση',
          smart_nest: 'Έξυπνη Τοποθέτηση',
          to_image: 'Σε Εικόνα',
          to_path: 'Σε Διαδρομή',
          trace: 'Ιχνηλάτηση',
          ungrouping: 'Κατάργηση ομαδοποίησης...',
          uploading_font_to_machine: 'Μεταφόρτωση γραμματοσειράς στο μηχάνημα...',
          wait_for_parsing_font: 'Επεξεργασία γραμματοσειράς... Παρακαλώ περιμένετε',
          weld_text: 'Συγχώνευση κειμένου',
        },
        align: 'Ευθυγράμμιση',
        boolean: 'Λογική πράξη',
        bottom_align: 'Ευθυγράμμιση κάτω',
        center_align: 'Ευθυγράμμιση κέντρου',
        difference: 'Διαφορά',
        distribute: 'Διανομή',
        flip: 'Αναστροφή',
        group: 'Ομάδα',
        hdist: 'Οριζόντια διανομή',
        hflip: 'Οριζόντια αναστροφή',
        intersect: 'Τομή',
        left_align: 'Ευθυγράμμιση αριστερά',
        lock_aspect: 'Κλείδωμα αναλογίας',
        middle_align: 'Ευθυγράμμιση μέσης',
        option_panel: {
          color: 'Χρώμα',
          current_time: 'Τρέχουσα ώρα',
          depth_engraving: 'Ανάγλυφο',
          fill: 'Εσωτερική πλήρωση',
          font_family: 'Γραμματοσειρά',
          font_size: 'Μέγεθος',
          font_style: 'Στυλ',
          layer_count: 'Αριθμός επιπέδων',
          letter_spacing: 'Διάστημα γραμμάτων',
          line_spacing: 'Διάστημα γραμμών',
          number: 'Αριθμός ακολουθίας',
          offset: 'Μετατόπιση',
          path_infill: 'Πλήρωση διαδρομής',
          pwm_engraving: 'Λειτουργία Βάθους',
          pwm_engraving_link: 'https://support.flux3dp.com/hc/en-us/articles/10419884701327',
          recently_used: 'Χρησιμοποιήθηκε πρόσφατα',
          rounded_corner: 'Στρογγυλεμένη γωνία',
          shading: 'Διαβάθμιση',
          sides: 'Πλευρές',
          start_offset: 'Μετατόπιση κειμένου',
          stroke: 'Περίγραμμα',
          stroke_color: 'Χρώμα περιγράμματος',
          stroke_width: 'Πλάτος γραμμής',
          text_align_center: 'Κέντρο',
          text_align_justify: 'Πλήρης στοίχιση',
          text_align_left: 'Αριστερά',
          text_align_right: 'Δεξιά',
          text_content_placeholder: 'Εισαγωγή κειμένου',
          text_infill: 'Πλήρωση κειμένου',
          threshold: 'Φωτεινότητα ορίου',
          threshold_short: 'Κατώφλι',
          variable_text: 'Μεταβλητό κείμενο',
          variable_text_link: 'https://support.flux3dp.com/hc/en-us/articles/12689396604175',
          vertical_align: 'Στοίχιση',
          vertical_text: 'Κάθετο κείμενο',
        },
        path_edit_panel: {
          connect: 'Συνδέστε',
          delete: 'Διαγράψτε',
          disconnect: 'Αποσυνδέστε',
          node_type: 'ΤΥΠΟΣ ΚΟΜΒΟΥ',
          round: 'Στρογγυλό',
          sharp: 'Αιχμηρό',
        },
        right_align: 'Ευθυγράμμιση δεξιά',
        subtract: 'Αφαίρεση',
        top_align: 'Ευθυγράμμιση επάνω',
        ungroup: 'Κατάργηση ομαδοποίησης',
        union: 'Ένωση',
        unlock_aspect: 'Ξεκλείδωμα αναλογίας',
        vdist: 'Κάθετη κατανομή',
        vflip: 'Κάθετη αναστροφή',
        zoom: 'Μεγέθυνση',
      },
      uv_print_block: {
        title: 'UV Εκτύπωση',
      },
    },
    svg_editor: {
      unable_to_fetch_clipboard_img: 'Αποτυχία λήψης εικόνας από το πρόχειρο',
      unnsupported_file_type: 'Ο τύπος αρχείου δεν υποστηρίζεται. Μετατρέψτε το αρχείο σε SVG ή bitmap',
    },
    tag: {
      g: 'Ομάδα',
      image: 'Εικόνα',
      text: 'Κείμενο',
      use: 'Εισαγωγή SVG',
    },
    tool_panels: {
      _nest: {
        end: 'Κλείσιμο',
        no_element: 'Δεν υπάρχουν στοιχεία για τοποθέτηση.',
        rotations: 'Πιθανή Περιστροφή',
        spacing: 'Απόσταση',
        start_nest: 'Τοποθέτηση',
        stop_nest: 'Σταμάτημα',
      },
      _offset: {
        corner_type: 'Γωνία',
        direction: 'Κατεύθυνση μετατόπισης',
        dist: 'Απόσταση μετατόπισης',
        expand: 'Επέκταση',
        fail_message: 'Αποτυχία μετατόπισης αντικειμένων.',
        inward: 'Προς τα μέσα',
        not_support_message: 'Τα επιλεγμένα στοιχεία περιέχουν μη υποστηριζόμενες ετικέτες SVG:\nΕικόνα, Ομάδα, Κείμενο και Εισαγόμενο Αντικείμενο.',
        outward: 'Προς τα έξω',
        round: 'Στρογγυλή',
        sharp: 'Αιχμηρή',
        shrink: 'Συρρίκνωση',
      },
      array_dimension: 'Διάσταση Πίνακα',
      array_interval: 'Διάστημα Πίνακα',
      cancel: 'Ακύρωση',
      columns: 'Στήλες',
      confirm: 'Επιβεβαίωση',
      dx: 'X',
      dy: 'Y',
      grid_array: 'Δημιουργία Πλέγματος Πίνακα',
      nest: 'Βελτιστοποίηση διάταξης',
      offset: 'Μετατόπιση',
      rows: 'Γραμμές',
    },
    units: {
      mm: 'χιλιοστόμετρα',
      walt: 'W',
    },
    zoom_block: {
      fit_to_window: 'Προσαρμογή στο παράθυρο',
    },
  },
  boxgen: {
    add_option: 'Προσθήκη επιλογής',
    basic_box: 'Βασικό Κουτί',
    beam_radius: 'Αντιστάθμιση ακτίνας κοπής',
    beam_radius_warning: 'Αφαιρέστε την αντιστάθμιση Kerf όταν οι άκρες ή οι αρμοί του κουτιού είναι σύντομοι για να διασφαλίσετε τη συναρμολόγηση του κουτιού',
    cancel: 'Ακύρωση',
    coming_soon: 'Έρχεται Σύντομα',
    continue_import: 'Συνεχίστε την εισαγωγή',
    control_tooltip: 'Αριστερό κλικ για περιστροφή\nΤροχός ποντικιού για μεγέθυνση\nΔεξί κλικ για μετακίνηση',
    control_tooltip_touch: 'Σύρετε για περιστροφή\nΤσίμπημα για μεγέθυνση\nΔύο δάχτυλα για μετακίνηση',
    cover: 'Κάλυμμα',
    customize: 'Προσαρμογή',
    depth: 'Βάθος',
    edge: 'Άκρη',
    finger: 'Δάχτυλο',
    finger_warning: 'Το εσωτερικό μήκος πλευράς του κουτιού πρέπει να είναι τουλάχιστον 6 χιλιοστά 6mm (0.24 inches) για να είναι συμβατό με τη σύνδεση δακτύλου.',
    import: 'Εισαγωγή',
    inner: 'Εσωτερικό',
    joints: 'Αρμός',
    max_dimension_tooltip: 'Το μέγιστο πλάτος είναι %s, η μέγιστη ρύθμιση ύψους/βάθους είναι %s.',
    merge: 'Συγχώνευση',
    outer: 'Εξωτερικό',
    reset: 'Επαναφορά',
    tCount: 'Μέτρηση T',
    tCount_tooltip: 'Ο αριθμός υποδοχών T ισχύει για τη μικρή πλευρά. Η ποσότητα στη μεγάλη πλευρά υπολογίζεται με βάση το μήκος της.',
    tDiameter: 'Διάμετρος T',
    text_label: 'Ετικέτα',
    thickness: 'Πάχος',
    title: 'BOXGEN',
    tLength: 'Μήκος T',
    tSlot: 'T-Υποδοχή',
    tSlot_warning: 'Το μήκος πλευράς του κουτιού πρέπει να είναι τουλάχιστον 30mm (1.18 inches) για να είναι συμβατό με τη σύνδεση T-Υποδοχή.',
    volume: 'Όγκος',
    workarea: 'Περιοχή εργασίας',
    zoom: 'Μεγέθυνση',
  },
  buttons: {
    back: 'Πίσω',
    back_to_beam_studio: 'Επιστροφή στο Beam Studio',
    done: 'Τέλος',
    next: 'Επόμενο',
  },
  calibration: {
    ador_autofocus_focusing_block: 'Πατήστε το εικονίδιο "AF" στην κύρια σελίδα της μηχανής για 3 δευτερόλεπτα και αφήστε τον αισθητήρα να αγγίξει το μπλοκ εστίασης.',
    ador_autofocus_material: 'Πατήστε το εικονίδιο "AF" στην κύρια σελίδα της μηχανής για 3 δευτερόλεπτα και αφήστε τον αισθητήρα να αγγίξει απαλά το υλικό.',
    align_4_0: 'Επάνω αριστερά',
    align_4_1: 'Επάνω δεξιά',
    align_4_2: 'Κάτω αριστερά',
    align_4_3: 'Κάτω δεξιά',
    align_8_0: 'Εξωτερικό επάνω αριστερά',
    align_8_1: 'Εξωτερικό επάνω δεξιά',
    align_8_2: 'Εξωτερικό κάτω αριστερά',
    align_8_3: 'Εξωτερικό κάτω δεξιά',
    align_8_4: 'Εσωτερικό επάνω αριστερά',
    align_8_5: 'Εσωτερικό επάνω δεξιά',
    align_8_6: 'Εσωτερικό κάτω αριστερά',
    align_8_7: 'Εσωτερικό κάτω δεξιά',
    align_bottom_left: 'Κάτω αριστερά',
    align_bottom_right: 'Κάτω δεξιά',
    align_red_cross_cut: 'Παρακαλώ ευθυγραμμίστε τη μέση του κόκκινου σταυρού με τον σταυρό κοπής.',
    align_red_cross_print: 'Παρακαλώ ευθυγραμμίστε τη μέση του κόκκινου σταυρού με τον τυπωμένο σταυρό.',
    align_top_left: 'Επάνω αριστερά',
    align_top_right: 'Επάνω δεξιά',
    analyze_result_fail: 'Αποτυχία ανάλυσης της καταγεγραμμένης εικόνας. <br/> Παρακαλώ βεβαιωθείτε: <br/> 1. Η καταγεγραμμένη εικόνα καλύπτεται πλήρως με λευκό χαρτί. <br/> 2. Η πλατφόρμα εστιάζεται σωστά.',
    ask_for_skip_engraving_task: 'Θέλετε να παραλείψετε το βήμα χάραξης και στη συνέχεια να τραβήξετε φωτογραφία και να βαθμονομήσετε απευθείας;',
    ask_for_skip_printing_task: 'Θέλετε να παραλείψετε το βήμα εκτύπωσης και στη συνέχεια να τραβήξετε φωτογραφία και να βαθμονομήσετε απευθείας;',
    at_focus_height: 'στο ύψος εστίασης',
    at_lower_height: 'σε χαμηλότερο ύψος',
    back: 'Πiσω',
    beamo2_autofocus_material: 'Μετακινήστε χειροκίνητα την κεφαλή λέιζερ πάνω από το υλικό και κατεβάστε την ανιχνευτή εστίασης για να ενεργοποιήσετε την αυτόματη εστίαση.',
    calculating_camera_matrix: 'Υπολογισμός Μήτρας Κάμερας...',
    calculating_regression_parameters: 'Υπολογισμός παραμέτρων παλινδρόμησης...',
    calibrate_camera_before_calibrate_modules: 'Παρακαλώ εκτελέστε βαθμονόμηση κάμερας πριν βαθμονομήσετε τις μονάδες.',
    calibrate_done: 'Η βαθμονόμηση ολοκληρώθηκε. Καλύτερη ακρίβεια κάμερας επιτυγχάνεται όταν γίνεται σωστή εστίαση.',
    calibrate_done_diode: 'Η βαθμονόμηση ολοκληρώθηκε. Η αντιστάθμιση της διοδικής μονάδας λέιζερ έχει αποθηκευτεί.',
    calibrate_success_msg: 'Η βαθμονόμηση ήταν επιτυχής.<br/>Η βαθμολογία βαθμονόμησης είναι %s (%.2f).',
    calibrating: 'Καλιμπράρισμα...',
    calibrating_with_device_pictures: 'Βαθμονόμηση με τις εικόνες της συσκευής...',
    camera_calibration: 'Βαθμονόμηση κάμερας',
    camera_parameter_saved_successfully: 'Οι παράμετροι της κάμερας αποθηκεύτηκαν επιτυχώς.',
    cancel: 'Ακύρωση',
    charuco_auto_focus: 'Μετακινήστε την κεφαλή λέιζερ πάνω από το μοτίβο και πατήστε <b>AF</b> για αυτόματη εστίαση.',
    charuco_capture: 'Κάντε κλικ στο "Επόμενο" για να καταγράψετε το μοτίβο',
    charuco_move_to_point_a: 'Μετακινήστε την κεφαλή λέιζερ για να ευθυγραμμίσετε το κόκκινο φως με το κέντρο του <b>σημείου A</b>.',
    charuco_move_to_point_b: 'Μετακινήστε την κεφαλή λέιζερ οριζόντια για να ευθυγραμμίσετε το κόκκινο φως με το κέντρο του <b>σημείου B</b>.',
    charuco_place_charuco_horizontal: 'Τοποθετήστε το μοτίβο βαθμονόμησης οριζόντια στο <b>%s</b> της περιοχής εργασίας.',
    charuco_place_charuco_vertical: 'Τοποθετήστε το μοτίβο βαθμονόμησης κάθετα στο <b>%s</b> της περιοχής εργασίας.',
    charuco_position_bottom_left: 'Κάτω Αριστερά',
    charuco_position_bottom_right: 'Κάτω Δεξιά',
    charuco_position_center: 'Κέντρο',
    charuco_position_left: 'Αριστερά',
    charuco_position_right: 'Δεξιά',
    charuco_position_top_left: 'Επάνω Αριστερά',
    charuco_position_top_right: 'Επάνω Δεξιά',
    check_checkpoint_data: 'Δεδομένα σημείου ελέγχου',
    check_device_pictures: 'Έλεγχος Εικόνων Συσκευής',
    check_pnp_desc: 'Βεβαιωθείτε ότι οι κόκκινοι δείκτες ευθυγραμμίζονται με τα σημεία χάραξης\nΑν όχι, κάντε κλικ στο "Πίσω" για προσαρμογή.\nΑν όλα είναι εντάξει, μπράβο! 🎉',
    checking_checkpoint: 'Ελέγχος δεδομένων σημείου ελέγχου...',
    checking_pictures: 'Γίνεται έλεγχος των εικόνων της συσκευής...',
    click_next: 'Κάντε κλικ στο "Επόμενο"',
    click_next_to_take_picture: 'Κάντε κλικ στο "Επόμενο" για να τραβήξετε μια φωτογραφία.',
    diode_calibration: 'Βαθμονόμηση διόδου λέιζερ',
    do_engraving: 'Κάντε χάραξη',
    download_and_print_calibration_pattern: 'Κατεβάστε το αρχείο προτύπου βαθμονόμησης παρακάτω και εκτυπώστε το σε χαρτί μεγέθους A4 (ή Letter).',
    download_calibration_pattern: 'Λήψη Μοτίβου Βαθμονόμησης',
    download_chessboard_file: 'Λήψη αρχείου σκακιέρας',
    downloading_checkpoint: 'Λήψη δεδομένων σημείου ελέγχου...',
    downloading_pictures: 'Λήψη Εικόνων...',
    drawing_calibration_image: 'Σχεδιάζοντας εικόνα βαθμονόμησης...',
    dx: 'Χ',
    dy: 'Υ',
    elevate_and_cut: 'Ανύψωση και Κοπή',
    elevate_and_cut_step_1: 'Τοποθετήστε ένα ξύλο μεγέθους A4 ανοιχτού χρώματος στο κέντρο της περιοχής εργασίας, υψωμένο στα 20mm.',
    elevate_and_cut_step_1_prism_lift: 'Χρησιμοποιήστε το Ador Prism Lift με μέγιστο μήκος 14mm μαζί με ένα ξύλο τουλάχιστον 6mm πάχους.',
    failed_to_calibrate_camera: '#848 Αποτυχία βαθμονόμησης κάμερας, παρακαλώ επικοινωνήστε με την υποστήριξη FLUX.',
    failed_to_calibrate_chessboard: 'Η βαθμονόμηση με την εικόνα της σκακιέρας απέτυχε.',
    failed_to_calibrate_with_pictures: '#848 Απέτυχε η βαθμονόμηση με τις εικόνες της συσκευής.',
    failed_to_detect_calibration_pattern: 'Αποτυχία εντοπισμού του προτύπου βαθμονόμησης. Ρυθμίστε την έκθεση της κάμερας ή επανατοποθετήστε το πρότυπο και δοκιμάστε ξανά.',
    failed_to_download_pictures: '#848 Αποτυχία λήψης εικόνων, επικοινωνήστε με την υποστήριξη FLUX.',
    failed_to_move_laser_head: 'Αποτυχία μετακίνησης της κεφαλής λέιζερ.',
    failed_to_parse_checkpoint: 'Απέτυχε η ανάλυση των δεδομένων σημείου ελέγχου.',
    failed_to_save_calibration_results: '#849 Αποτυχία αποθήκευσης αποτελεσμάτων βαθμονόμησης, παρακαλώ δοκιμάστε ξανά. Αν αυτό συνεχίζει να συμβαίνει, παρακαλώ επικοινωνήστε με την υποστήριξη FLUX.',
    failed_to_save_camera_parameter: 'Αποτυχία αποθήκευσης των παραμέτρων της κάμερας.',
    failed_to_solve_pnp: 'Δεν ήταν δυνατή η επίλυση της θέσης της κάμερας.',
    finish: 'Τέλος',
    found_checkpoint: 'Δεδομένα σημείου ελέγχου βρέθηκαν στη συσκευή σας. Θέλετε να ανακτήσετε από το σημείο ελέγχου;',
    getting_plane_height: 'Λήψη Ύψους Επιπέδου...',
    hint_adjust_parameters: 'Χρησιμοποιήστε αυτές τις παραμέτρους για να προσαρμόσετε το κόκκινο τετράγωνο',
    hint_red_square: 'Ευθυγραμμίστε την εξωτερική πλευρά του κόκκινου τετραγώνου με το τετράγωνο κοπής.',
    material_4_a4_paper: 'Τέσσερα φύλλα λευκού χαρτιού μεγέθους A4 (ή Letter).',
    material_a4_calibration_pattern: 'Μοτίβο βαθμονόμησης μεγέθους A4 (ή Letter).',
    materials_required: 'Απαιτούμενα υλικά:',
    module_calibration_2w_ir: 'Βαθμονόμηση υπέρυθρης μονάδας',
    module_calibration_printer: 'Βαθμονόμηση μονάδας εκτυπωτή',
    module_offset_settings: 'Ρυθμίσεις μετατόπισης',
    module_offset_settings_desc: 'Παρακαλώ προσαρμόστε τις τιμές μετατόπισης X και Y για να ευθυγραμμίσετε την πραγματική θέση %s με την έξοδο λέιζερ CO2.',
    module_offset_settings_save_failed: 'Αποτυχία αποθήκευσης ρυθμίσεων μετατόπισης.',
    moving_laser_head: 'Μετακίνηση της κεφαλής λέιζερ...',
    moving_platform: 'Plattform wird bewegt...',
    next: 'Επόμενο',
    no_picture_found: '#852 Η συσκευή σας δεν έχει διαθέσιμες ακατέργαστες φωτογραφίες για βαθμονόμηση. Παρακαλώ εκτελέστε "Ρύθμιση κάμερας (Προχωρημένο)".',
    perform_autofocus_bb2: 'Παρακαλώ πηγαίνετε στον πίνακα ελέγχου της μηχανής και πατήστε AF για να εκτελέσετε την αυτόματη εστίαση.',
    perform_autofocus_bm2: 'Μετακινήστε χειροκίνητα την κεφαλή λέιζερ πάνω από το υλικό και χαμηλώστε τον ανιχνευτή εστίασης για να ενεργοποιήσετε την αυτόματη εστίαση.',
    please_do_camera_calibration_and_focus: {
      beambox: 'Κατά τη βαθμονόμηση της διοδικής μονάδας λέιζερ, χρειάζεται κάμερα.\nΒεβαιωθείτε ότι η κάμερα αυτού του μηχανήματος έχει βαθμονομηθεί.\nΚαι ευγενικά προσαρμόστε την πλατφόρμα στο εστιακό σημείο (το ύψος του ανεστραμμένου ακρυλικού)',
      beamo: 'Κατά τη βαθμονόμηση της διοδικής μονάδας λέιζερ, χρειάζεται κάμερα.\nΒεβαιωθείτε ότι η κάμερα αυτού του μηχανήματος έχει βαθμονομηθεί.\nΚαι ευγενικά προσαρμόστε την κεφαλή λέιζερ για να εστιάσετε στο αντικείμενο χάραξης (το ύψος του ανεστραμμένου ακρυλικού)',
    },
    please_goto_editor_first: 'Ολοκληρώστε τη ρύθμιση πριν συνεχίσετε',
    please_place_dark_colored_paper: 'Παρακαλώ τοποθετήστε ένα σκουρόχρωμο χαρτί μεγέθους Α4 ή Letter στο κέντρο της περιοχής εργασίας.',
    please_place_paper: 'Παρακαλώ τοποθετήστε ένα λευκό χαρτί μεγέθους Α4 ή Letter στην αριστερή επάνω γωνία της περιοχής εργασίας.',
    please_place_paper_center: 'Παρακαλώ τοποθετήστε ένα λευκό χαρτί μεγέθους Α4 ή Letter στο κέντρο της περιοχής εργασίας.',
    please_refocus: {
      beambox: 'Παρακαλώ ρυθμίστε την πλατφόρμα στο εστιακό σημείο (το ύψος του ανεστραμμένου ακρυλικού)',
      beamo: 'Παρακαλώ ρυθμίστε το λέιζερ κεφαλής για να εστιάσει στο αντικείμενο χάραξης (το ύψος του ανεστραμμένου ακρυλικού)',
      beamo_af: 'Παρακαλώ κάντε διπλό πάτημα στο πλάι κουμπί της προσθήκης αυτόματης εστίασης και αφήστε τον αισθητήρα να αγγίξει απαλά το υλικό.',
      hexa: 'Κάντε διπλό κλικ στο κουμπί ρύθμισης ύψους για να ανεβάσετε το τραπέζι μελισσών πάνω και να κάνετε τον αισθητήρα να αγγίξει το υλικό χάραξης.',
    },
    preparing_to_take_picture: 'Προετοιμασία για λήψη φωτογραφίας...',
    promark_help_link: 'https://support.flux3dp.com/hc/en-us/articles/11173605809295',
    put_charuco: 'Τοποθέτηση Μοτίβου Βαθμονόμησης',
    put_charuco_1: 'Εκτυπώστε το μοτίβο βαθμονόμησης (A4/Letter).',
    put_charuco_2: 'Κολλήστε την επίπεδα σε μια σκληρή επιφάνεια.',
    put_charuco_3: 'Τοποθετήστε στο κέντρο και εκτελέστε αυτόματη εστίαση.',
    put_charuco_bm2_1: 'Εκτυπώστε το αρχείο μοτίβου βαθμονόμησης σε χαρτί A4 (Letter Size) για βαθμονόμηση.',
    put_charuco_bm2_2: 'Κάντε κλικ στο “Επόμενο” και ακολουθήστε τις οδηγίες για να τοποθετήσετε το χαρτί.',
    put_charuco_promark_2: "Βεβαιωθείτε ότι το χαρτί βαθμονόμησης είναι καθαρά ορατό χωρίς αντηλιά. Κάντε κλικ στο 'Επόμενο' για να τραβήξετε φωτογραφία.",
    put_charuco_promark_desc_1: 'Χρησιμοποιήστε το χαρτί βαθμονόμησης από το κουτί αξεσουάρ ή εκτυπώστε το ακόλουθο μοτίβο βαθμονόμησης σε χαρτί A4 για βαθμονόμηση της κάμερας.',
    put_charuco_promark_desc_2: 'Τοποθετήστε το χαρτί βαθμονόμησης επίπεδο και στο κέντρο της πλατφόρμας εργασίας.',
    put_chessboard_promark_1: 'Ρυθμίστε την απόσταση εστίασης στην κατάλληλη εστίαση για τον φακό πεδίου.',
    put_chessboard_promark_2: 'Βεβαιωθείτε ότι το χαρτί σκακιέρας είναι καθαρά ορατό χωρίς αντηλιά. Κάντε κλικ στο "Επόμενο" για να τραβήξετε φωτογραφία.',
    put_chessboard_promark_desc_1: 'Παρακαλώ χρησιμοποιήστε το χαρτί σκακιέρας που παρέχεται στο κουτί αξεσουάρ ή εκτυπώστε το ακόλουθο μοτίβο σκακιέρας σε χαρτί Α4 για την καλιμπράρισμα της κάμερας.',
    put_chessboard_promark_desc_2: 'Τοποθετήστε τη σκακιέρα επίπεδη και κεντραρισμένη στην πλατφόρμα εργασίας.',
    put_paper: 'Τοποθετήστε χαρτί',
    put_paper_bm2_1: 'Τοποθετήστε δύο λευκά χαρτιά A4 επίπεδα και ασφαλίστε τα.',
    put_paper_bm2_2: 'Χαμηλώστε τον αισθητήρα εστίασης για αυτόματη εστίαση στο χαρτί.',
    put_paper_bm2_3: 'Κλείστε το κάλυμμα της πόρτας.',
    put_paper_bm2_4: 'Κάντε κλικ στο "Ξεκινήστε τη χάραξη".',
    put_paper_promark: 'Τοποθετήστε μαύρο χαρτόνι',
    put_paper_promark_1: 'Τοποθετήστε το μαύρο χαρτόνι από το κουτί των εξαρτημάτων στην πλατφόρμα εργασίας.',
    put_paper_promark_2: 'Ρυθμίστε σωστά την εστίαση και μετά κάντε κλικ στο "Ξεκινήστε τη χάραξη" για να συνεχίσετε.',
    put_paper_skip: 'Εάν το σχέδιο βαθμονόμησης δεν προχωρήσει αυτόματα στη λήψη εικόνας, πατήστε "Παράλειψη" για να τραβήξετε εικόνα.',
    put_paper_step1: 'Παρακαλούμε τοποθετήστε ένα λευκό χαρτί μεγέθους A4 ή Λέιζερ στο κέντρο της περιοχής εργασίας.',
    put_paper_step2: 'Ασφαλίστε τις τέσσερις γωνίες του χαρτιού για να διασφαλίσετε ότι είναι επίπεδο.',
    put_paper_step3: 'Κάντε κλικ στο "Ξεκινήστε τη χάραξη".',
    put_paper_wide_angle_1: 'Τοποθετήστε τέσσερα λευκά χαρτιά μεγέθους A4 ή Letter επίπεδα για να καλύψετε ολόκληρη την περιοχή εργασίας.',
    put_paper_wide_angle_2: 'Στερεώστε τα χαρτιά για να διασφαλίσετε ότι είναι επίπεδα.',
    relocate_camera: 'Μετακίνηση κάμερας',
    relocate_camera_desc: 'Εάν η πόρτα ανοίξει ή η κεφαλή λέιζερ μετακινηθεί, μετακινήστε την κάμερα και ευθυγραμμίστε ξανά τα σημεία.',
    res_average: 'Μέτριο',
    res_excellent: 'Εξαιρετικό',
    res_poor: 'Κακό',
    reset_points: 'Επαναφορά σημείων',
    retake: 'Επανάληψη λήψης',
    rotation_angle: 'Περιστροφή',
    show_last_config: 'Εμφάνιση Τελευταίας Ρύθμισης',
    skip: 'Παράλειψη',
    solve_pnp_bm2: 'Επιβεβαιώστε ότι 16 σημάδια είναι χαραγμένα στα χαρτιά. (Εάν όχι, κάντε κλικ στο Πίσω για να χαράξετε ξανά.)',
    solve_pnp_keep_door_closed: 'Κρατήστε την πόρτα κλειστή κατά τη διάρκεια της ακόλουθης διαδικασίας.',
    solve_pnp_move_platform: 'Το μηχάνημα θα μετακινηθεί αυτόματα προς τα κάτω και θα τραβήξει άλλη μια φωτογραφία. Παρακαλώ μην μετακινείτε το χαρτί βαθμονόμησης κατά τη διάρκεια αυτής της διαδικασίας.',
    solve_pnp_open_the_lid: 'Παρακαλώ ανοίξτε το καπάκι για να τραβήξετε τη φωτογραφία.',
    solve_pnp_step1: 'Παρακαλώ ευθυγραμμίστε τα σημεία χάραξης σύμφωνα με τον αριθμό και την αναμενόμενη θέση κάθε κόκκινου δείκτη.',
    solve_pnp_step2: 'Μπορείτε να πατήσετε "Επανάληψη λήψης" για να ευθυγραμμιστείτε ξανά ή να ρυθμίσετε χειροκίνητα τις θέσεις των σημείων σήμανσης.',
    solve_pnp_step3: 'Εάν το σημείο χάραξης είναι εμφανώς εκτός θέσης, σύρετε την προβολή μέχρι να γίνει ορατό και κάντε κλικ στο "Επανάληψη λήψης".',
    solve_pnp_title: 'Ευθυγραμμίστε τα σημεία σήμανσης',
    start_engrave: 'Ξεκινήστε τη χάραξη',
    start_printing: 'Ξεκινήστε την εκτύπωση',
    step: 'Βήμα',
    taking_picture: 'Λήψη Φωτογραφίας...',
    title_align_marker_points: 'Ευθυγράμμιση Σημείων Δείκτη',
    title_capture_calibration_pattern: 'Λήψη Προτύπου Βαθμονόμησης',
    title_confirm_calibration_result: 'Επιβεβαίωση Αποτελέσματος Βαθμονόμησης',
    title_engrave_marker_points: 'Χάραξη Σημείων Δείκτη',
    title_prepare_materials: 'Προετοιμάστε τα υλικά',
    unable_to_load_camera_parameters: "#851 Δεν υπάρχουν διαθέσιμες παράμετροι ρύθμισης της κάμερας στη συσκευή σας. Μεταβείτε στις 'Ρυθμίσεις' > 'Ρύθμιση κάμερας (Προχωρημένο)' για να ολοκληρώσετε τη ρύθμιση και να αποκτήσετε τις παραμέτρους.",
    update_firmware_msg1: 'Το υλικολογισμικό σας δεν υποστηρίζει αυτήν τη λειτουργία. Ενημερώστε το υλικολογισμικό σε v',
    update_firmware_msg2: 'ή νεότερη έκδοση για να συνεχίσετε. (Μενού > Μηχάνημα > [Το μηχάνημά σας] > Ενημέρωση λογισμικού)',
    uploading_images: 'Μεταφόρτωση Εικόνων...',
    use_last_config: 'Χρήση Τελευταίας Βαθμονόμησης',
    use_old_camera_parameter: 'Θέλετε να χρησιμοποιήσετε την τρέχουσα παράμετρο φακού της κάμερας;',
    with_af: 'Με Αυτόματη Εστίαση',
    with_prism_lift: 'Με το Ador Prism Lift',
    with_promark_safe_plus: 'Με το Promark Safe+',
    without_af: 'Χωρίς Αυτόματη Εστίαση',
    without_prism_lift: 'Χωρίς το Ador Prism Lift',
    without_promark_safe_plus: 'Χωρίς το Promark Safe+',
    x_ratio: 'Αναλογία Χ',
    y_ratio: 'Αναλογία Υ',
    zendesk_link: 'https://support.flux3dp.com/hc/en-us/articles/360001811416',
  },
  camera_data_backup: {
    download_success: 'Επιτυχής λήψη δεδομένων κάμερας.',
    downloading_data: 'Λήψη δεδομένων...',
    estimated_time_left: 'Υπολοιπόμενος εκτιμώμενος χρόνος:',
    folder_not_exists: 'Ο επιλεγμένος φάκελος δεν υπάρχει.',
    incorrect_folder: 'Αποτυχία μεταφόρτωσης δεδομένων βαθμονόμησης. Παρακαλώ ελέγξτε εάν ο φάκελος που επιλέξατε είναι σωστός.',
    no_picture_found: 'Δεν βρέθηκε εικόνα στη μηχανή.',
    title: 'Αντίγραφο ασφαλείας δεδομένων κάμερας',
    upload_success: 'Επιτυχής αποστολή δεδομένων κάμερας.',
    uploading_data: 'Ανεβάζοντας δεδομένα...',
  },
  canvas_control: {
    calculate: 'Υπολογισμός χρόνου',
    canvas_zoom: 'Zoom',
    exposure: 'Έκθεση',
    not_supported: 'Δεν υποστηρίζεται',
    opacity: 'Αδιαφάνεια',
  },
  caption: {
    connectionTimeout: 'Λήξη χρονικού ορίου σύνδεσης',
  },
  change_logs: {
    added: 'Προστέθηκαν:',
    change_log: 'Αλλαγές:',
    changed: 'Άλλαξαν:',
    fixed: 'Διορθώθηκαν:',
    help_center_url: 'https://support.flux3dp.com/hc/en-us/sections/360000421876',
    see_older_version: 'Δείτε παλαιότερες εκδόσεις',
  },
  cloud_sync: {
    import_config: 'Βρέθηκαν ρυθμίσεις cloud για αυτήν τη συσκευή. Θέλετε να τις εισαγάγετε;',
    import_failed: 'Αποτυχία ανάγνωσης ρυθμίσεων cloud.',
    sync_config: 'Θέλετε να συγχρονίσετε αυτές τις ρυθμίσεις στο cloud;',
    sync_failed: 'Αποτυχία συγχρονισμού ρυθμίσεων στο cloud.',
    sync_success: 'Οι ρυθμίσεις συγχρονίστηκαν στο cloud με επιτυχία.',
  },
  code_generator: {
    barcode: 'Γραμμωτός κώδικας',
    content: 'Περιεχόμενο',
    import: 'Εισαγωγή',
    qr_code: 'QR Κωδικός',
    type: 'Τύπος',
  },
  connection_issue_guide: {
    alert_link: 'Αποσυνδέεται; Δοκιμάστε αυτόν τον τρόπο αντιμετώπισης προβλημάτων.',
    connect_computer: {
      content: 'Ο υπολογιστής σας πρέπει να βρίσκεται στο ίδιο δίκτυο με το μηχάνημα.',
      macos_steps: 'Κάντε κλικ στο εικονίδιο Wi-Fi στη γραμμή μενού. Στη συνέχεια επιλέξτε το hotspot του τηλεφώνου σας.',
      macos_title: 'macOS',
      title: 'Συνδέστε τον υπολογιστή σας',
      windows_steps: 'Κάντε κλικ στο εικονίδιο δικτύου στη γραμμή εργασιών. Στη συνέχεια επιλέξτε το hotspot του τηλεφώνου σας.',
      windows_title: 'Windows',
    },
    connect_wifi: {
      cant_find_hotspot: 'Το μηχάνημα δεν μπορεί να βρει το hotspot μου',
      dont_know_hotspot_name: 'Δεν γνωρίζω το όνομα του hotspot μου',
      step1: '1. Στον πίνακα αφής του μηχανήματος, μεταβείτε στο: Δίκτυο → Σύνδεση σε Wi-Fi.',
      step2: '2. Βρείτε και επιλέξτε το όνομα του hotspot του τηλεφώνου σας από τη λίστα Wi-Fi.',
      step3: '3. Εισαγάγετε τον κωδικό πρόσβασης του hotspot και συνδεθείτε.',
      title: 'Συνδέστε το μηχάνημα στο hotspot του τηλεφώνου',
    },
    enter_ip: {
      check_firmware: 'Έκδοση υλικολογισμικού',
      check_ip_reachable: 'IP προσβάσιμη',
      check_machine_responds: 'Το μηχάνημα αποκρίνεται',
      placeholder: 'Διεύθυνση IP',
      step1: 'Εισαγάγετε τη διεύθυνση IP που βρήκατε στο προηγούμενο βήμα.',
      step2: 'Κάντε κλικ στο «Επαλήθευση» για να δοκιμάσετε τη σύνδεση.',
      step3: 'Το Beam Studio θα ελέγξει:',
      title: 'Εισαγάγετε τη διεύθυνση IP του μηχανήματός σας',
      verify: 'Επαλήθευση',
    },
    fail: {
      bullet1: '• Το μοντέλο και τον σειριακό αριθμό του μηχανήματός σας',
      bullet2: '• Τη διεύθυνση IP που εμφανίζεται στον πίνακα αφής',
      bullet3: '• Μια περιγραφή του σφάλματος που αντιμετωπίσατε',
      contact_title: 'Όταν επικοινωνείτε με την υποστήριξη, βοηθάει να έχετε:',
      intro: 'Μην ανησυχείτε — αυτό δεν σημαίνει απαραίτητα ότι κάτι δεν πάει καλά με το μηχάνημά σας. Ενδέχεται να υπάρχουν επιπλέον παράγοντες που επηρεάζουν τη σύνδεση. Η ομάδα υποστήριξής μας είναι εδώ για να σας βοηθήσει να το εξακριβώσετε.',
      title: 'Δεν μπορέσαμε να ολοκληρώσουμε τη δοκιμή',
    },
    hotspot: {
      android_steps: 'Ρυθμίσεις → Συνδέσεις → Σημείο πρόσβασης Wi-Fi και σύνδεση δικτύου → Σημείο πρόσβασης Wi-Fi',
      android_title: 'Android',
      ios_steps: 'Ρυθμίσεις → Προσωπικό hotspot → Να επιτρέπεται σε άλλους',
      ios_title: 'iPhone (iOS)',
      tip: 'Συμβουλή: Χρησιμοποιήστε ένα απλό αγγλικό όνομα hotspot και αριθμητικό κωδικό πρόσβασης (π.χ. Όνομα: FLUX_Test   Κωδικός: 12345678)',
      warning_2_4ghz: 'Σημαντικό: Τα μηχανήματα FLUX υποστηρίζουν μόνο Wi-Fi 2.4GHz. Ρυθμίστε το hotspot σας στα 2.4GHz πριν συνεχίσετε.',
    },
    how_it_works: 'Πώς λειτουργεί η δοκιμή:',
    how_it_works_step1: '1. Ρυθμίστε το τηλέφωνό σας ως hotspot Wi-Fi.',
    how_it_works_step2: '2. Συνδέστε το μηχάνημα στο hotspot.',
    how_it_works_step3: '3. Συνδέστε τον υπολογιστή σας στο ίδιο hotspot.',
    how_it_works_step4: '4. Δοκιμάστε τη σύνδεση στο Beam Studio.',
    intro: 'Ας εκτελέσουμε μια γρήγορη δοκιμή για να ελέγξουμε αν το μηχάνημά σας λειτουργεί σωστά. Θα συνδέσουμε το μηχάνημα και τον υπολογιστή σας μέσω του hotspot του κινητού σας τηλεφώνου για να διαπιστώσουμε αν το πρόβλημα οφείλεται στο δίκτυό σας ή στο ίδιο το μηχάνημα.',
    ip_address: {
      step1: 'Στον πίνακα αφής του μηχανήματος, μεταβείτε στο:\nΔίκτυο → Αναζητήστε τη «Διεύθυνση IP»',
      step2: 'Η IP συνήθως μοιάζει με: 172.20.10.x ή 192.168.x.x\n(Αυτό εξαρτάται από το hotspot του τηλεφώνου σας)',
      step3: 'Σημειώστε αυτή τη διεύθυνση IP για το επόμενο βήμα.',
      title: 'Βρείτε τη διεύθυνση IP του μηχανήματός σας',
      warning: 'Αν η IP ξεκινά με 169.254, η σύνδεση απέτυχε. Επιστρέψτε στο Βήμα 1 και προσπαθήστε ξανά.',
    },
    success: {
      cause: 'Το πρόβλημα σύνδεσης που αντιμετωπίσατε πιθανότατα οφείλεται στο περιβάλλον του τοπικού σας δικτύου και όχι στο ίδιο το μηχάνημα.',
      intro: 'Ολοκληρώσατε με επιτυχία τη δοκιμή σύνδεσης Wi-Fi — μπράβο σας! Αυτό επιβεβαιώνει ότι το μηχάνημα FLUX σας λειτουργεί άψογα.',
      recommend1: '• Επικοινωνήστε με τον πάροχο υπηρεσιών διαδικτύου (ISP) ή τον κατασκευαστή του router σας για βοήθεια με τις ρυθμίσεις Wi-Fi',
      recommend2: '• Ρωτήστε τον διαχειριστή δικτύου σας αν βρίσκεστε σε σχολείο, γραφείο ή κοινόχρηστο χώρο εργασίας',
      recommend3: '• Ελέγξτε αν το router σας υποστηρίζει 2.4GHz και δοκιμάστε να το επανεκκινήσετε',
      recommend_title: 'Τι Συνιστούμε:',
      title: 'Μπράβο! 🎉',
    },
    title: 'Πρόβλημα σύνδεσης;',
  },
  curve_engraving: {
    '921': 'Αποτυχία αυτόματης εστίασης.',
    '922': 'Αποτυχία εκτέλεσης μέτρησης με κόκκινο φως.',
    amount: 'Ποσότητα',
    apply_arkwork: 'Εφαρμογή έργου τέχνης στην καμπύλη',
    apply_camera: 'Εφαρμογή εικόνας κάμερας στην καμπύλη',
    click_to_select_point: 'Κάντε κλικ για να επιλέξετε ή να αποεπιλέξετε σημεία για επαναμέτρηση.',
    coloumns: 'Στήλες',
    column_gap: 'Διάκενο στηλών',
    err_object_over_range: 'Το αντικείμενο υπερβαίνει το εύρος μέτρησης.',
    failed_to_take_reference: 'Αποτυχία λήψης αναφοράς',
    gap: 'Κενό',
    help_center_url: 'https://support.flux3dp.com/hc/en-us/articles/10364060644495',
    measure_audofocus_area: 'Μετρήστε την περιοχή αυτόματης εστίασης',
    preview_3d_curve: 'Προεπισκόπηση χάραξης καμπύλης',
    remeasure: 'Επαναμέτρηση',
    remeasuring_points: 'Επαναμέτρηση σημείων...',
    reselect_area: 'Επαναεπιλογή περιοχής',
    row_gap: 'Διάκενο σειρών',
    rows: 'Σειρές',
    set_object_height: 'Ρύθμιση ύψους αντικειμένου',
    set_object_height_desc: 'Μετρήστε το μέγιστο πάχος του αντικειμένου.',
    start_autofocus: 'Εκκίνηση αυτόματης εστίασης',
    starting_measurement: 'Ξεκινώντας μέτρηση...',
    sure_to_delete: 'Θέλετε να διαγράψετε τα δεδομένα εστίασης της χάραξης καμπύλης;',
    take_reference: 'Λήψη αναφοράς',
    take_reference_desc: 'Παρακαλώ μετακινήστε την κεφαλή του λέιζερ στο υψηλότερο σημείο του αντικειμένου, χαμηλώστε τον αισθητήρα εστίασης και κάντε κλικ στο "Επιβεβαίωση" για εστίαση.',
  },
  device: {
    abort: 'Ακύρωση',
    aborted: 'Ακυρώθηκε',
    aborting: 'Ακύρωση',
    busy: 'Απασχολημένος',
    cartridge_info_read_failed: 'Please ensure that the ink is fully inserted. Try to remove the ink and install it back.',
    cartridge_info_verification_failed: 'Please verify that your ink is FLUX authentic.',
    cartridge_serial_number: 'Ink cartridge serial number',
    close_door_to_read_cartridge_info: "To access ink information, please close the machine's door cover.",
    completed: 'Ολοκληρώθηκε',
    completing: 'Ολοκλήρωση',
    deviceList: 'Λίστα συσκευών',
    disable: 'Απενεργοποίηση',
    disconnectedError: {
      caption: 'Η σύνδεση της συσκευής αποσυνδέθηκε',
      message: 'Παρακαλώ επιβεβαιώστε αν η πρόσβαση δικτύου του %s είναι διαθέσιμη',
    },
    firmware_version: 'Έκδοση υλικολογισμικού',
    ink_color: 'Ink color',
    ink_level: 'Ink level',
    ink_type: 'Ink type',
    IP: 'Διεύθυνση IP',
    model_name: 'Μοντέλο',
    occupied: 'Συντήρηση',
    pause: 'Παύση',
    paused: 'Σε παύση',
    pausedFromError: 'Σε παύση λόγω σφάλματος',
    pausing: 'Παύει',
    please_wait: 'Παρακαλώ περιμένετε...',
    preparing: 'Προετοιμασία',
    processing: 'Επεξεργασία',
    quit: 'Έξοδος',
    ready: 'Έτοιμος',
    reconnecting: 'Επανασύνδεση',
    reset: 'Επαναφορά',
    resuming: 'Συνέχιση',
    retry: 'Επανάληψη',
    running: 'Λειτουργία',
    scanning: 'Σάρωση',
    select: 'Επιλογή',
    select_printer: 'Επιλέξτε εκτυπωτή',
    serial_number: 'Σειριακός αριθμός',
    start: 'Εκκίνηση',
    starting: 'Εκκίνηση',
    status: 'Κατάσταση',
    submodule_type: 'Module',
    toolhead_change: 'Αλλαγή κεφαλής εργαλείου',
    unknown: 'Άγνωστη',
    uploading: 'Μεταφόρτωση',
    UUID: 'UUID',
  },
  device_selection: {
    go_to_settings: 'Μετάβαση Στις Ρυθμίσεις',
    macos_15_local_network_permission: 'Σε macOS 15 ή νεότερη έκδοση, ενεργοποιήστε την πρόσβαση του Beam Studio στο τοπικό δίκτυο στις Ρυθμίσεις συστήματος > Απόρρητο & Ασφάλεια > Τοπικό δίκτυο.',
    no_device: '#801 Δεν μπορούμε να βρούμε το μηχάνημά σας στο δίκτυο.\nΠαρακαλώ ακολουθήστε τον <a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/360001683556">οδηγό</a> για αντιμετώπιση προβλημάτων σύνδεσης.',
    no_device_web: "#801 Ελέγξτε την κατάσταση της μηχανής σας ή κάντε κλικ στο 'Ρύθμιση μηχανής' παρακάτω για να ρυθμίσετε τη μηχανή.",
    select_usb_device: 'Επιλέξτε συσκευή USB',
  },
  editor: {
    exposure: 'Φωτεινότητα',
    nozzle_refresh_area: 'Περιοχή Ανανέωσης Ακροφυσίου',
    opacity: 'Προεπισκόπηση Αδιαφάνειας',
    prespray_area: 'Περιοχή προετοιμασίας',
  },
  error_pages: {
    screen_size: 'Λάβετε υπόψη ότι το Beam Studio μπορεί να μην λειτουργεί βέλτιστα στη συσκευή σας. Για βέλτιστη εμπειρία, θα πρέπει να είναι μια συσκευή με πλάτος οθόνης τουλάχιστον 1024 εικονοστοιχεία.',
  },
  flux_id_login: {
    connection_fail: '#847 Αποτυχία σύνδεσης στην υπηρεσία μέλους FLUX.',
    email: 'Email',
    flux_plus: {
      access_monotype_feature: 'Δεν έχετε το πρόσθετο γραμματοσειρών Monotype.',
      access_monotype_feature_note: 'Πρέπει να έχετε συνδρομή FLUX+ Pro ή το πρόσθετο γραμματοσειρών Monotype για να έχετε πρόσβαση σε αυτή τη λειτουργία.',
      access_plus_feature_1: 'Έχετε πρόσβαση σε μια',
      access_plus_feature_2: 'λειτουργία.',
      access_plus_feature_note: 'Πρέπει να έχετε συνδρομή FLUX+ για να έχετε πρόσβαση σε αυτή τη λειτουργία.',
      ai_credit_tooltip: 'Για λειτουργίες AI',
      explore_plans: 'Εξερευνήστε τα σχέδια FLUX+',
      features: {
        ai_bg_removal: 'Αφαίρεση φόντου με τεχνητή νοημοσύνη',
        boxgen: 'Γεννήτρια 3D κουτιών',
        dmkt: '1000+ αρχεία σχεδίασης',
        monotype: '250+ προπληρωμένες γραμματοσειρές',
        my_cloud: 'Απεριόριστη αποθήκευση στο cloud',
      },
      flux_credit_tooltip: 'Για αρχεία Αγοράς Σχεδίων και αφαίρεση φόντου με τεχνητή νοημοσύνη',
      get_addon: 'Αποκτήστε το πρόσθετο',
      goto_member_center: 'Μεταβείτε στο Κέντρο Μελών',
      learn_more: 'Μάθετε περισσότερα',
      member_center_url: 'https://member.flux3dp.com/en-US/subscription',
      subscribe_now: 'Εγγραφείτε τώρα',
      thank_you: 'Σας ευχαριστούμε που είστε τιμημένο μέλος!',
      website_url: 'https://flux3dp.com/subscription',
    },
    forget_password: 'Ξεχάσατε τον κωδικό σας;',
    incorrect: 'Το email ή ο κωδικός πρόσβασης δεν είναι σωστά.',
    login: 'Συνδεθείτε',
    login_success: 'Συνδεδεμένος',
    lost_password_url: 'https://id.flux3dp.com/user/forgot-password',
    new_to_flux: 'Νέος στο FLUX; Δημιουργήστε έναν λογαριασμό.',
    not_verified: 'Το email δεν έχει επιβεβαιωθεί ακόμα.',
    password: 'Κωδικός πρόσβασης',
    register: 'Δημιουργήστε τον λογαριασμό σας FLUX',
    remember_me: 'Να με θυμάσαι',
    sign_in_later: 'Σύνδεση αργότερα',
    signup_url: 'https://id.flux3dp.com/user/login#up',
    unlock_shape_library: 'Συνδεθείτε για να ξεκλειδώσετε τη βάση δεδομένων σχημάτων.',
  },
  framing: {
    area_check: 'Έλεγχος περιοχής',
    areacheck_desc: 'Εξασφαλίζει την ασφάλεια της περιοχής εργασίας προβάλλοντας το πλαίσιο οριοθέτησης του αντικειμένου και τη ζώνη επιτάχυνσης της κεφαλής λέιζερ.',
    calculating_task: 'Υπολογισμός εργασίας...',
    contour: 'Περίγραμμα',
    contour_desc: 'Προεπισκόπηση του πραγματικού περιγράμματος του σχεδίου.',
    framing: 'Πλαισίωση',
    framing_desc: 'Προεπισκόπηση του ορίου αντικειμένου.',
    hull: 'Περίβλημα',
    hull_desc: 'Προεπισκοπεί ένα σχήμα που ακολουθεί στενά το σχέδιο, όπως ένα λάστιχο γύρω από το αντικείμενο.',
    low_laser: 'Χαμηλή ισχύς λέιζερ',
    low_laser_desc: 'Ορίστε τιμή χαμηλής ισχύος λέιζερ για την εργασία πλαισίωσης.',
    repeat: 'Επανάληψη',
    rotate_axis: 'Άξονας περιστροφής',
    rotateaxis_desc: 'Προεπισκόπηση του κέντρου του άξονα περιστροφής, ο άξονας δεν κινείται.',
    rotation_frame_warning: 'Η προεπισκόπηση πλαισίου θα περιστραφεί μία φορά. Αποφύγετε τη διακοπή στη μέση για να αποτρέψετε την κακή ευθυγράμμιση της σήμανσης.',
    rotation_framing_desc: 'Προεπισκόπηση ολόκληρης της περιοχής περιστροφής, ο άξονας περιστρέφεται σύμφωνα με την προεπισκόπηση.',
    start_task: 'Έναρξη Εργασίας',
    start_task_description: 'Αφού ολοκληρωθεί η προεπισκόπηση καρέ, κάντε κλικ στο "Έναρξη Εργασίας" για να υποβάλετε τη δουλειά.',
  },
  general: {
    choose_folder: 'Επιλέξτε φάκελο',
    processing: 'Επεξεργασία...',
  },
  generators: {
    box_generator: 'Γεννήτρια Κουτιού',
    code_generator: 'Γεννήτρια κώδικα',
    keychain_generator: 'Γεννήτρια μπρελόκ',
    material_test_generator: 'Γεννήτρια Δοκιμής Υλικού',
    puzzle_generator: 'Γεννήτρια παζλ',
    title: 'Γεννήτριες',
  },
  generic_error: {
    OPERATION_ERROR: '[ΣΕ] Παρουσιάστηκε σύγκρουση κατάστασης, παρακαλώ επαναλάβετε την ενέργεια.',
    SUBSYSTEM_ERROR: '[ΣΥΕ] Σφάλμα κατά την εκτέλεση του έργου από το firmware της μηχανής. Παρακαλώ επανεκκινήστε τη μηχανή.',
    UNKNOWN_COMMAND: 'Παρακαλώ ενημερώστε το υλικολογισμικό της συσκευής',
    UNKNOWN_ERROR: '[ΑΕ] Παρουσιάστηκε άγνωστο σφάλμα. Παρακαλώ επανεκκινήστε το Beam Studio και τη μηχανή.',
  },
  global: {
    apply: 'Εφαρμογή',
    back: 'Πίσω',
    cancel: 'Ακύρωση',
    editing: {
      redo: 'Επανάληψη',
      reset: 'Επαναφορά',
      reset_view: 'Επαναφορά Προβολής',
      undo: 'Αναίρεση',
      zoom_in: 'Μεγέθυνση',
      zoom_out: 'Σμίκρυνση',
    },
    enable: 'Ενεργοποίηση',
    height: 'Ύψος',
    mode_conflict: 'Αυτή η επιλογή δεν είναι διαθέσιμη στην τρέχουσα λειτουργία.',
    ok: 'Εντάξει',
    preview: 'Προεπισκόπηση',
    save: 'Αποθήκευση',
    save_and_exit: 'Αποθήκευση και έξοδος',
    saving: 'Αποθήκευση...',
    select: 'Επιλογή',
    stop: 'Σταμάτημα',
    width: 'Πλάτος',
  },
  google_font_panel: {
    all_languages: 'Όλες οι γλώσσες',
    category: 'Κατηγορία',
    language_label: 'Γλώσσα',
    language_placeholder: 'Γλώσσα',
    language_unavailable_offline: 'Μη διαθέσιμο εκτός σύνδεσης',
    more_google_fonts: 'Περισσότερες Google Fonts...',
    no_fonts_available: 'Δεν υπάρχουν διαθέσιμες γραμματοσειρές.',
    no_internet_connection: 'Χωρίς σύνδεση στο διαδίκτυο',
    no_results_message: 'Δεν βρέθηκαν γραμματοσειρές που να ταιριάζουν με τα κριτήρια αναζήτησής σας.',
    no_selection: 'Δεν έχει επιλεγεί γραμματοσειρά',
    offline_message: 'Τα Google Fonts δεν είναι διαθέσιμα εκτός σύνδεσης. Συνδεθείτε στο διαδίκτυο για να περιηγηθείτε και να επιλέξετε Google Fonts.',
    search_placeholder: 'Αναζήτηση γραμματοσειρών...',
    search_unavailable_offline: 'Αναζήτηση μη διαθέσιμη εκτός σύνδεσης',
    selected_prefix: 'Επιλεγμένο:',
    title: 'Google Fonts',
    unavailable_message: 'Τα Google Fonts δεν είναι διαθέσιμα αυτή τη στιγμή. Ελέγξτε τη σύνδεσή σας στο διαδίκτυο ή επικοινωνήστε με τον διαχειριστή σας.',
  },
  image_edit_panel: {
    eraser: {
      brush_size: 'Μέγεθος πινέλου',
      description: 'Κάντε κλικ ή σύρετε για να διαγράψετε χειροκίνητα ανεπιθύμητες περιοχές.',
      title: 'Γόμα',
    },
    magic_wand: {
      description: 'Επιλέξτε και αφαιρέστε γειτονικές περιοχές με βάση την ομοιότητα χρωμάτων.',
      title: 'Μαγικό Ραβδί',
      tolerance: 'Ανοχή',
    },
    rounded_corner: {
      description: 'Ρυθμίστε την καμπυλότητα των γωνιών του αντικειμένου.',
      radius: 'Ακτίνα',
      title: 'Στρογγυλεμένη γωνία',
    },
    title: 'Επεξεργασία Εικόνας',
  },
  initialize: {
    back: 'Πίσω',
    cancel: 'Ακύρωση',
    confirm: 'Επιβεβαίωση',
    connect: 'Σύνδεση',
    connect_ethernet: {
      title: 'Άμεση σύνδεση',
      tutorial1: '1. Συνδέστε το μηχάνημα με τον υπολογιστή σας με καλώδιο Ethernet.',
      tutorial2_1: '2. Ακολουθήστε ',
      tutorial2_2: ' για να κάνετε τον υπολογιστή σας ως δρομολογητή.',
      tutorial2_a_href_mac: 'https://support.flux3dp.com/hc/en-us/articles/360001517076',
      tutorial2_a_href_win: 'https://support.flux3dp.com/hc/en-us/articles/360001507715',
      tutorial2_a_text: 'αυτόν τον οδηγό',
      tutorial3: '3. Κάντε κλικ στο Επόμενο.',
    },
    connect_machine_ip: {
      alert: {
        swiftray_connection_error: 'Αδύνατη η σύνδεση με τον διακομιστή. Επανεκκινήστε το Beam Studio και δοκιμάστε ξανά.',
      },
      check_camera: 'Έλεγχος διαθεσιμότητας κάμερας',
      check_connection: 'Έλεγχος σύνδεσης μηχανήματος',
      check_firmware: 'Έλεγχος έκδοσης υλικολογισμικού',
      check_ip: 'Έλεγχος διαθεσιμότητας IP',
      check_swiftray_connection: 'Έλεγχος σύνδεσης διακομιστή',
      check_swiftray_connection_unreachable: 'ο διακομιστής δεν είναι προσβάσιμος',
      check_usb: 'Έλεγχος σύνδεσης USB',
      connection_failed_hint: 'Δεν είναι δυνατή η σύνδεση με το μηχάνημα. Ανατρέξτε σε <a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/360001683556">αυτόν τον οδηγό</a> για την επίλυση του προβλήματος.',
      enter_ip: 'Εισάγετε τη διεύθυνση IP του μηχανήματός σας',
      finish_setting: 'Ξεκινήστε τη δημιουργία!',
      invalid_format: 'Μη έγκυρη μορφή',
      invalid_ip: 'Μη έγκυρη διεύθυνση IP: ',
      promark_hint: 'Εάν αποτύχετε επανειλημμένα να συνδεθείτε μέσω USB, ανατρέξτε στο <a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/11318820440591">άρθρο του Κέντρου βοήθειας</a>.',
      retry: 'Επανάληψη',
      starts_with_169254: 'Ξεκινά με 169.254',
      succeeded_message: 'Επιτυχής σύνδεση 🎉',
      unreachable: 'Μη προσβάσιμη διεύθυνση IP',
      unreachable_macos_15: 'Σε macOS 15 ή νεότερο, ενεργοποιήστε την πρόσβαση του Beam Studio στο τοπικό δίκτυο από τις Ρυθμίσεις συστήματος > <a target="_blank" href="x-apple.systempreferences:com.apple.preference.security?Privacy_LocalNetwork">Απόρρητο και ασφάλεια</a> > Τοπικό δίκτυο.',
    },
    connect_usb: {
      connect_camera: 'Συνδέστε την κάμερα της μηχανής στον υπολογιστή σας με καλώδιο USB.',
      title: 'Σύνδεση USB',
      title_sub: ' (HEXA & Ador Only)',
      turn_off_machine: 'Απενεργοποιήστε το μηχάνημα.',
      turn_on_machine: 'Ενεργοποιήστε το μηχάνημα.',
      tutorial1: 'Συνδέστε το μηχάνημα με τον υπολογιστή σας με καλώδιο USB.',
      tutorial2: 'Κάντε κλικ στο "Επόμενο".',
      wait_for_turning_on: 'Πατήστε "Επόμενο" μετά την ολοκλήρωση της διαδικασίας εκκίνησης και αφού έχετε μπει στην κύρια οθόνη.',
    },
    connect_wifi: {
      title: 'Σύνδεση στο Wi-Fi',
      tutorial1: '1. Μεταβείτε στον Πίνακα αφής > Πατήστε στο "Δίκτυο" > "Σύνδεση στο WiFi".',
      tutorial1_ador: '1. Μεταβείτε στον Πίνακα αφής > Πατήστε στο "ΜΗΧΑΝΗΜΑ" > Πατήστε στο "Δίκτυο" > "Σύνδεση στο WiFi".',
      tutorial2: '2. Επιλέξτε και συνδεθείτε στο προτιμώμενο Wi-Fi δίκτυό σας.',
      what_if_1: 'Τι συμβαίνει αν δεν βλέπω το Wi-Fi μου;',
      what_if_1_content: '1. Η κρυπτογράφηση Wi-Fi πρέπει να είναι WPA2 ή χωρίς κωδικό πρόσβασης.\n2. Η κρυπτογράφηση μπορεί να ρυθμιστεί στο περιβάλλον διαχείρισης δρομολογητή Wi-Fi. Αν ο δρομολογητής δεν υποστηρίζει WPA2 και χρειάζεστε βοήθεια στην επιλογή του σωστού δρομολογητή, επικοινωνήστε με την υποστήριξη.\n3. Το κανάλι Wi-Fi πρέπει να είναι 2.4Ghz (το 5Ghz δεν υποστηρίζεται).',
      what_if_2: 'Τι συμβαίνει αν δεν βλέπω κανένα Wi-Fi;',
      what_if_2_content: '1. Βεβαιωθείτε ότι το Wi-Fi dongle είναι πλήρως συνδεδεμένο.\n2. Αν δεν υπάρχει διεύθυνση MAC του ασύρματου δικτύου στην οθόνη αφής, επικοινωνήστε με την υποστήριξη.',
    },
    connect_wired: {
      title: 'Σύνδεση σε Ενσύρματο Δίκτυο',
      tutorial1: '1. Συνδέστε το μηχάνημα με το δρομολογητή σας.',
      tutorial2: '2. Πατήστε "Δίκτυο" για να λάβετε τη διεύθυνση IP ενσύρματου δικτύου.',
      tutorial2_ador: '2. Πατήστε "ΜΗΧΑΝΗΜΑ"> "Δίκτυο" για να λάβετε τη διεύθυνση IP ενσύρματου δικτύου.',
      what_if_1: 'Τι συμβαίνει αν η διεύθυνση IP είναι κενή;',
      what_if_1_content: '1. Βεβαιωθείτε ότι το καλώδιο Ethernet είναι πλήρως συνδεδεμένο.\n2. Αν δεν υπάρχει διεύθυνση MAC του ενσύρματου δικτύου στην οθόνη αφής, επικοινωνήστε με την υποστήριξη.',
      what_if_2: 'Τι συμβαίνει αν η διεύθυνση IP ξεκινάει με 169;',
      what_if_2_content: '1. Αν η διεύθυνση IP ξεκινάει με 169.254, θα πρέπει να υπάρχει πρόβλημα ρύθμισης DHCP, επικοινωνήστε με τον πάροχο υπηρεσιών διαδικτύου (ISP) για περαιτέρω βοήθεια.\n2. Αν ο υπολογιστής σας συνδέεται στο διαδίκτυο απευθείας χρησιμοποιώντας PPPoE, αλλάξτε ώστε να χρησιμοποιείτε το δρομολογητή για σύνδεση μέσω PPPoE και ενεργοποιήστε τη λειτουργία DHCP στο δρομολογητή.',
    },
    connecting: 'Σύνδεση...',
    connection_types: {
      ether2ether: 'Άμεση σύνδεση',
      usb: 'Σύνδεση USB',
      wifi: 'Wi-Fi',
      wired: 'Ενσύρματο δίκτυο',
    },
    next: 'Επόμενο',
    no_machine: 'Δεν έχω μηχάνημα αυτή τη στιγμή.',
    promark: {
      configuration_confirmation: 'Αυτό διασφαλίζει ότι το Promark σας είναι σωστά ρυθμισμένο για βέλτιστη απόδοση και ακρίβεια.',
      or_complete_later: `Ή παραλείψτε αυτό το βήμα και ολοκληρώστε τις Ρυθμίσεις Promark αργότερα στο:
    Μηχανήματα > "Όνομα Promark" > Ρυθμίσεις Promark`,
      qc_instructions: 'Συμπληρώστε τις παραμέτρους που βρίσκονται στο πίσω μέρος της κάρτας "QC Pass"',
      select_laser_source: 'Επιλέξτε το Promark σας',
      select_workarea: 'Επιλέξτε Περιοχή Εργασίας',
      setting_completed_ask_camera_calibration: 'Η ρύθμιση του φακού πεδίου του Promark ολοκληρώθηκε με επιτυχία! Θέλετε να προχωρήσετε με τη βαθμονόμηση της κάμερας;',
      settings: 'Ρυθμίσεις Promark',
    },
    retry: 'Επανάληψη',
    select_beambox: 'Επιλέξτε το Beambox σας',
    select_beamo: 'Επιλέξτε το beamo σας',
    select_connection_type: 'Πώς θέλετε να συνδεθείτε;',
    select_hexa: 'Επιλέξτε το HEXA σας',
    select_language: 'Επιλέξτε γλώσσα',
    select_machine_type: 'Επιλέξτε τον τύπο του μηχανήματός σας',
    select_promark: 'Επιλέξτε το Promark σας',
    setting_completed: {
      back: 'Πίσω',
      great: 'Καλώς ήρθατε στο Beam Studio',
      ok: 'ΞΕΚΙΝΗΣΤΕ ΤΗ ΔΗΜΙΟΥΡΓΙΑ',
      setup_later: 'Μπορείτε πάντα να ρυθμίσετε τη μηχανή σας από τη γραμμή τίτλου > "Μηχανές" > "Ρύθμιση μηχανής"',
      start: 'Έναρξη',
    },
    skip: 'Παράλειψη',
    start: 'Έναρξη',
  },
  input_machine_password: {
    connect: 'ΣΥΝΔΕΣΗ',
    password: 'Κωδικός πρόσβασης',
    require_password: '"%s" απαιτεί κωδικό πρόσβασης',
  },
  insecure_websocket: {
    extension_detected: 'Εντοπίστηκε η επέκταση Beam Studio Connect',
    extension_detected_description: 'Ανιχνεύσαμε ότι έχετε εγκαταστήσει την επέκταση Beam Studio Connect. Κάντε κλικ στο "Επιβεβαίωση" για να ανακατευθυνθείτε στο HTTPS, ή κάντε κλικ στο "Ακύρωση" για να συνεχίσετε να χρησιμοποιείτε το HTTP.',
    extension_not_deteced: 'Δεν ήταν δυνατή η ανίχνευση της επέκτασης Beam Studio Connect',
    extension_not_deteced_description: "Για να χρησιμοποιήσετε το HTTPS, κάντε κλικ στο 'Επιβεβαίωση' για να εγκαταστήσετε την επέκταση Beam Studio Connect. Μετά την εγκατάσταση της επέκτασης, παρακαλώ ανανεώστε τη σελίδα για να την ενεργοποιήσετε.<br/>Διαφορετικά, κάντε κλικ στον παρακάτω σύνδεσμο για να δείτε πώς να χρησιμοποιήσετε το HTTP στο Chrome.",
    unsecure_url_help_center_link: '<a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/9935859456271">Σύνδεσμος</a>',
  },
  keychain_generator: {
    decoration: 'Διακόσμηση',
    design_preview: 'Προεπισκόπηση σχεδίου',
    element: 'Στοιχείο',
    element_size: 'Μέγεθος',
    emboss: 'Ανάγλυφο',
    exploded_view: 'Ανεπτυγμένη όψη',
    export_failed: 'Αποτυχία εισαγωγής μπρελόκ στον καμβά. Παρακαλώ δοκιμάστε ξανά.',
    hole: 'Οπή',
    hole_options: {
      diameter: 'Διάμετρος',
      hole_type: 'Τύπος',
      offset: 'Μετατόπιση',
      position: 'Θέση',
      thickness: 'Πάχος',
      type_punch: 'Διάτρηση',
      type_ring: 'Δαχτυλίδι',
    },
    import_to_canvas: 'Εισαγωγή στον καμβά',
    layers: {
      keychain: 'Μπρελόκ - Περίγραμμα',
      keychain_deco_emboss: 'Διακοσμήσεις μπρελόκ - Κοπή',
      keychain_deco_emboss_guide: 'Διακοσμήσεις μπρελόκ - Οδηγός κοπής',
      keychain_deco_engraving: 'Διακοσμήσεις μπρελόκ - Χάραξη',
    },
    more_shapes: 'Περισσότερα σχήματα',
    outline_offset: 'Μετατόπιση περιγράμματος',
    reset_to_default: 'Επαναφορά προεπιλογών',
    shape: 'Σχήμα',
    size_scale: 'Κλίμακα μεγέθους',
    switch_type_warning: 'Οι τρέχουσες ρυθμίσεις σας δεν έχουν εισαχθεί ακόμα στον καμβά.\nΗ αλλαγή τύπου μπρελόκ θα επαναφέρει όλες τις ρυθμίσεις στις προεπιλεγμένες τιμές.',
    text: 'Κείμενο',
    text_options: {
      font_family: 'Οικογένεια γραμματοσειράς',
      font_settings: 'Ρυθμίσεις γραμματοσειράς',
      font_size: 'Μέγεθος γραμματοσειράς',
      font_style: 'Στυλ γραμματοσειράς',
      letter_spacing: 'Απόσταση γραμμάτων',
      line_spacing: 'Διάστιχο',
      text_placeholder: 'Εισαγωγή κειμένου...',
    },
    types: {
      animal: 'Στυλ ζώου',
      capsule: 'Στυλ κάψουλας',
      dialog_box: 'Στυλ πλαισίου διαλόγου',
      geometry: 'Γεωμετρικό στυλ',
      oval: 'Οβάλ στυλ',
      pet: 'Στυλ κατοικιδίου',
      plant: 'Στυλ φυτού',
      polygonal: 'Πολυγωνικό στυλ',
      quadrilateral: 'Τετράπλευρο στυλ',
      round_arch: 'Στυλ στρογγυλής αψίδας',
      rounded: 'Στρογγυλό στυλ',
      surfing_board: 'Στυλ σανίδας σερφ',
      tag: 'Στυλ ετικέτας',
      text: 'Κείμενο',
      zodiac: 'Ζώδια',
    },
  },
  layer_module: {
    general_laser: 'Λέιζερ',
    laser_2w_infrared: 'Υπέρυθρο λέιζερ 2W',
    laser_10w_diode: 'Λέιζερ διόδου 10W',
    laser_20w_diode: 'Λέιζερ διόδου 20W',
    non_working_area: 'Μη Εργασιακή Περιοχή',
    none: 'None',
    notification: {
      convertFromLaserModuleMsg: 'Προσέξτε, αν ολοκληρώσετε αυτή τη λειτουργία, οι ρυθμίσεις του στρώματος λέιζερ θα αφαιρεθούν.',
      convertFromLaserModuleTitle: 'Θέλετε να μετατρέψετε το λέιζερ σε εκτύπωση;',
      convertFromPrintingModuleMsg: 'Προσέξτε, αν ολοκληρώσετε αυτή τη λειτουργία, οι ρυθμίσεις χρωμάτων του στρώματος εκτύπωσης θα αφαιρεθούν.',
      convertFromPrintingModuleTitle: 'Θέλετε να μετατρέψετε την εκτύπωση σε λέιζερ;',
      importedDocumentContainsPrinting: 'Το έγγραφο περιέχει στρώμα εκτύπωσης, θέλετε να αλλάξετε την περιοχή εργασίας σε Ador;',
      importedDocumentContainsPrinting4C: 'Το έγγραφο περιέχει στρώμα εκτύπωσης, θέλετε να αλλάξετε την περιοχή εργασίας σε beamo II;',
      performIRCaliMsg: 'Κάντε κλικ στο "Επιβεβαίωση" για να εκτελέσετε βαθμονόμηση ή μέσω του μενού (Μηχάνημα > [Όνομα Μηχανήματος] > Βαθμονόμηση Υπερύθρου)',
      performIRCaliTitle: 'Εκτελέστε βαθμονόμηση υπερύθρου',
      performPrintingCaliMsg: 'Κάντε κλικ στο "Επιβεβαίωση" για να εκτελέσετε βαθμονόμηση ή μέσω του μενού (Μηχάνημα > [Όνομα Μηχανήματος] > Βαθμονόμηση Εκτύπωσης)',
      performPrintingCaliTitle: 'Εκτελέστε βαθμονόμηση εκτύπωσης',
      printingLayersConverted: 'Τα στρώματα εκτύπωσης έχουν μετατραπεί σε στρώματα λέιζερ.',
    },
    printing: 'Εκτύπωση',
    unknown: 'Unknown Module',
    uv_print: 'UV Εκτύπωση',
    uv_varnish: 'Βερνίκι',
    uv_white_ink: 'Λευκό μελάνι',
  },
  machine_linking: {
    continue: 'Συνέχεια',
    i_have_read: 'Έχω διαβάσει',
    input_birthday_to_link: 'Εισαγάγετε την ημερομηνία γέννησής σας για να ολοκληρώσετε τη σύνδεση της συσκευής',
    input_birthday_to_link_note: '*Χρησιμοποιείται για να επαληθεύσει εάν η ηλικία σας πληροί τις προϋποθέσεις επιλεξιμότητας',
    link_failed: 'Η σύνδεση απέτυχε.',
    link_failed_already_linked: 'Αυτή η συσκευή είναι αυτή τη στιγμή συνδεδεμένη με άλλο FLUX ID. Μπορείτε να συνεχίσετε να τη χρησιμοποιείτε ή να τη συνδέσετε με τον λογαριασμό σας.',
    link_failed_cannot_set_secret: 'Δεν είναι δυνατή η αποθήκευση των πληροφοριών σύνδεσης στη συσκευή. Ελέγξτε τη σύνδεση μεταξύ του υπολογιστή και της συσκευής σας.',
    link_failed_under_age: 'Δεν πληροίτε επί του παρόντος τις προϋποθέσεις για τη χρήση αυτής της υπηρεσίας και δεν μπορείτε να ολοκληρώσετε τη σύνδεση της συσκευής.',
    link_machine: 'Σύνδεση FLUX ID',
    link_machine_to_account: 'Συνδέθηκε με %(name)s. Θέλετε να συνδέσετε αυτή τη συσκευή με τον λογαριασμό σας;',
    link_success: 'Επιτυχής σύνδεση.',
    link_to_my_flux_id: 'Σύνδεση με το FLUX ID μου',
    privacy_policy: 'Πολιτική Απορρήτου',
    privacy_policy_link: 'https://flux3dp.com/privacy/',
    process_linking: 'Σύνδεση…',
    use_without_linking: 'Χρήση χωρίς σύνδεση',
  },
  machine_status: {
    '-17': 'Λειτουργία κασέτας',
    '-10': 'Λειτουργία συντήρησης',
    '-2': 'Σάρωση',
    '-1': 'Συντήρηση',
    '0': 'Έτοιμο',
    '1': 'Εκτελείται',
    '2': 'Παύση',
    '4': 'Σε παύση',
    '6': 'Σε παύση',
    '16': 'Σε παύση',
    '18': 'Σε παύση',
    '32': 'Σε παύση',
    '36': 'Σε παύση',
    '38': 'Παύση',
    '48': 'Σε παύση',
    '50': 'Παύση',
    '64': 'Ολοκληρώθηκε',
    '66': 'Ολοκλήρωση',
    '68': 'Προετοιμασία',
    '128': 'Ακυρώθηκε',
    '256': 'Συναγερμός',
    '512': 'Θανατηφόρο',
    UNKNOWN: 'Άγνωστο',
  },
  maintenance: {
    actions: {
      checked: 'Ελέγχθηκε',
      done: 'Ολοκληρώθηκε',
      fail: 'Απέτυχε',
      history: 'Ιστορικό',
      open_guide: 'Άνοιγμα οδηγού',
      pass: 'Πέρασε',
      print: 'Εκτύπωση / PDF',
    },
    areas: {
      back_cover: 'Πίσω κάλυμμα',
      modules: 'Μονάδες',
      optics: 'Οπτικά',
      panel: 'Πίνακας',
      working_area: 'Περιοχή εργασίας',
    },
    cadence: {
      by_material: 'Ανά υλικό',
      condition: 'Κατά συνθήκη',
      day: 'Κάθε ημέρα',
      days: 'Κάθε %s ημέρες',
      each_operation: 'Σε κάθε χρήση',
      every_1_2_weeks: 'Κάθε 1–2 εβδομάδες',
      month: 'Κάθε μήνα',
      months: 'Κάθε %s μήνες',
      upon_unboxing: 'Κατά την πρώτη αποσυσκευασία',
      week: 'Κάθε εβδομάδα',
      weeks: 'Κάθε %s εβδομάδες',
    },
    celebration: {
      subtitle: 'Το %s σας είναι σε άριστη κατάσταση — συνεχίστε έτσι.',
      title: 'Όλες οι βασικές εργασίες συντήρησης ολοκληρώθηκαν!',
    },
    columns: {
      cadence: 'Συχνότητα',
      status: 'Κατάσταση',
      task: 'Εργασία',
    },
    empty_no_machine: 'Συνδέστε ή επιλέξτε ένα μηχάνημα για να δείτε το πρόγραμμα συντήρησής του.',
    empty_no_schedule: 'Δεν υπάρχει ακόμη διαθέσιμη λίστα συντήρησης για αυτό το μοντέλο.',
    essential: 'Βασικό',
    essential_health: 'Βασική υγεία',
    essential_hint: 'μετρά στην υγεία',
    feedback: {
      checked: '%s: ελέγχθηκε.',
      done: '%s: ολοκληρώθηκε. Επόμενη προθεσμία %s.',
      done_no_date: '%s: ολοκληρώθηκε.',
      fail_warning: '%s: επισημάνθηκε για αντικατάσταση σωλήνα. Ανοίξτε τον οδηγό για τα βήματα.',
      passed: '%s: πέρασε — ο σωλήνας λέιζερ είναι υγιής!',
    },
    footer_tip: 'Συμβουλή: χαράξτε ένα δοκιμαστικό αρχείο κάθε μήνα για να διατηρείτε το μηχάνημα υγιές.',
    history_hint: 'Διατηρούνται μόνο οι %s πιο πρόσφατες καταχωρίσεις για κάθε εργασία.',
    intro: 'Παρακολουθήστε κάθε εργασία συντήρησης για αυτό το μηχάνημα και σημειώστε την ως ολοκληρωμένη με ένα κλικ.',
    legend: {
      due_soon: 'Επίκειται σύντομα',
      overdue: 'Εκπρόθεσμο',
      up_to_date: 'Ενημερωμένο',
    },
    machine_groups: {
      my_machines: 'Τα μηχανήματά μου',
      other_models: 'Άλλα μοντέλα',
    },
    machine_label: 'Μηχάνημα',
    materials: {
      acrylic: 'Ακρυλικό',
      leather: 'Δέρμα',
      paper: 'Χαρτί',
      wood: 'Ξύλο',
    },
    status: {
      checked: 'Ελεγμένο',
      due: 'Προθεσμία',
      healthy: 'Υγιής',
      last: 'Τελευταία',
      never_done: 'Δεν έγινε ποτέ',
      next: 'Επόμενη προθεσμία',
      not_checked: 'Μη ελεγμένο',
      not_logged: 'Μη καταγεγραμμένο',
      overdue: 'Εκπρόθεσμο',
      replace_tube: 'Αντικατάσταση σωλήνα',
    },
    tasks: {
      align: {
        keyPoints: 'Ρυθμίστε όταν η οπτική διαδρομή είναι εκτός ευθυγράμμισης.',
        name: 'Ευθυγράμμιση οπτικής διαδρομής',
      },
      chassis: {
        keyPoints: 'Αφαιρέστε τα υπολείμματα και την πίσσα από το σασί και το κάτω κάλυμμα.',
        name: 'Καθαρισμός σασί',
      },
      door: {
        keyPoints: 'Αφαιρέστε το λίπος από το κάλυμμα της πόρτας.',
        name: 'Καθαρισμός καλύμματος πόρτας',
      },
      exhaust: {
        keyPoints: 'Καθαρίστε τη σκόνη από τα πτερύγια του ανεμιστήρα.',
        name: 'Καθαρισμός ανεμιστήρα εξαγωγής',
      },
      fan: {
        keyPoints: 'Αφαιρέστε τη σκόνη από τα πτερύγια του ανεμιστήρα εξαερισμού.',
        name: 'Καθαρισμός ανεμιστήρα εξαερισμού',
      },
      fieldlens: {
        keyPoints: 'Καθαρίστε τον φακό πεδίου, σκουπίζοντας από το κέντρο προς τα έξω με δεξιόστροφη φορά.',
        name: 'Καθαρισμός φακού πεδίου',
      },
      honeycomb_plate: {
        keyPoints: 'Αφαιρέστε τα υπολείμματα και την πίσσα από τα κελιά της πλάκας κηρήθρας.',
        name: 'Καθαρισμός πλάκας κηρήθρας',
      },
      honeycomb_table: {
        keyPoints: 'Αφαιρέστε τα υπολείμματα και την πίσσα από το πλέγμα κηρήθρας.',
        name: 'Καθαρισμός τραπεζιού κηρήθρας',
      },
      lube: {
        keyPoints: 'Καθαρίστε τους οδηγούς άξονες, τη γραμμική ράγα και τον μηχανισμό εστίασης και μετά λιπάνετε ξανά. Η συχνότητα διαφέρει ανάλογα με το υλικό που κόβετε.',
        name: 'Λίπανση',
      },
      maintain_test: {
        keyPoints: 'Ελέγξτε την ένδειξη κατάστασης και τους διακόπτες.',
        name: 'Σελίδα MAINTAIN',
      },
      mirrors_combiner: {
        keyPoints: 'Αφαιρέστε τους ρύπους από τους φακούς/καθρέφτες· ελέγξτε για οξείδωση. Χωρίς υπολείμματα οινοπνεύματος ή νερού.',
        name: 'Καθρέφτες, φακός εστίασης & συνδυαστής δέσμης',
      },
      mirrors_lens: {
        keyPoints: 'Καθαρίστε τους 4 καθρέφτες και τον φακό· βεβαιωθείτε ότι δεν υπάρχει οξείδωση ή στίγματα νερού.',
        name: 'Καθαρισμός καθρεφτών & φακού',
      },
      mod_diode: {
        keyPoints: 'Καθαρίστε τον ανεμιστήρα, τον φακό εστίασης και το POGO pin.',
        name: 'Μονάδα λέιζερ διόδου',
      },
      mod_ir: {
        keyPoints: 'Καθαρίστε τον φακό εστίασης.',
        name: 'Μονάδα υπέρυθρου λέιζερ',
      },
      optical_inspection: {
        keyPoints: 'Επιθεωρήστε την οπτική διαδρομή· επίσης κατά την αποσυσκευασία και μετά την αντικατάσταση του σωλήνα.',
        name: 'Επιθεώρηση οπτικής διαδρομής',
      },
      optical_unboxing: {
        keyPoints: 'Βεβαιωθείτε ότι η οπτική διαδρομή είναι ακριβής. Ελέγξτε κατά την πρώτη αποσυσκευασία.',
        name: 'Επιθεώρηση οπτικής διαδρομής',
      },
      screen: {
        keyPoints: 'Καθαρίστε τη σκόνη και το λίπος από τον πίνακα.',
        name: 'Καθαρισμός οθόνης',
      },
      tube: {
        keyPoints: 'Αν το ακρυλικό 3 mm δεν κόβεται στο 70% της ισχύος, αντικαταστήστε τον σωλήνα.',
        name: 'Έλεγχος υγείας σωλήνα λέιζερ',
      },
      water: {
        keyPoints: 'Προσθέστε νερό μέχρι να γεμίσει πάνω από 80% χωρίς φυσαλίδες αέρα.',
        name: 'Αντικατάσταση νερού ψύξης',
      },
      worktable: {
        keyPoints: 'Ψεκάστε οινόπνευμα σε ένα χαρτομάντιλο και μετά σκουπίστε την επιφάνεια εργασίας.',
        name: 'Καθαρισμός επιφάνειας εργασίας',
      },
      zaxis: {
        keyPoints: 'Σκουπίστε τον κοχλία της κολώνας του άξονα Z και μετά απλώστε ομοιόμορφα λιπαντικό με μια μπατονέτα.',
        name: 'Λίπανση κολώνας άξονα Z',
      },
    },
    title: 'Λίστα συντήρησης',
  },
  material_test_generator: {
    block_settings: 'Ρυθμίσεις Μπλοκ',
    columns: 'Στήλες',
    count: 'Ποσότητα',
    cut: 'Κοπή',
    engrave: 'Χάραξη',
    export: 'Εξαγωγή',
    max: 'Μέγ',
    min: 'Ελάχ',
    parameter: 'Παράμετρος',
    rows: 'Σειρές',
    size: 'Μέγεθος (ΥxΠ)',
    spacing: 'Απόσταση',
    table_settings: 'Ρυθμίσεις Πίνακα',
    text_settings: 'Ρυθμίσεις κειμένου',
    title: 'Γεννήτρια Δοκιμής Υλικού',
  },
  menu: {
    inches: 'Ίντσες',
    mm: 'χιλιοστά',
  },
  message: {
    auth_error: '#820 Σφάλμα έγκρισης: Παρακαλώ ενημερώστε το Beam Studio και το υλικολογισμικό της μηχανής στην πιο πρόσφατη έκδοση.',
    authenticating: 'Πιστοποίηση σε εξέλιξη...',
    auto_focus: {
      instruction: 'Παρακαλώ μετακινήστε το κεφάλι του λέιζερ πάνω από το αντικείμενο και ακολουθήστε τις οδηγίες κίνησης για να πατήσετε AF για να εστιάσετε.',
      succeeded: 'Επιτυχής εστίαση',
      title: 'Αυτόματη εστίαση',
      warning_at_coordinates: 'Μετά την είσοδο στη λειτουργία αυτόματης εστίασης, η κεφαλή λέιζερ θα επαναφερθεί και θα μετακινηθεί στην καθορισμένη θέση για εστίαση.\nΒεβαιωθείτε ότι η θέση-στόχος είναι στο υλικό και ότι δεν υπάρχουν εμπόδια στη διαδρομή κίνησης.',
    },
    backend_calculation: {
      analyzing_svg: 'Ανάλυση SVG - %d%% ...',
      calculating_task_path: 'Υπολογισμός διαδρομής εργασίας - %d%% ...',
      finishing: 'Ολοκλήρωση...',
      initializing: 'Αρχικοποίηση...',
    },
    camera: {
      abort_preview: 'Ακύρωση',
      calibration_data_missing: 'Ρύθμιση βαθμονόμησης κάμερας',
      calibration_data_missing_message: 'Λείπουν τα δεδομένα βαθμονόμησης κάμερας.\nΕισαγάγετε τα αποθηκευμένα δεδομένα βαθμονόμησης ή εκτελέστε βαθμονόμηση κάμερας.',
      calibration_wide_angle_camera_first: 'Παρακαλώ βαθμονομήστε πρώτα την ευρυγώνια κάμερα.',
      camera_cable_unstable: 'Ανιχνεύθηκε ασταθής μετάδοση εικόνας από την κάμερα. Η προεπισκόπηση μπορεί ακόμα να εκτελεστεί κανονικά, αλλά μπορεί να υπάρχει πρόβλημα αργής προεπισκόπησης ή λήξης χρονικού ορίου.',
      continue_preview: 'Συνέχεια',
      door_opened: 'Η πόρτα είναι ανοιχτή',
      door_opened_text: 'Παρακαλώ κλείστε την πόρτα πριν επανεκκινήσετε την προεπισκόπηση κάμερας.',
      fail_to_transmit_image: '#845 Κάτι πήγε στραβά με τη μετάδοση εικόνας. Παρακαλώ επανεκκινήστε το μηχάνημά σας ή το Beam Studio. Αν αυτό το σφάλμα επιμένει, ακολουθήστε τον οδηγό.',
      switching_camera: 'Αλλαγή κάμερας...',
      wide_angle_open_door: 'Ανοίξτε το κάλυμμα της πόρτας',
      wide_angle_open_door_text: 'Ανοίξτε το κάλυμμα της πόρτας πριν μεταβείτε στην ευρυγώνια κάμερα.',
      ws_closed_unexpectedly: '#844 Η σύνδεση με την κάμερα του μηχανήματος έχει κλείσει απροσδόκητα. Αν αυτό το σφάλμα επιμένει, ακολουθήστε τον οδηγό.',
    },
    cancelling: 'Ακύρωση...',
    cant_connect_to_device: '#827 Αδυναμία σύνδεσης με τη μηχανή, παρακαλώ ελέγξτε τη σύνδεσή σας',
    connected: 'Συνδέθηκε',
    connecting: 'Σύνδεση...',
    connectingCamera: 'Σύνδεση κάμερας...',
    connectingMachine: 'Σύνδεση με %s...',
    connectionTimeout: '#805 Χρονικό όριο σύνδεσης συσκευής. Ελέγξτε την κατάσταση του δικτύου σας και τον δείκτη Wi-Fi του μηχανήματός σας.',
    device_blocked: {
      caption: 'Μη εξουσιοδοτημένος αριθμός σειράς',
      offline: 'Ο σειριακός αριθμός της συσκευής σας περιορίζεται στη χρήση εκτός σύνδεσης καθώς φαίνεται να είναι απενεργοποιημένος. Παρακαλούμε να δώσετε τον σειριακό αριθμό της συσκευής (που βρίσκεται στο πίσω μέρος της συσκευής) στον έμπορό σας και να τους ζητήσετε να επικοινωνήσουν με το support@flux3dp.com για να ενεργοποιηθεί η εξουσιοδότηση σύνδεσης. Εάν θέλετε να χρησιμοποιήσετε τη συσκευή εκτός σύνδεσης, επικοινωνήστε απευθείας με το support@flux3dp.com.',
      online: 'Ο σειριακός αριθμός της συσκευής σας φαίνεται να είναι απενεργοποιημένος. Παρακαλούμε να δώσετε τον σειριακό αριθμό της συσκευής (που βρίσκεται στο πίσω μέρος της συσκευής) στον έμπορό σας και να τους ζητήσετε να επικοινωνήσουν με το support@flux3dp.com για να ενεργοποιηθεί η εξουσιοδότηση της συσκευής.',
    },
    device_busy: {
      caption: 'Η συσκευή είναι απασχολημένη',
      message: 'Η συσκευή εκτελεί άλλη εργασία, δοκιμάστε αργότερα. Αν σταματήσει να λειτουργεί, επανεκκινήστε τη συσκευή.',
    },
    device_is_used: 'Η συσκευή χρησιμοποιείται, θέλετε να ακυρώσετε την τρέχουσα εργασία;',
    device_not_found: {
      caption: 'Δεν βρέθηκε προεπιλεγμένη συσκευή',
      message: '#812 Ελέγξτε την ένδειξη Wi-Fi της συσκευής σας',
    },
    disconnected: 'Ασταθής σύνδεση, παρακαλώ ελέγξτε τη σύνδεση της συσκευής και δοκιμάστε ξανά αργότερα',
    endingLineCheckMode: 'Έξοδος από τη λειτουργία ελέγχου γραμμής...',
    endingRawMode: 'Έξοδος από τη λειτουργία ελέγχου μηχανήματος...',
    enteringLineCheckMode: 'Είσοδος σε λειτουργία ελέγχου γραμμής...',
    enteringRawMode: 'Είσοδος σε λειτουργία ελέγχου μηχανήματος...',
    enteringRedLaserMeasureMode: 'Είσοδος σε λειτουργία μέτρησης με κόκκινο λέιζερ...',
    exitingRotaryMode: 'Έξοδος από τη λειτουργία περιστροφής...',
    getProbePosition: 'Λήψη θέσης Αισθητήρα...',
    gettingLaserSpeed: 'Ανάγνωση ταχύτητας κεφαλής λέιζερ...',
    homing: 'Ομοιοποίηση...',
    mac_os_arch_mismatch: {
      caption: 'Επανεγκατάσταση συμβατής έκδοσης',
      download_center: 'Κέντρο Λήψεων',
      message: 'Αυτό το Mac χρησιμοποιεί Apple Silicon. Κατεβάστε την έκδοση Apple Silicon και επανεγκαταστήστε.',
    },
    need_password: 'Απαιτείται κωδικός πρόσβασης για σύνδεση με τη συσκευή',
    please_enter_dpi: 'Παρακαλώ εισάγετε τη μονάδα του αρχείου σας (σε mm)',
    preview: {
      adjust: 'Προσαρμογή',
      adjust_height_tooltip: 'Κάντε κλικ στο πλαίσιο ελέγχου για να ενεργοποιήσετε την επεξεργασία.',
      already_performed_auto_focus: 'Έχετε ήδη εκτελέσει αυτόματη εστίαση, να χρησιμοποιήσετε τις υπάρχουσες ρυθμίσεις;',
      camera_preview: 'Προεπισκόπηση κάμερας',
      capturing_image: 'Λήψη εικόνας...',
      enter_manually: 'Εισαγωγή χειροκίνητα',
      getting_focal_distance: 'Λήψη εστιακής απόστασης...',
      moving_to_preview_position: 'Μετακίνηση στη θέση προεπισκόπησης...',
      please_enter_height: 'Παρακαλώ εισάγετε το ύψος του αντικειμένου για ακριβή λήψη κάμερας.',
      please_focus_before_preview: 'Για καλύτερη ποιότητα προεπισκόπησης, εκτελέστε αυτόματη εστίαση πριν την προεπισκόπηση.',
      press_esc_to_stop: 'Πατήστε ESC για να σταματήσετε την προεπισκόπηση της κάμερας.',
      succeeded: 'Επιτυχής προεπισκόπηση',
    },
    promark_disconnected: '#850 Η σύνδεση με τη συσκευή διακόπηκε, ελέγξτε την κατάσταση σύνδεσης της συσκευής.',
    redLaserTakingReference: 'Λήψη αναφοράς...',
    retrievingCameraOffset: 'Ανάγνωση μετατόπισης κάμερας...',
    settingLaserSpeed: 'Ρύθμιση ταχύτητας κεφαλής λέιζερ...',
    swiftray_disconnected: 'Δεν είναι δυνατή η σύνδεση με το backend, προσπάθεια επανασύνδεσης.',
    swiftray_reconnected: 'Το backend επανασυνδέθηκε, δοκιμάστε να στείλετε ξανά την εργασία.',
    time_remaining: 'Υπολειπόμενος χρόνος:',
    tryingToConenctMachine: 'Προσπάθεια σύνδεσης με το μηχάνημα...',
    turningOffAirPump: 'Απενεργοποίηση αντλίας αέρα...',
    turningOffFan: 'Απενεργοποίηση ανεμιστήρα...',
    unable_to_find_machine: 'Αδυναμία εύρεσης μηχανής',
    unable_to_start: '#830 Αδυναμία έναρξης της εργασίας. Παρακαλώ δοκιμάστε ξανά. Αν συμβεί ξανά, επικοινωνήστε μαζί μας με αναφορά σφαλμάτων:',
    unavailableWorkarea: '#804 Η τρέχουσα περιοχή εργασίας υπερβαίνει την περιοχή εργασίας αυτής της μηχανής. Παρακαλώ ελέγξτε την περιοχή εργασίας της επιλεγμένης μηχανής ή ορίστε την περιοχή εργασίας από Επεξεργασία > Ρυθμίσεις εγγράφου.',
    unknown_device: '#826 Δεν είναι δυνατή η σύνδεση με τη συσκευή, βεβαιωθείτε ότι το USB είναι συνδεδεμένο με τη συσκευή',
    unknown_error: '#821 Η εφαρμογή συνάντησε άγνωστο σφάλμα, χρησιμοποιήστε Βοήθεια > Μενού > Αναφορά σφαλμάτων.',
    unsupport_osx_version: 'Η τρέχουσα έκδοση macOS %s ενδέχεται να μην υποστηρίζει ορισμένες λειτουργίες. Ενημερώστε παρακαλώ σε macOS 13+.',
    unsupport_win_version: 'Η τρέχουσα έκδοση λειτουργικού συστήματος %s ενδέχεται να μην υποστηρίζει ορισμένες λειτουργίες. Ενημερώστε παρακαλώ στην πιο πρόσφατη έκδοση.',
    unsupported_example_file: 'Το επιλεγμένο παράδειγμα αρχείου δεν υποστηρίζεται από την τρέχουσα περιοχή εργασίας.',
    uploading_fcode: 'Μεταφόρτωση FCode',
    usb_unplugged: 'Η σύνδεση USB έχει χαθεί. Παρακαλώ ελέγξτε τη σύνδεση USB σας',
    wrong_swiftray_version_message: 'Λανθασμένη έκδοση backend (έκδοση: {version}). Ελέγξτε εάν εκτελούνται πολλαπλές εμφανίσεις του Beam Studio και κλείστε τις περιττές πριν ξαναπροσπαθήσετε.',
    wrong_swiftray_version_title: 'Λανθασμένη έκδοση backend',
  },
  monitor: {
    ask_reconnect: 'Η σύνδεση με τη μηχανή διακόπηκε. Θέλετε να συνδεθείτε ξανά;',
    bug_report: 'Αναφορά Σφαλμάτων',
    camera: 'Κάμερα',
    cancel: 'Ακύρωση',
    confirmFileDelete: 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το αρχείο;',
    connecting: 'Σύνδεση, παρακαλώ περιμένετε...',
    DEVICE_ERROR: 'Κάτι πήγε στραβά\\nΠαρακαλώ επανεκκινήστε το μηχάνημα',
    download: 'Λήψη',
    extensionNotSupported: 'Αυτή η μορφή αρχείου δεν υποστηρίζεται',
    fileExistContinue: 'Το αρχείο υπάρχει ήδη, θέλετε να το αντικαταστήσετε;',
    forceStop: 'Θέλετε να ακυρώσετε την τρέχουσα εργασία;',
    go: 'Έναρξη',
    HARDWARE_ERROR_AIR_ASSIST_ABNORMAL: '#913 Αισθητήρας ροής αέρα ανώμαλος',
    HARDWARE_ERROR_BOTTOM_OPENED: '#903 Το κάτω μέρος άνοιξε. Κλείστε το κάτω μέρος για να συνεχίσετε.',
    HARDWARE_ERROR_CARTRIDGE_OVERHEAT: '#931 Ειδοποίηση θερμοκρασίας δοχείου μελάνης\nΗ θερμοκρασία του δοχείου μελάνης υπερβαίνει το κανονικό εύρος.\nΓια προστασία, η εργασία διακόπηκε. Παρακαλώ επανεγκαταστήστε το δοχείο μελάνης και επανεκκινήστε την εργασία.',
    HARDWARE_ERROR_CARTRIDGE_POWERON_FAILED: '#930 Επανεγκαταστήστε το δοχείο μελάνης\nΕντοπίστηκε κακή σύνδεση στο δοχείο μελάνης. Παρακαλώ επανεγκαταστήστε το δοχείο μελάνης και δοκιμάστε ξανά.',
    HARDWARE_ERROR_COVER_NOT_CLOSED: '#924 Αποτυχία εγκατάστασης καλύμματος κεφαλής εκτύπωσης',
    HARDWARE_ERROR_COVER_NOT_OPENED: '#925 Αποτυχία αφαίρεσης καλύμματος κεφαλής εκτύπωσης',
    HARDWARE_ERROR_DOOR_OPENED: '#901 Κλείστε την πόρτα για να συνεχίσετε.',
    HARDWARE_ERROR_DRAWER_OPENED: '#911 Το συρτάρι άνοιξε',
    HARDWARE_ERROR_FIRE_DETECTED: '#912 Ανώμαλος αισθητήρας φλόγας',
    HARDWARE_ERROR_HEADTYPE_MISMATCH: '#915 Εντοπίστηκε λανθασμένη κεφαλή. Παρακαλώ εγκαταστήστε τη σωστή κεφαλή για να συνεχίσετε.',
    HARDWARE_ERROR_HEADTYPE_NONE: '#917 Δεν εντοπίστηκε κεφαλή. Παρακαλώ βεβαιωθείτε ότι η κεφαλή έχει εγκατασταθεί σωστά για να συνεχίσετε.',
    HARDWARE_ERROR_HEADTYPE_UNKNOWN: '#918 Εντοπίστηκε άγνωστη κεφαλή. Παρακαλώ εγκαταστήστε τη σωστή κεφαλή για να συνεχίσετε.',
    HARDWARE_ERROR_HOMING_PULLOFF_FAILED: '#920 Σφάλμα Ομαλής Εκκίνησης',
    HARDWARE_ERROR_KEY_OFF: '#929 Δεν εντοπίστηκε κλειδί ασφαλείας\nΤο κλειδί ασφαλείας δεν εντοπίζεται ή έχει απενεργοποιηθεί. Για την ασφάλειά σας, το μηχάνημα δεν μπορεί να λειτουργήσει μέχρι να ενεργοποιηθεί σωστά το κλειδί.\nΠαρακαλώ τοποθετήστε το κλειδί ασφαλείας και ενεργοποιήστε το πριν επανεκκινήσετε την εργασία.',
    HARDWARE_ERROR_LASER_TEMPERATURE_ABNORMAL: '#933 Ανώμαλη θερμοκρασία λέιζερ\nΗ θερμοκρασία του λέιζερ είναι πολύ υψηλή. Παρακαλώ σταματήστε τη λειτουργία και αφήστε το λέιζερ να κρυώσει πριν επανεκκινήσετε.',
    HARDWARE_ERROR_LASER_VOLTAGE_ABNORMAL: '#932 Ανώμαλη τάση λέιζερ\nΣφάλμα τάσης λέιζερ. Παρακαλώ επανεκκινήστε το μηχάνημα. Εάν το πρόβλημα παραμένει, επικοινωνήστε με την υποστήριξη πελατών.',
    HARDWARE_ERROR_MAINBOARD_ERROR: '#401 Κρίσιμο σφάλμα: Το κύριο τμήμα εκτός σύνδεσης. Παρακαλούμε επικοινωνήστε με την υποστήριξη.',
    HARDWARE_ERROR_MAINBOARD_NO_RESPONSE: '#928 Η κύρια πλακέτα δεν ανταποκρίνεται\nΗ κύρια πλακέτα δεν ανταποκρίνεται. Παρακαλώ επανεκκινήστε την εργασία.',
    HARDWARE_ERROR_OVER_TEMPERATURE: '#902 Υπερθερμάνθηκε. Παρακαλώ περιμένετε λίγα λεπτά.',
    HARDWARE_ERROR_PLATFORM_HOMING_FAILED: '#910 Αποτυχία επαναφοράς άξονα z',
    HARDWARE_ERROR_PRINTER_NO_RESPONSE: '#919 Καμία απόκριση από τη μονάδα εκτύπωσης.',
    HARDWARE_ERROR_PROBE_SHOWED: 'Παρακαλώ ανασύρετε τον ανιχνευτή.',
    HARDWARE_ERROR_PUMP_ERROR: '#900 Χαμηλή ροή ψυκτικού. Παρακαλώ ελέγξτε τη δεξαμενή νερού σας.',
    HARDWARE_ERROR_REMOTE_INTERLOCK_OPENED: '#927 Ενεργοποίηση απομακρυσμένου διακόπτη ασφαλείας\nΠαρακαλώ ελέγξτε τον σύνδεσμο του απομακρυσμένου διακόπτη ασφαλείας και βεβαιωθείτε ότι είναι σωστά συνδεδεμένος πριν επανεκκινήσετε την εργασία.',
    HARDWARE_ERROR_ROTARY_NOT_DETECTED: '#914 Δεν εντοπίστηκε μονάδα περιστροφής',
    HARDWARE_ERROR_SUBSYSTEM_ERROR: '#402 Κρίσιμο σφάλμα: Το υποσύστημα δεν απαντά. Παρακαλούμε επικοινωνήστε με την υποστήριξη.',
    HARDWARE_FAILURE: 'Κάτι πήγε στραβά. Παρακαλώ επανεκκινήστε το μηχάνημα',
    hour: 'ώ',
    left: 'αριστερά',
    MAINBOARD_OFFLINE: '#905 Σφάλμα κατά τη σύνδεση με την κεντρική πλακέτα. Παρακαλώ επανεκκινήστε το μηχάνημα.',
    minute: 'λ',
    monitor: 'Παρακολούθηση',
    NO_RESPONSE: '#905 Σφάλμα κατά τη σύνδεση με την κεντρική πλακέτα.\\nΠαρακαλώ επανεκκινήστε το μηχάνημα.',
    no_task_info: 'Δεν υπάρχουν προς το παρόν εργασίες για εμφάνιση.',
    pause: 'Παύση',
    prepareRelocate: 'Προετοιμασία για μετεγκατάσταση',
    processing: 'Επεξεργασία',
    record: 'Εγγραφή',
    relocate: 'Μετεγκατάσταση',
    RESOURCE_BUSY: 'Το μηχάνημα είναι απασχολημένο\\nΑν δεν λειτουργεί, παρακαλώ επανεκκινήστε το μηχάνημα',
    resume: 'Συνέχεια',
    savingPreview: 'Δημιουργία προεπισκοπήσεων',
    second: 'δ',
    start: 'Έναρξη',
    stop: 'Διακοπή',
    SUBSYSTEM_ERROR: '#402 Κρίσιμο Σφάλμα: Καμία απόκριση υποσυστήματος. Παρακαλώ επικοινωνήστε με την υποστήριξη.',
    task: {
      BEAMBOX: 'Χάραξη με λέιζερ',
      'N/A': 'Ελεύθερη λειτουργία',
    },
    taskTab: 'Εργασία',
    temperature: 'Θερμοκρασία',
    upload: 'Μεταφόρτωση',
    USER_OPERATION: 'Ακολουθήστε τις οδηγίες στο πίνακα της συσκευής για να συνεχίσετε.',
    USER_OPERATION_CARTRIDGE_INK_EMPTY: 'Κενή κασέτα\nΗ κασέτα δεν έχει μελάνι. Αντικαταστήστε την κασέτα για να συνεχίσετε την εκτύπωση.',
    USER_OPERATION_CARTRIDGE_INK_LOW: 'Χαμηλή στάθμη μελανιού\nΤο μελάνι στην κασέτα εξαντλείται. Συνιστούμε να αντικαταστήσετε την κασέτα σύντομα.',
    USER_OPERATION_CHANGE_CARTRIDGE: 'Παρακαλούμε εισάγετε τη σωστή κάρτα για να συνεχίσετε.',
    USER_OPERATION_CHANGE_CARTRIDGE_CARTRIDGE_NOT_DETECTED: 'Παρακαλούμε εισάγετε την κάρτα για να συνεχίσετε.',
    USER_OPERATION_CHANGE_TOOLHEAD: 'Παρακαλώ εγκαταστήστε τη σωστή κεφαλή για να συνεχίσετε.',
    USER_OPERATION_CHANGE_TOOLHEAD_HEADTYPE_MISMATCH: '#915 Εντοπίστηκε λανθασμένη κεφαλή. Παρακαλώ εγκαταστήστε τη σωστή κεφαλή για να συνεχίσετε.',
    USER_OPERATION_CHANGE_TOOLHEAD_HEADTYPE_NONE: '#917 Δεν εντοπίστηκε κεφαλή. Παρακαλώ βεβαιωθείτε ότι η κεφαλή έχει εγκατασταθεί σωστά για να συνεχίσετε.',
    USER_OPERATION_CHANGE_TOOLHEAD_HEADTYPE_UNKNOWN: '#918 Εντοπίστηκε άγνωστη κεφαλή. Παρακαλώ εγκαταστήστε τη σωστή κεφαλή για να συνεχίσετε.',
    USER_OPERATION_REMOVE_CARTRIDGE: 'Παρακαλώ αφαιρέστε την κασέτα για να συνεχίσετε.',
    USER_OPERATION_ROTARY_PAUSE: 'Παρακαλώ αλλάξτε στον περιστροφικό κινητήρα.',
    USER_OPERATION_USER_Z_AXIS_CHECK_REQUIRED: 'Υπενθύμιση εστίασης\nΕστιάστε ξανά πριν ξεκινήσετε μια νέα εργασία για να διασφαλίσετε ακριβή αποτελέσματα.',
  },
  my_cloud: {
    action: {
      confirmFileDelete: 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το αρχείο; Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.',
      delete: 'Διαγραφή',
      download: 'Λήψη',
      duplicate: 'Αντίγραφο',
      open: 'Άνοιγμα',
      rename: 'Μετονομασία',
    },
    file_limit: 'δωρεάν αρχείο',
    loading_file: 'Φόρτωση...',
    no_file_subtitle: 'Μεταβείτε στο Μενού > "Αρχείο" > "Αποθήκευση στο Cloud"',
    no_file_title: 'Αποθηκεύστε αρχεία στο My Cloud για να ξεκινήσετε.',
    not_login_title: 'Συνδεθείτε για να αποθηκεύσετε τα αρχεία σας στο cloud.',
    save_file: {
      choose_action: 'Αποθήκευση αρχείου:',
      input_file_name: 'Εισαγωγή ονόματος αρχείου:',
      invalid_char: 'Μη έγκυροι χαρακτήρες:',
      save: 'Αποθήκευση',
      save_new: 'Αποθήκευση ως νέο αρχείο',
      storage_limit_exceeded: 'Η αποθήκευση στο cloud σας έχει φτάσει στο ανώτατο όριο. Παρακαλώ διαγράψτε τυχόν περιττά αρχεία πριν αποθηκεύσετε νέα.',
    },
    sort: {
      a_to_z: 'Όνομα: Α - Ω',
      most_recent: 'Πιο πρόσφατα',
      oldest: 'Παλαιότερα',
      z_to_a: 'Όνομα: Ω - Α',
    },
    title: 'Το Cloud μου',
    upgrade: 'Αναβάθμιση',
  },
  noun_project_panel: {
    clear: 'Καθαρισμός',
    elements: 'Στοιχεία',
    enjoy_shape_library: 'Απολαύστε τη βάση δεδομένων σχημάτων.',
    export_svg_title: 'Αδυναμία εξαγωγής SVG',
    export_svg_warning: 'Αυτό το έργο περιέχει αντικείμενα που προστατεύονται από το νόμο περί πνευματικής ιδιοκτησίας. Επομένως, το Beam Studio θα εξαιρέσει αυτόματα αυτά τα αντικείμενα κατά την εξαγωγή. Μπορείτε ακόμα να αποθηκεύσετε το έργο σας σε μορφή Beam Studio Scene (.beam) για να διατηρήσετε όλα τα δεδομένα σας. Θέλετε ακόμα να εξαγάγετε;',
    learn_more: 'Μάθετε περισσότερα',
    login_first: 'Συνδεθείτε για να ξεκλειδώσετε τη βάση δεδομένων σχημάτων.',
    recent: 'Πρόσφατα',
    search: 'Αναζήτηση',
    shapes: 'Σχήματα',
  },
  pass_through: {
    export: 'Εξαγωγή στην Περιοχή Εργασίας',
    exporting: 'Εξαγωγή...',
    guide_mark: 'Σημείο Οδηγού',
    guide_mark_desc: 'Τα σημεία οδηγού θα χαραχθούν ως σημείο αναφοράς για την ευθυγράμμιση του έργου τέχνης.',
    guide_mark_length: 'Μήκος:',
    guide_mark_x: 'Συντεταγμένη Χ:',
    height_desc: 'Ρυθμίστε το ύψος κάθε τμήματος της περιοχής εργασίας.',
    help_links: {
      ado1: 'https://support.flux3dp.com/hc/en-us/articles/10140002160399',
      fbb2: 'https://support.flux3dp.com/hc/en-us/articles/11570021253263',
    },
    help_text: 'Πώς να ρυθμίσετε τη διέλευση για το %(model)s;',
    object_length: 'Μήκος Αντικειμένου',
    ref_layer: 'Επίπεδο Αναφοράς',
    ref_layer_desc: 'Σημειώστε ότι η εκτέλεση του επιπέδου αναφοράς έχει οριστεί σε 0 από προεπιλογή. Δεν θα εκτελεστεί, αλλά είναι μόνο για αναφορά ευθυγράμμισης.',
    ref_layer_name: 'Αναφορά',
    title: 'Λειτουργία διέλευσης',
    workarea_height: 'Περιοχή Εργασίας (Ύψος):',
  },
  promark_connection_test: {
    description: 'Το σύστημα θα εκτελέσει μια λειτουργία κόκκινου φωτός για περίπου δύο λεπτά για να ελέγξει εάν η σύνδεση είναι σταθερή.',
    health: 'Σταθερότητα:',
    healthy_description: 'Η σταθερότητα είναι καλή, αλλά αποφύγετε σημαντικές μετακινήσεις του υπολογιστή κατά τη χάραξη.',
    res_0: 'Εξαιρετική',
    res_1: 'Καλή',
    res_2: 'Χαμηλή',
    res_3: 'Πολύ χαμηλή',
    res_4: 'Εξαιρετικά χαμηλή',
    restart: 'Επανεκκίνηση δοκιμής',
    start: 'Έναρξη δοκιμής',
    stop: 'Διακοπή δοκιμής',
    title: 'Δοκιμή σταθερότητας σύνδεσης',
    unhealthy_description: 'Η σταθερότητα είναι πολύ χαμηλή. Συνιστάται η αντικατάσταση του προσαρμογέα δικτύου ή του καλωδίου τροφοδοσίας.',
  },
  promark_settings: {
    angle: 'Γωνία',
    bulge: 'Εξόγκωμα',
    field: 'Πεδίο',
    galvo_configuration: 'Ρυθμίσεις Galvo',
    mark: 'Σήμανση',
    mark_parameters: 'Παράμετροι χάραξης',
    offsetX: 'Μετατόπιση X',
    offsetY: 'Μετατόπιση Y',
    red_dot: 'Κόκκινη κουκκίδα',
    scale: 'Κλίμακα',
    scaleX: 'Κλίμακα X',
    scaleY: 'Κλίμακα Y',
    skew: 'Κλίση',
    switchXY: 'Εναλλαγή X/Y',
    title: 'Ρυθμίσεις Promark',
    trapezoid: 'Τραπέζιο',
    workarea_hint: 'Μπορείτε να αλλάξετε την περιοχή εργασίας στις "Ρυθμίσεις Εγγράφου".',
    z_axis_adjustment: {
      section1: 'Ρυθμίστε το ύψος του άξονα Ζ για να βελτιώσετε την εστίαση.',
      title: 'Ρύθμιση Άξονα Ζ',
      tooltip1: 'Δοκιμάστε να μαρκάρετε ένα τετράγωνο 1x1 εκ. για να επιβεβαιώσετε αν η τρέχουσα εστιακή απόσταση είναι κατάλληλη.',
    },
  },
  puzzle_generator: {
    bleed: 'Περικοπή',
    board_base: 'Βάση πλάκας',
    board_radius: 'Ακτίνα πλαισίου',
    board_width: 'Πλάτος πλαισίου',
    change_image: 'Κάντε κλικ για αλλαγή εικόνας',
    columns: 'Στήλες',
    design_preview: 'Προεπισκόπηση σχεδίου',
    exploded_view: 'Διασπασμένη προβολή',
    export_as: 'Εξαγωγή ως',
    export_engrave: 'Επίπεδο χάραξης',
    export_failed: 'Αποτυχία εισαγωγής παζλ στον καμβά. Δοκιμάστε ξανά ή προσαρμόστε τις ρυθμίσεις παζλ.',
    export_none: 'Κανένα',
    export_print: 'Επίπεδο εκτύπωσης',
    file_too_large: 'Το επιλεγμένο αρχείο υπερβαίνει το μέγιστο επιτρεπόμενο μέγεθος.',
    guide_lines: 'Γραμμές οδηγού',
    heart_sharpness: 'Οξύτητα αιχμής',
    image: 'Εικόνα',
    image_load_failed: 'Αποτυχία φόρτωσης της επιλεγμένης εικόνας. Δοκιμάστε ένα άλλο αρχείο.',
    image_resolution_warning: 'Η ανάλυση εικόνας υπερβαίνει τα %(resolution)spx. Αυτό μπορεί να επηρεάσει την ποιότητα εξαγωγής ή την απόδοση.',
    import_to_canvas: 'Εισαγωγή στον καμβά',
    layers: {
      board_base: 'Βάση πλακέτας',
      guide_lines: 'Γραμμές οδηγοί',
      image: 'Εικόνα παζλ',
      pieces: 'Κομμάτια παζλ',
      raised_edges: 'Ανυψωμένα άκρα',
    },
    offset_x: 'Μετατόπιση X',
    offset_y: 'Μετατόπιση Y',
    orientation: 'Προσανατολισμός κομματιών',
    orientation_type_1: 'Τύπος 1',
    orientation_type_2: 'Τύπος 2',
    orientation_type_3: 'Τύπος 3',
    orientation_type_4: 'Τύπος 4',
    piece_size: 'Μέγεθος κομματιών',
    preview_placeholder: 'Προεπισκόπηση παζλ',
    puzzle_board: 'Πλάκα παζλ',
    puzzle_pieces: 'Κομμάτια παζλ',
    radius: 'Ακτίνα',
    raised_edges: 'Ανυψωμένα άκρα',
    reset_to_default: 'Επαναφορά στις προεπιλογές',
    rows: 'Γραμμές',
    switch_type_warning: 'Οι τρέχουσες ρυθμίσεις σας δεν έχουν ακόμη εισαχθεί στον καμβά.\nΗ αλλαγή τύπου παζλ θα επαναφέρει όλες τις ρυθμίσεις στις προεπιλογές.',
    tab_size: 'Μέγεθος καρτέλας',
    types: {
      circle_jigsaw: 'Κυκλικό παζλ',
      heart_jigsaw: 'Παζλ σε σχήμα καρδιάς',
      hex_jigsaw: 'Εξαγωνικό παζλ',
      rectangle_jigsaw: 'Ορθογώνιο παζλ',
    },
    unsupported_file_type: 'Μη υποστηριζόμενος τύπος αρχείου. Χρησιμοποιήστε JPG, PNG ή WebP.',
    upload_hint: 'JPG, PNG, WebP (μέγ. 10MB)',
    upload_image: 'Κάντε κλικ ή σύρετε για μεταφόρτωση',
    zoom: 'Ζουμ',
  },
  qr_code_generator: {
    error_tolerance: 'Ανοχή σφάλματος',
    error_tolerance_link: 'https://support.flux3dp.com/hc/en-us/articles/9113705072143',
    invert: 'Αντιστροφή χρωμάτων φόντου',
    placeholder: 'Εισαγωγή κειμένου',
    title: 'Δημιουργός κωδικού QR',
  },
  resolution: {
    title: 'Ανάλυση',
    values: {
      detailed: 'Εξαιρετικά Λεπτό',
      high: 'Λεπτό',
      low: 'Προσχέδιο',
      medium: 'Τυπικό',
      mixed: 'Μικτό',
      ultra: 'Ultra HD',
    },
  },
  rotary_settings: {
    circumference: 'Περιφέρεια',
    extend_workarea: 'Επέκταση περιοχής εργασίας',
    mirror: 'Κατοπτρισμός',
    object_diameter: 'Διάμετρος Αντικειμένου',
    overlap_size: 'Μέγεθος επικάλυψης',
    rotary_scale: 'Κλίμακα περιστροφής',
    split_setting: 'Ρύθμιση διαίρεσης',
    split_setting_url: 'https://support.flux3dp.com/hc/en-us/articles/12276094010767',
    split_size: 'Μέγεθος διαίρεσης',
    type: 'τύπος',
  },
  select_device: {
    auth_failure: '#811 Αποτυχία πιστοποίησης',
    select_device: 'Επιλέξτε συσκευή',
    unable_to_connect: '#810 Αδυναμία δημιουργίας σταθερής σύνδεσης με τη μηχανή',
  },
  settings: {
    anti_aliasing: 'Αντι-aliasing',
    auto_connect: 'Αυτόματη επιλογή μοναδικής συσκευής',
    auto_switch_tab: 'Αυτόματη εναλλαγή μεταξύ πίνακα επιπέδων και αντικειμένων',
    autofocus_offset: 'Αντιστάθμιση αυτόματης εστίασης',
    autosave_enabled: 'Αυτόματη αποθήκευση',
    autosave_interval: 'Αυτόματη αποθήκευση κάθε',
    autosave_number: 'Αριθμός αυτόματων αποθηκεύσεων',
    autosave_path: 'Τοποθεσία αυτόματης αποθήκευσης',
    autosave_path_not_correct: 'Η καθορισμένη διαδρομή δεν βρέθηκε.',
    blade_precut_position: 'Θέση προκοπής',
    blade_precut_switch: 'Προκοπή λεπίδας',
    blade_radius: 'Ακτίνα λεπίδας',
    bottom_up: 'Από κάτω προς τα πάνω',
    calculation_optimization: 'Επιτάχυνση υπολογισμού διαδρομής',
    cancel: 'Ακύρωση',
    caption: 'Ρυθμίσεις',
    check_updates: 'Αυτόματος έλεγχος ενημερώσεων',
    close: 'Κλείσιμο',
    confirm_remove_default: 'Το προεπιλεγμένο μηχάνημα θα αφαιρεθεί.',
    confirm_reset: 'Επιβεβαίωση επαναφοράς Beam Studio',
    continuous_drawing: 'Συνεχής σχεδίαση',
    crop_task_thumbnail: 'Μικρογραφία περικομμένου περιεχομένου',
    crop_task_thumbnail_tooltip: 'Εμφανίστε μόνο τη μικρογραφία της περιοχής που περιέχει περιεχόμενο, εξαιρώντας τα κενά μέρη του καμβά.',
    custom_preview_height: 'Προσαρμοσμένο Ύψος Προεπισκόπησης',
    default_beambox_model: 'Προεπιλεγμένη ρύθμιση εγγράφου',
    default_borderless_mode: 'Προεπιλογή Άνοιγμα Κάτω',
    default_enable_autofocus_module: 'Προεπιλογή Αυτόματης Εστίασης',
    default_enable_diode_module: 'Προεπιλογή Διόδου Λέιζερ',
    default_font_family: 'Προεπιλεγμένη γραμματοσειρά',
    default_font_style: 'Προεπιλεγμένο στυλ γραμματοσειράς',
    default_laser_module: 'Προεπιλεγμένη μονάδα λέιζερ',
    default_machine: 'Προεπιλεγμένο μηχάνημα',
    default_machine_button: 'Κενό',
    default_units: 'Προεπιλεγμένες μονάδες',
    diode_offset: 'Αντιστάθμιση λέιζερ διόδου',
    diode_one_way_engraving: 'Μονόδρομη χάραξη λέιζερ διόδου',
    diode_two_way_warning: 'Η αμφίδρομη εκπομπή φωτός είναι ταχύτερη και μπορεί να προκαλέσει ανακρίβεια στη θέση χάραξης λέιζερ. Συνιστάται δοκιμή πρώτα.',
    disabled: 'Απενεργοποιημένο',
    done: 'Εφαρμογή',
    enable_custom_backlash: 'Ενεργοποίηση Προσαρμοσμένης Αντιστάθμισης Οπισθοδρόμησης',
    enable_low_speed: 'Ενεργοποίηση Χαμηλής Ταχύτητας',
    enable_uv_print_file: 'Ενεργοποίηση αρχείου εκτύπωσης UV',
    enabled: 'Ενεργοποιημένο',
    engraving_direction: 'Κατεύθυνση',
    engraving_offset_tooltip: 'Αν το αποτέλεσμα χάραξης μετατοπίζεται προς τα αριστερά ή προς τα πάνω, μειώστε τη μετατόπιση X/Y· αν μετατοπίζεται προς τα δεξιά ή προς τα κάτω, αυξήστε τη μετατόπιση X/Y.',
    fast_gradient: 'Βελτιστοποίηση ταχύτητας',
    font_convert: 'Μετατροπέας κειμένου σε μονοπάτι',
    font_substitute: 'Υποκατάσταση Μη Υποστηριζόμενων Χαρακτήρων',
    grouped_objects: 'Ομαδοποιημένα Αντικείμενα',
    groups: {
      ador_modules: 'Πρόσθετα Ador',
      autosave: 'Αυτόματη αποθήκευση',
      beamo2_modules: 'beamo 2 μονάδες',
      camera: 'Κάμερα',
      connection: 'Σύνδεση',
      editor: 'Επεξεργαστής',
      engraving: 'Χάραξη (σάρωση)',
      general: 'Γενικά',
      mask: 'Περικοπή Περιοχής Εργασίας',
      module_settings: 'Ρυθμίσεις μονάδας',
      module_type: 'Μονάδα μηχανής',
      modules: 'Πρόσθετα',
      path: 'Διανύσματα (Περιγράμματα)',
      performance: 'Απόδοση',
      privacy: 'Ιδιωτικότητα',
      text: 'Κείμενο',
      text_to_path: 'Κείμενο',
      update: 'Ενημερώσεις λογισμικού',
      workarea: 'Περιοχή εργασίας',
    },
    guess_poke: 'Αναζήτηση διεύθυνσης IP συσκευής',
    guides: 'Οδηγοί',
    guides_origin: 'Προέλευση οδηγών',
    help_center_urls: {
      anti_aliasing: 'https://support.flux3dp.com/hc/en-us/articles/360004408956',
      calculation_optimization: 'https://support.flux3dp.com/hc/en-us/articles/11146997425039',
      connection: 'https://support.flux3dp.com/hc/en-us/sections/360000302135',
      continuous_drawing: 'https://support.flux3dp.com/hc/en-us/articles/360004406496',
      default_borderless_mode: 'https://support.flux3dp.com/hc/en-us/articles/360001104076',
      default_enable_autofocus_module: 'https://support.flux3dp.com/hc/en-us/articles/360001574536',
      default_enable_diode_module: 'https://support.flux3dp.com/hc/en-us/articles/360001568035',
      fast_gradient: 'https://support.flux3dp.com/hc/en-us/articles/360004496235',
      font_convert: 'https://support.flux3dp.com/hc/en-us/articles/9132766761743',
      font_substitute: 'https://support.flux3dp.com/hc/en-us/articles/360004496575',
      image_downsampling: 'https://support.flux3dp.com/hc/en-us/articles/360004494995',
      loop_compensation: 'https://support.flux3dp.com/hc/en-us/articles/360004408856',
      mask: 'https://support.flux3dp.com/hc/en-us/articles/360004408876',
      segmented_engraving: 'https://support.flux3dp.com/hc/en-us/articles/12306366019215',
      simplify_clipper_path: 'https://support.flux3dp.com/hc/en-us/articles/360004407276',
      uv_print_export: 'https://support.flux3dp.com/hc/en-us/articles/12320887477135',
      vector_speed_constraint: 'https://support.flux3dp.com/hc/en-us/articles/360004496495',
    },
    high: 'Υψηλή',
    image_downsampling: 'Ποιότητα προεπισκόπησης bitmap',
    ip: 'Διεύθυνση IP συσκευής',
    keep_preview_result: 'Διατήρηση Προεπισκόπησης Αποτελέσματος',
    language: 'Γλώσσα',
    loop_compensation: 'Αντιστάθμιση βρόγχου',
    low: 'Χαμηλό',
    low_laser_for_preview: 'Λέιζερ για Εκτέλεση πλαισίου',
    mask: 'Περικοπή Περιοχής Εργασίας',
    medium: 'Μέτριος',
    module_offset_2w_ir: '2W υπέρυθρης ακτίνας λέιζερ αντιστάθμιση',
    module_offset_10w: 'Αντιστάθμιση λέιζερ διόδου 10W',
    module_offset_20w: '20W λέιζερ διόδου αντιστάθμιση',
    module_offset_laser: 'Αντιστάθμιση λέιζερ',
    module_offset_printer: 'Αντιστάθμιση εκτυπωτή',
    none: 'Κανένα',
    normal: 'Υψηλό',
    notification_off: 'Απενεργοποίηση',
    notification_on: 'Ενεργοποίηση',
    notifications: 'Ειδοποιήσεις επιφάνειας εργασίας',
    off: 'Απενεργοποιημένο',
    on: 'Ενεργοποιημένο',
    preview_movement_speed: 'Ταχύτητα προεπισκόπησης κίνησης',
    printer_advanced_mode: 'Προηγμένη λειτουργία εκτυπωτή',
    printing_offset_tooltip: 'Αν το αποτέλεσμα εκτύπωσης μετατοπίζεται προς τα αριστερά ή προς τα πάνω, μειώστε την μετατόπιση X/Y· αν μετατοπίζεται προς τα δεξιά ή προς τα κάτω, αυξήστε την μετατόπιση X/Y.',
    remove_default_machine_button: 'Αφαίρεση',
    reset: 'Επαναφορά Beam Studio',
    reset_now: 'Επαναφορά Beam Studio',
    segmented_engraving: 'Τμηματική χάραξη',
    share_with_flux: 'Κοινοποίηση αναλυτικών Beam Studio',
    show_banners: 'Εμφάνιση μπάνερ αρχικής σελίδας',
    simplify_clipper_path: 'Βελτιστοποίηση σημείων αγκύρωσης',
    single_object: 'Ένα Αντικείμενο',
    tabs: {
      device: 'Συσκευή',
      general: 'Γενικά',
    },
    text_path_calc_optimization: 'Βελτιστοποίηση Υπολογισμού Διαδρομής Κειμένου',
    top_down: 'Από πάνω προς τα κάτω',
    trace_output: 'Έξοδος ιχνηλάτησης εικόνας',
    update_beta: 'Δοκιμαστική έκδοση',
    update_latest: 'Τελευταία',
    use_real_boundary: 'Χρησιμοποιήστε τη μέγιστη εμβέλεια',
    use_real_boundary_tooltip: 'Επέκταση στην πραγματική μέγιστη περιοχή εργασίας, χωρίς περιορισμό από γραμμές ακέραιου πλέγματος.',
    use_union_boundary: 'Εμφάνιση επικαλυπτόμενης περιοχής εργασίας',
    use_union_boundary_tooltip: 'Εμφάνιση επικαλυπτόμενων περιοχών εργασίας πολλών μονάδων',
    vector_order_optimization: 'Βελτιστοποίηση σειράς διανυσμάτων',
    vector_speed_constraint: 'Όριο ταχύτητας',
    wrong_ip_format: 'Λανθασμένη μορφή IP',
  },
  social_media: {
    facebook: 'Συζητήστε με FLUXers, κάντε ερωτήσεις και μάθετε συμβουλές!',
    instagram: 'Λάβετε τις τελευταίες εμπνεύσεις, προσφορές και δώρα!',
    youtube: 'Δείτε τα μαθήματα Beam Studio και ιδέες χειροτεχνίας.',
  },
  stamp_maker_panel: {
    bevel_radius: 'Ακτίνα λοξοτομής',
    horizontal_flip: 'Οριζόντια αναστροφή',
    how_to: {
      text: 'Πώς να φτιάξετε σφραγίδα;',
      url: 'https://support.flux3dp.com/hc/en-us/articles/13658787903247',
    },
    invert: 'Αντιστροφή',
    title: 'Δημιουργία Σφραγίδας',
  },
  support: {
    no_vcredist: 'Παρακαλώ εγκαταστήστε το Visual C++ Redistributable 2015<br/>Μπορείτε να το κατεβάσετε από flux3dp.com',
    no_webgl: 'Το WebGL δεν υποστηρίζεται. Παρακαλώ χρησιμοποιήστε άλλη συσκευή.',
  },
  tab_panel: {
    apply: 'Εφαρμογή καρτελών',
    gap: 'Κενό',
    help_center: 'https://support.flux3dp.com/hc/en-us/articles/12441363882511',
    manual_mode: 'Χειροκίνητη λειτουργία',
    title: 'Καρτέλες',
  },
  tips: {
    canvas_hold_space_to_pan: 'Κρατήστε πατημένο το πλήκτρο Space και σύρετε για μετακίνηση στον καμβά.',
    feature_auto_fit: 'Μετά την προεπισκόπηση κάμερας, χρησιμοποιήστε Ενέργειες → Αυτόματη Προσαρμογή για αυτόματη τοποθέτηση αντικειμένων στο υλικό σας.',
    feature_box_generator: 'Χρησιμοποιήστε Γεννήτριες → Γεννήτρια Κουτιών για να δημιουργήσετε κουτιά προσαρμοσμένου μεγέθους σε δευτερόλεπτα.',
    feature_code_generator: 'Χρησιμοποιήστε Γεννήτριες → Γεννήτρια Barcode για να δημιουργήσετε κωδικούς QR και barcodes.',
    feature_elements: 'Το πάνελ Στοιχεία περιλαμβάνει τώρα πάνω από ένα εκατομμύριο γραφικά έτοιμα προς χρήση.',
    feature_layer_color_configurations: 'Αντιστοιχίστε χρώματα επιπέδων SVG σε ταχύτητα και ισχύ μέσω Επεξεργασία → Επίπεδο → Ρυθμίσεις Χρώματος.',
    feature_material_test: 'Χρησιμοποιήστε Γεννήτριες → Γεννήτρια Δοκιμής Υλικού στην αριστερή γραμμή εργαλείων για να βρείτε γρήγορα τις καλύτερες ρυθμίσεις για ένα υλικό.',
    layer_execution_order: 'Η σειρά των επιπέδων καθορίζει τη σειρά εργασίας. Οι εργασίες εκτελούνται από πάνω προς τα κάτω.',
    machine_clean_mirror: 'Ελέγχετε τακτικά τους καθρέφτες και τον φακό εστίασης και καθαρίζετέ τους όταν χρειάζεται για να αποφύγετε τη συσσώρευση καπνού.',
    machine_no_unattended_operation: 'Μην αφήνετε ποτέ το μηχάνημα να λειτουργεί χωρίς επίβλεψη.',
    machine_regular_start: 'Εκτελέστε μια εργασία λέιζερ τουλάχιστον μία φορά κάθε δύο εβδομάδες για να βοηθήσετε στην επέκταση της διάρκειας ζωής του σωλήνα λέιζερ.',
    object_edit_image_to_erase: 'Χρησιμοποιήστε Εικόνα → Ενέργειες → Επεξεργασία Εικόνας για να διαγράψετε ανεπιθύμητες περιοχές σε μια εικόνα.',
    object_polygon_sides: 'Προσαρμόστε τον αριθμό των πλευρών στον πίνακα ιδιοτήτων του πολυγώνου.',
    object_rounded_rectangle: 'Ορίστε την ακτίνα της γωνίας ενός στρογγυλεμένου ορθογωνίου στον πίνακα ιδιοτήτων του ορθογωνίου.',
    object_sharpen_portrait: 'Βελτιώστε τις χαρακτικές πορτρέτων με Εικόνα → Ενέργειες → Όξυνση.',
    settings_auto_save: 'Ενεργοποιήστε την Αυτόματη Αποθήκευση στις Προτιμήσεις για να αποφύγετε να χάσετε τη δουλειά σας.',
    settings_default_text_font: 'Μπορείτε να ορίσετε την προεπιλεγμένη γραμματοσειρά για το εργαλείο Κειμένου στις Προτιμήσεις.',
    task_focus_lower_for_cutting: 'Για παχύτερα υλικά, η εστίαση περίπου 2 mm κάτω από την επιφάνεια μπορεί να βελτιώσει τα αποτελέσματα κοπής.',
    task_leather_moisten_reduce_burn: 'Υγράνετε ελαφρά το δέρμα πριν από την κοπή για να μειώσετε τα σημάδια καψίματος.',
    task_parameters_for_promark_color: 'Προσαρμόστε το πλάτος παλμού και τη συχνότητα σε λέιζερ MOPA για να παράγετε χρώματα σε ανοξείδωτο χάλυβα ή τιτάνιο.',
    task_slower_for_smoother_acrylic_edge: 'Η μείωση της ταχύτητας κοπής ελαφρώς μπορεί να παράγει πιο λείες ακρυλικές άκρες.',
    tips: 'Συμβουλές:',
  },
  topbar: {
    alerts: {
      add_content_first: 'Παρακαλώ προσθέστε αντικείμενα πρώτα',
      close_door_before_framing: 'Κλείστε την πόρτα πριν ξεκινήσετε την προεπισκόπηση πλαισίωσης.',
      door_opened: 'Παρακαλώ κλείστε το κάλυμμα της πόρτας για να ενεργοποιήσετε τη χαμηλής ισχύος λέιζερ λειτουργία.',
      fail_to_connect_with_camera: '#803 Αποτυχία σύνδεσης με την κάμερα. Κάντε επανεκκίνηση του μηχανήματος ή του Beam Studio. Αν το σφάλμα επιμένει, ακολουθήστε <a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/360001791895">αυτόν τον οδηγό</a>.',
      fail_to_get_door_status: 'Παρακαλώ βεβαιωθείτε ότι το κάλυμμα της πόρτας είναι κλειστό για να ενεργοποιήσετε τη χαμηλής ισχύος λέιζερ λειτουργία.',
      fail_to_start_preview: '#803 Αποτυχία εκκίνησης προεπισκόπησης. Κάντε επανεκκίνηση του μηχανήματος ή του Beam Studio. Αν το σφάλμα επιμένει, ακολουθήστε <a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/360001791895">αυτόν τον οδηγό</a>.',
      headtype_mismatch: 'Εντοπίστηκε λανθασμένος τύπος κεφαλής. ',
      headtype_none: 'Δεν εντοπίστηκε κεφαλή. ',
      headtype_unknown: 'Εντοπίστηκε άγνωστος τύπος κεφαλής. ',
      install_correct_headtype: 'Παρακαλώ εγκαταστήστε σωστά τις διοδικές λέιζερ κεφαλές 10W/20W για να ενεργοποιήσετε τη χαμηλής ισχύος λέιζερ λειτουργία.',
      job_origin_unavailable: 'Η ρύθμιση της προέλευσης της εργασίας απαιτεί έκδοση υλικολογισμικού 4.3.5 / 5.3.5 ή νεότερη. Θέλετε να ενημερώσετε το υλικολογισμικό τώρα;',
      job_origin_warning: 'Χρησιμοποιείτε την “τρέχουσα θέση” ως σημείο εκκίνησης. Βεβαιωθείτε ότι η κεφαλή λέιζερ έχει μετακινηθεί στη σωστή θέση για να αποφύγετε συγκρούσεις.',
      object_outside_moving_area: 'Ορισμένα αντικείμενα βρίσκονται εκτός της περιοχής προεπισκόπησης πλαισίου.',
      power_too_high: 'ΥΠΕΡΒΟΛΙΚΗ ΙΣΧΥΣ',
      power_too_high_confirm: 'ΣΗΜΕΙΩΘΗΚΕ',
      power_too_high_msg: 'Η χρήση χαμηλότερης ισχύος λέιζερ (κάτω από 70%) θα επεκτείνει τη διάρκεια ζωής του σωλήνα λέιζερ.\nΕισάγετε "ΣΗΜΕΙΩΘΗΚΕ" για να προχωρήσετε.',
      pwm_unavailable: 'Η Λειτουργία Βάθους απαιτεί έκδοση υλικολογισμικού 4.3.4 / 5.3.4 ή νεότερη. Θέλετε να ενημερώσετε το υλικολογισμικό τώρα;',
      QcleanScene: 'Θέλετε να διαγράψετε το σχέδιο;<br/>Αυτό θα διαγράψει επίσης το ιστορικό αναίρεσής σας!',
      start_preview_timeout: '#803 Χρονικό όριο κατά την εκκίνηση της προεπισκόπησης. Κάντε επανεκκίνηση του μηχανήματος ή του Beam Studio. Αν το σφάλμα επιμένει, ακολουθήστε <a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/360001791895">αυτόν τον οδηγό</a>.',
      variable_text_warning: 'Αυτή η εργασία περιέχει μεταβλητό κείμενο. Το σύστημα θα δώσει προτεραιότητα στη χάραξη του μεταβλητού κειμένου και δεν θα ακολουθήσει τη σειρά των επιπέδων.',
    },
    frame_task: 'Καδράρισμα',
    hint: {
      polygon: 'Πατήστε το πλήκτρο + / - για να αυξήσετε / μειώσετε τις πλευρές.',
    },
    menu: {
      about: 'Σχετικά με το Beam Studio',
      about_beam_studio: 'Σχετικά με το Beam Studio',
      accessories: 'Αξεσουάρ',
      account: 'Λογαριασμός',
      add_new_machine: 'Ρύθμιση μηχανής',
      align_center: 'Στοίχιση στο κέντρο',
      anti_aliasing: 'Αντι-aliasing',
      auto_align: 'Αυτόματη Στοίχιση',
      autofocus: {
        operating: 'Αυτόματη εστίαση...',
        select_device_error: 'Επιλέξτε συσκευή πριν την αυτόματη εστίαση.',
        show_probe_error: 'Εμφανίστε την ακίδα πριν την αυτόματη εστίαση.',
        title: 'Αυτόματη Εστίαση',
      },
      borderless_mode: 'Λειτουργία χωρίς πλαίσιο',
      bug_report: 'Αναφορά σφαλμάτων',
      calibrate_beambox_camera: 'Βαθμονόμηση κάμερας',
      calibrate_beambox_camera_borderless: 'Βαθμονόμηση κάμερας (Ανοιχτό κάτω μέρος)',
      calibrate_camera_advanced: 'Ρύθμιση κάμερας (Προχωρημένο)',
      calibrate_diode_module: 'Βαθμονόμηση μονάδας λέιζερ διόδου',
      calibrate_ir_module: 'Βαθμονόμηση υπέρυθρης μονάδας',
      calibrate_printer_module: 'Βαθμονόμηση εκτυπωτικής μονάδας',
      calibrate_wide_angle_camera: 'Βαθμονόμηση κάμερας (Κάμερα ευρείας γωνίας)',
      calibration: 'Βαθμονομήσεις',
      camera_calibration_data: 'Δεδομένα Βαθμονόμησης Κάμερας',
      change_logs: 'Καταγραφή αλλαγών',
      clear_scene: 'Νέα αρχεία',
      close: 'Κλείσιμο παραθύρου',
      commands: 'Εντολές',
      contact: 'Επικοινωνήστε μαζί μας',
      copy: 'Αντιγραφή',
      cut: 'Αποκοπή',
      dashboard: 'Πίνακας ελέγχου',
      decompose_path: 'Αποσυνθέστε',
      delete: 'Διαγραφή',
      design_market: 'Αγορά σχεδίων',
      dev_tool: 'Εργαλείο Εντοπισμού Σφαλμάτων',
      disassemble_use: 'Αποσυναρμολόγηση',
      document_setting: 'Ρυθμίσεις εγγράφου',
      document_setting_short: 'Έγγραφο',
      download_log: 'Κατεβάστε αρχεία καταγραφής',
      download_log_canceled: 'Η λήψη αρχείου καταγραφής ακυρώθηκε',
      download_log_error: 'Παρουσιάστηκε άγνωστο σφάλμα, δοκιμάστε ξανά αργότερα',
      duplicate: 'Αντιγραφή',
      edit: 'Επεξεργασία',
      example_files: 'Αρχεία Παραδείγματος',
      export_BVG: 'BVG',
      export_calibration_data: 'Εξαγωγή δεδομένων βαθμονόμησης',
      export_flux_task: 'Εξαγωγή εργασίας FLUX',
      export_JPG: 'JPG',
      export_PNG: 'PNG',
      export_SVG: 'SVG',
      export_to: 'Εξαγωγή σε...',
      export_UV_print: 'UV Εκτύπωση PDF',
      file: 'Αρχείο',
      fit_to_window: 'Προσαρμογή στο μέγεθος παραθύρου',
      follow_us: 'Ακολούθησέ μας',
      forum: 'Κοινότητα φόρουμ',
      group: 'Ομαδοποίηση',
      help: 'Βοήθεια',
      help_center: 'Κέντρο βοήθειας',
      hide: 'Απόκρυψη Beam Studio',
      hideothers: 'Απόκρυψη άλλων',
      image_crop: 'Περικοπή',
      image_curve: 'Καμπύλη',
      image_invert: 'Αντιστροφή',
      image_sharpen: 'Εστίαση',
      image_stamp: 'Υδατογραφήματα',
      image_vectorize: 'Ιχνηλάτηση',
      import_acrylic_focus_probe: 'beamo & Beambox Αισθητήρας Εστίασης - 3mm',
      import_ador_laser_example: 'Παράδειγμα Laser Ador',
      import_ador_printing_example_full: 'Παράδειγμα εκτύπωσης Ador - Πλήρες χρώμα',
      import_ador_printing_example_single: 'Παράδειγμα εκτύπωσης Ador - Ένα χρώμα',
      import_beambox_2_example: 'Παράδειγμα του Beambox II',
      import_beambox_2_focus_probe: 'Beambox II Αισθητήρας Εστίασης - 3mm',
      import_beamo_2_laser_example: 'Παράδειγμα Laser beamo II',
      import_beamo_2_printing_example: 'Παράδειγμα εκτύπωσης beamo II',
      import_beamo_2_printing_test: 'Δοκιμή εκτύπωσης beamo II',
      import_calibration_data: 'Εισαγωγή δεδομένων βαθμονόμησης',
      import_hello_beambox: 'Παράδειγμα Beambox',
      import_hello_beamo: 'Παράδειγμα του beamo',
      import_hexa_example: 'Παράδειγμα HEXA',
      import_hexa_rf_example: 'Παράδειγμα HEXA RF',
      import_material_printing_test: 'Δοκιμή εκτύπωσης υλικού',
      import_material_testing_cut: 'Δοκιμή κοπής υλικού',
      import_material_testing_engrave: 'Δοκιμή χάραξης υλικού',
      import_material_testing_line: 'Δοκιμή γραμμής υλικού',
      import_material_testing_old: 'Δοκιμή χάραξης υλικού - Κλασική',
      import_material_testing_simple_cut: 'Δοκιμή κοπής υλικού - Απλή',
      import_promark_engraving_example_1: 'Παράδειγμα χάραξης Promark I',
      import_promark_engraving_example_2: 'Παράδειγμα χάραξης Promark II',
      import_promark_example: 'Παράδειγμα Promark',
      import_promark_mopa_20w_color: 'MOPA 20W Δοκιμή Χρώματος',
      import_promark_mopa_60w_color: 'MOPA 60W Δοκιμή Χρώματος',
      import_promark_mopa_100w_color: 'MOPA 100W Δοκιμή Χρώματος',
      keyboard_shortcuts: 'Συντομεύσεις πληκτρολογίου',
      layer_color_config: 'Ρυθμίσεις χρωμάτων',
      layer_setting: 'Στρώμα',
      link: {
        autocad: 'https://support.flux3dp.com/hc/en-us/articles/16590795274895',
        beam_studio_api: 'https://github.com/flux3dp/beam-studio/wiki/Beam-Studio-Easy-API',
        contact_us: 'https://support.flux3dp.com/hc/en-us/requests/new',
        design_market: 'https://dmkt.io',
        downloads: 'https://flux3dp.com/downloads/',
        forum: 'https://www.facebook.com/groups/flux.laser/',
        help_center: 'https://helpcenter.flux3dp.com/',
        shortcuts: 'https://support.flux3dp.com/hc/en-us/articles/10003978157455',
      },
      log: {
        camera: 'Κάμερα',
        cloud: 'Νέφος',
        discover: 'Ανακάλυψη',
        hardware: 'Υλικό',
        network: 'Δίκτυο',
        player: 'Πρόγραμμα αναπαραγωγής',
        robot: 'Ρομπότ',
        usb: 'USB',
        usblist: 'Λίστα USB',
      },
      login_or_register: 'Σύνδεση ή Εγγραφή',
      logout: 'Αποσύνδεση',
      machine_info: 'Πληροφορίες μηχανήματος',
      machines: 'Μηχανές',
      maintenance_checklist: 'Λίστα συντήρησης',
      manage_account: 'Διαχείριση λογαριασμού',
      material_test: 'Δοκιμή Υλικού',
      minimize: 'Ελαχιστοποίηση',
      my_account: 'Ο λογαριασμός μου',
      network_testing: 'Δοκιμή ρυθμίσεων δικτύου',
      object: 'Αντικείμενο',
      offset: 'Μετατόπιση',
      open: 'Άνοιγμα',
      paste: 'Επικόλληση',
      paste_in_place: 'Επικόλληση στη θέση',
      path: 'Διαδρομή',
      photo_edit: 'Επεξεργασία εικόνας',
      plugin: 'Πρόσθετο',
      preferences: 'Προτιμήσεις',
      questionnaire: 'Ερωτηματολόγιο ανατροφοδότησης',
      quit: 'Έξοδος',
      recent: 'Άνοιγμα Πρόσφατων',
      redo: 'Επανάληψη',
      reload_app: 'Επαναφόρτωση Εφαρμογής',
      reset: 'Επαναφορά',
      reset_layout: 'Επαναφορά διάταξης',
      rotary_setup: 'Ρυθμίσεις Περιστροφής',
      rotate: 'Περιστροφή',
      samples: 'Παραδείγματα',
      save_as: 'Αποθήκευση ως...',
      save_scene: 'Αποθήκευση',
      save_to_cloud: 'Αποθήκευση στο Cloud',
      scale: 'Κλίμακα',
      service: 'Υπηρεσίες',
      set_as_default: 'Ορισμός ως προεπιλογή',
      show_gesture_tutorial: 'Εισαγωγή χειρονομιών',
      show_grids: 'Εμφάνιση πλεγμάτων',
      show_layer_color: 'Χρήση χρώματος στρώματος',
      show_rulers: 'Εμφάνιση οδηγών',
      show_start_tutorial: 'Εμφάνιση εισαγωγικού μαθήματος',
      show_ui_intro: 'Εμφάνιση εισαγωγής διεπαφής',
      software_update: 'Ενημέρωση λογισμικού',
      svg_edit: 'SVG',
      switch_to_beta: 'Μετάβαση σε Beta Έκδοση',
      switch_to_latest: 'Μετάβαση σε Σταθερή Έκδοση',
      tab_layers: 'Επίπεδα',
      tab_objects: 'Αντικείμενα',
      tab_path_edit: 'Επεξεργασία Μονοπατιού',
      tools: {
        title: 'Εργαλεία',
      },
      tutorial: 'Ξεκινήστε το εκπαιδευτικό πρόγραμμα εκτύπωσης Delta',
      undo: 'Αναίρεση',
      ungroup: 'Κατάργηση ομαδοποίησης',
      update: 'Έλεγχος Ενημέρωσης',
      update_firmware: 'Ενημέρωση υλικολογισμικού',
      update_machine: 'Ενημέρωση μηχανήματος',
      update_mainboard: 'Ενημέρωση μητρικής πλακέτας',
      update_printer_board: 'Ενημέρωση πλακέτας ελεγκτή εκτυπωτή',
      using_beam_studio_api: 'Χρήση Beam Studio API',
      view: 'Προβολή',
      window: 'Παράθυρο',
      zoom_in: 'Μεγέθυνση',
      zoom_out: 'Σμίκρυνση',
      zoom_with_window: 'Αυτόματη προσαρμογή στο μέγεθος παραθύρου',
    },
    rename_tab: 'Μετονομασία καρτέλας',
    select_machine: 'Επιλέξτε μηχανή',
    tag_names: {
      dxf: 'DXF Αντικείμενο',
      ellipse: 'Ελλειψοειδές',
      fit_text: 'Πλαίσιο κειμένου',
      g: 'Ομάδα',
      image: 'Εικόνα',
      line: 'Γραμμή',
      multi_select: 'Πολλαπλά Αντικείμενα',
      no_selection: 'Καμία επιλογή',
      pass_through_object: 'Διέλευση Αντικειμένου',
      path: 'Διαδρομή',
      polygon: 'Πολύγωνο',
      rect: 'Ορθογώνιο',
      svg: 'SVG Αντικείμενο',
      text: 'Κείμενο',
      text_path: 'Κείμενο σε Διαδρομή',
      use: 'Εισαγόμενο Αντικείμενο',
    },
    task_preview: 'Προεπισκόπηση διαδρομής',
    untitled: 'Χωρίς τίτλο',
  },
  topmenu: {
    credit: 'Το Beam Studio καθίσταται δυνατό από το ανοιχτού κώδικα έργο <a target="_blank" href="https://github.com/flux3dp/beam-studio">Beam Studio</a> και άλλο <a target="_blank" href="https://flux3dp.com/credits/">λογισμικό ανοιχτού κώδικα</a>.',
    device: {
      download_log_canceled: 'Η λήψη αρχείου καταγραφής ακυρώθηκε',
      download_log_error: 'Παρουσιάστηκε άγνωστο σφάλμα, δοκιμάστε ξανά αργότερα',
      log: {
        usblist: 'Λίστα USB',
      },
      network_test: 'Δοκιμή δικτύου',
    },
    file: {
      all_files: 'Όλα τα αρχεία',
      clear_recent: 'Εκκαθάριση πρόσφατων αρχείων',
      converting: 'Μετατροπή σε εικόνα...',
      fcode_files: 'Κώδικας FLUX',
      import: 'Εισαγωγή',
      jpg_files: 'JPG',
      label: 'Αρχείο',
      path_not_exit: 'Αυτή η διαδρομή δεν υπάρχει πλέον στον δίσκο.',
      png_files: 'PNG',
      save_fcode: 'Εξαγωγή Εργασίας FLUX',
      save_jpg: 'Εξαγωγή JPG',
      save_pdf: 'Εξαγωγή PDF',
      save_png: 'Εξαγωγή PNG',
      save_scene: 'Αποθήκευση Σκηνής',
      save_svg: 'Εξαγωγή SVG',
      scene_files: 'Σκηνές Beam Studio',
      svg_files: 'SVG',
    },
    version: 'Έκδοση',
  },
  tutorial: {
    ask_retry_calibration: 'Θα θέλατε να επαναλάβετε τη βαθμονόμηση της κάμερας;',
    camera_calibration_failed: 'Αποτυχία βαθμονόμησης κάμερας',
    gesture: {
      click: 'Πατήστε για επιλογή αντικειμένου',
      drag: 'Σύρετε για πολλαπλή επιλογή',
      hold: 'Πατήστε παρατεταμένα για αναδυόμενο μενού',
      pan: 'Κάντε κύλιση στον καμβά με δύο δάχτυλα.',
      zoom: 'Αγγίξτε με δύο δάχτυλα για μεγέθυνση / σμίκρυνση',
    },
    links: {
      adjust_focus: 'https://support.flux3dp.com/hc/en-us/articles/360001684196',
    },
    look_for_machine: 'Αναζήτηση μηχανής για το εκπαιδευτικό πρόγραμμα...',
    needNewInterfaceTutorial: 'Θα θέλατε να ξεκινήσετε ένα εκπαιδευτικό πρόγραμμα για το νέο διεπαφής του Beam Studio;<br/>(Μπορείτε να το παραλείψετε τώρα και να ξεκινήσετε αργότερα κάνοντας κλικ στο "Βοήθεια" > "Εμφάνιση Εισαγωγής Διεπαφής".)',
    needNewUserTutorial: 'Θέλετε να ξεκινήσετε ένα εκπαιδευτικό πρόγραμμα;<br/>(Μπορείτε να το παραλείψετε τώρα και να ξεκινήσετε αργότερα κάνοντας κλικ στο "Βοήθεια" > "Εμφάνιση Έναρξης Οδηγού".)',
    newInterface: {
      add_new_layer: 'Προσθήκη Νέου Επιπέδου',
      align_controls: 'Έλεγχοι ευθυγράμμισης',
      basic_shapes: 'Βασικά Σχήματα',
      camera_preview: 'Προεπισκόπηση Κάμερας',
      drag_to_sort: 'Σύρετε για ταξινόμηση',
      end_alert: 'Είστε σίγουροι ότι θέλετε να τερματίσετε την εισαγωγή στο νέο περιβάλλον χρήστη;',
      flip: 'Αναστροφή',
      group_controls: 'Έλεγχοι ομαδοποίησης',
      layer_controls: 'Δεξί κλικ για επιλογή ελέγχων στρώματος: Αντιγραφή / Συγχώνευση / Κλείδωμα / Διαγραφή στρωμάτων',
      object_actions: 'Ενέργειες αντικειμένου',
      pen_tool: 'Εργαλείο Πένας',
      rename_by_double_click: 'Μετονομασία με διπλό κλικ',
      select_image_text: 'Επιλογή / Εικόνα / Κείμενο',
      select_machine: 'Επιλέξτε μια μηχανή',
      shape_operation: 'Λειτουργία σχήματος',
      start_work: 'Ξεκινήστε την εργασία',
      switch_between_layer_panel_and_object_panel: 'Εναλλαγή μεταξύ του πίνακα στρωμάτων και του πίνακα αντικειμένων',
    },
    newUser: {
      add_new_layer: 'Προσθήκη νέου στρώματος',
      adjust_focus: '2. Ρυθμίστε την εστίαση',
      close_cover: '3. Κλείστε το κάλυμμα',
      drag_to_draw: 'Σύρετε για σχεδίαση',
      draw_a_circle: 'Σχεδιάστε έναν κύκλο',
      draw_a_rect: 'Σχεδιάστε ένα ορθογώνιο',
      end_alert: 'Είστε σίγουροι ότι θέλετε να τερματίσετε την εκμάθηση;',
      end_preview_mode: 'Τερματισμός Λειτουργίας Προεπισκόπησης',
      infill: 'Ενεργοποίηση πλήρωσης',
      please_select_wood_cutting: 'Παρακαλώ επιλέξτε την προεπιλογή "Ξύλο - Κοπή"',
      please_select_wood_engraving: 'Παρακαλώ επιλέξτε την προεπιλογή "Ξύλο - Χάραξη"',
      preview_the_platform: 'Προεπισκόπηση της Πλατφόρμας',
      put_wood: '1. Τοποθετήστε το δείγμα ξύλου',
      send_the_file: 'Αποστολή Αρχείου',
      set_preset_wood_cut: 'Ορισμός προεπιλογής: Ξύλο - Κοπή',
      set_preset_wood_engraving: 'Ορισμός προεπιλογής: Ξύλο - Χάραξη',
      start_tutorial: 'Εισαγωγικό μάθημα',
      switch_to_layer_panel: 'Μετάβαση στο πάνελ στρωμάτων',
      switch_to_object_panel: 'Μετάβαση στο πίνακα αντικειμένων',
      switch_to_preview_mode: 'Μετάβαση σε λειτουργία προεπισκόπησης',
    },
    next: 'ΕΠΟΜΕΝΟ',
    retry: 'Επανάληψη',
    set_connection: 'Ορισμός σύνδεσης',
    skip: 'Παράλειψη',
    skip_tutorial: 'Παρακάμψατε το εκπαιδευτικό. Μπορείτε να το ξεκινήσετε από το μενού Βοήθεια.',
    suggest_calibrate_camera_first: 'Συνιστούμε στους χρήστες να βαθμονομήσουν αρχικά την κάμερα και να επαναφέρουν την εστίαση πριν από κάθε προεπισκόπηση για βέλτιστα αποτελέσματα.<br/>Θα θέλατε να επιβεβαιώσετε τη διενέργεια της βαθμονόμησης τώρα;<br/>(Μπορείτε να το παραλείψετε τώρα και να το κάνετε αργότερα κάνοντας κλικ στο "Μενού" > "Μηχάνημα" > [Η Συσκευή Σας] > "Βαθμονόμηση Κάμερας".)',
    tutorial_complete: 'Αυτό ήταν όλο για το εκπαιδευτικό. Ώρα για δημιουργία!',
    unable_to_find_machine: 'Δεν βρέθηκε μηχανή για το εκπαιδευτικό. Θέλετε να μεταβείτε στις ρυθμίσεις, να επαναλάβετε ή να το παραλείψετε;',
    welcome: 'ΚΑΛΩΣ ΟΡΙΣΑΤΕ',
  },
  update: {
    cannot_reach_internet: '#823 Ο διακομιστής δεν είναι προσβάσιμος<br/>Ελέγξτε τη σύνδεση στο διαδίκτυο',
    download: 'ΔΙΑΔΙΚΤΥΑΚΗ ΕΝΗΜΕΡΩΣΗ',
    firmware: {
      caption: 'Μια ενημέρωση υλικολογισμικού για το μηχάνημα είναι διαθέσιμη',
      confirm: 'ΜΕΤΑΦΟΡΤΩΣΗ',
      firmware_too_old_update_by_sdcard: 'Η έκδοση υλικολογισμικού είναι πολύ παλιά. Παρακαλώ αναβαθμίστε το υλικολογισμικό χρησιμοποιώντας μια κάρτα SD.',
      force_update_message: '#814 Παρακαλώ αναβαθμίστε τη μηχανή σας στην τελευταία έκδοση υλικολογισμικού.',
      latest_firmware: {
        cant_get_latest: 'Αδυναμία λήψης πληροφοριών για την τελευταία έκδοση υλικολογισμικού.',
        caption: 'Ενημέρωση υλικολογισμικού μηχανήματος',
        message: 'Έχετε την τελευταία έκδοση υλικολογισμικού μηχανήματος',
        still_update: 'ΕΝΗΜΕΡΩΣΗ',
      },
      message_pattern_1: 'Το "%s" είναι τώρα έτοιμο για ενημέρωση υλικολογισμικού.',
      message_pattern_2: '%s Υλικολογισμικό v%s είναι τώρα διαθέσιμο - Έχετε το v%s.',
      too_old_for_web: 'Η τρέχουσα έκδοση υλικολογισμικού της μηχανής σας είναι η v%s.\nΑν θέλετε να χρησιμοποιήσετε την online έκδοση του Beam Studio, αναβαθμίστε το υλικολογισμικό της μηχανής στην τελευταία έκδοση.',
      update_fail: '#822 Αποτυχία αναβάθμισης',
      update_success: 'Επιτυχής αναβάθμιση υλικολογισμικού',
      upload_firmware_title: 'Φόρτωση υλικολογισμικού (*.fxfw)',
      upload_mainboard_title: 'Ανέβασμα υλικολογισμικού μητρικής πλακέτας (*.bin)',
      upload_printer_board_title: 'Ανέβασμα υλικολογισμικού πλακέτας εκτυπωτή (*.bin)',
    },
    install: 'ΕΓΚΑΤΑΣΤΑΣΗ',
    later: 'ΑΡΓΟΤΕΡΑ',
    preparing: 'Προετοιμασία...',
    release_note: 'Σημείωση έκδοσης:',
    skip: 'Παράλειψη Αυτής Της Έκδοσης',
    software: {
      available_switch: 'Το Beam Studio v%s είναι διαθέσιμο. Έχετε την έκδοση v%s. Θέλετε να αναβαθμίσετε;',
      available_update: 'Το Beam Studio v%s είναι διαθέσιμο. Έχετε την έκδοση v%s. Θέλετε να κατεβάσετε την ενημέρωση;',
      caption: 'Διαθέσιμη ενημέρωση λογισμικού για το Beam Studio',
      check_update: 'Έλεγχος για ενημέρωση',
      checking: 'Έλεγχος για ενημέρωση',
      downloading: 'Γίνεται λήψη ενημερώσεων στο παρασκήνιο, μπορείτε να κάνετε κλικ στο "ΟΚ" για να συνεχίσετε την εργασία σας.',
      install_or_not: 'είναι έτοιμο για ενημέρωση. Θα θέλατε να κάνετε επανεκκίνηση και να αναβαθμίσετε τώρα;',
      no: 'Όχι',
      no_response: 'Αποτυχία σύνδεσης με τον διακομιστή, ελέγξτε τις ρυθμίσεις δικτύου σας.',
      not_found: 'Χρησιμοποιείτε την τελευταία έκδοση του Beam Studio.',
      switch_or_not: 'Το λογισμικό είναι έτοιμο για αναβάθμιση. Θέλετε να κάνετε επανεκκίνηση τώρα;',
      switch_version: 'Αλλαγή έκδοσης',
      switch_version_not_found: 'Δεν βρέθηκε διαθέσιμη έκδοση για αναβάθμιση.',
      update_for_ador: 'Η τρέχουσα έκδοση λογισμικού %s δεν είναι συμβατή, παρακαλώ κατεβάστε την τελευταία έκδοση του Beam Studio για τον Ador.',
      yes: 'Ναι',
    },
    update: 'Ενημέρωση',
    updating: 'Αναβάθμιση...',
    upload: 'ΜΕΤΑΦΟΡΤΩΣΗ',
  },
  variable_text_settings: {
    advance_by: 'Προώθηση κατά',
    auto_advance: 'Αυτόματη προώθηση',
    auto_advance_hint: 'Μεταβαίνει αυτόματα στα επόμενα μεταβλητά δεδομένα κάθε φορά που εκτελείται μια εργασία.',
    bake: 'Οριστικοποίηση',
    bake_description: 'Κατάργηση μεταβλητότητας και μετατροπή σε κανονικό κείμενο',
    browse: 'Περιήγηση',
    clear: 'Καθαρισμός',
    csv_file: 'Αρχείο CSV',
    current: 'Τρέχων',
    end: 'Τέλος',
    failed_to_convert: 'Το αντικείμενο μεταβλητού κειμένου περιέχει μη υποστηριζόμενη μορφή, κάτι που ενδέχεται να εμποδίσει την εμφάνιση του περιεχομένου.',
    file_error: 'Αποτυχία ανάλυσης αρχείου CSV, ελέγξτε τη μορφή αρχείου.',
    file_size_exceeded: 'Η μεταφόρτωση αρχείου απέτυχε, το μέγεθος αρχείου υπερβαίνει τα 5 MB.',
    next: 'Επόμενο',
    note: 'Αυτή η ρύθμιση θα εφαρμοστεί αυτόματα σε όλα τα μεταβλητά κείμενα',
    previous: 'Προηγούμενο',
    start: 'Έναρξη',
    test: 'Δοκιμή',
    test_description: 'Πατήστε παρατεταμένα για να δείτε το μεταβλητό κείμενο',
    title: 'Ρυθμίσεις μεταβλητών κειμένων',
  },
  web_cam: {
    image_to_small: 'Το μέγεθος της εικόνας της κάμερας είναι πολύ μικρό. Η εικόνα μπορεί να είναι κατεστραμμένη.',
    no_device: 'Δεν είναι δυνατή η ανίχνευση της κάμερας. Παρακαλώ συνδέστε ξανά την κάμερα και δοκιμάστε ξανά.',
    no_permission: 'Το Beam Studio δεν έχει άδεια πρόσβασης στην κάμερα. Βεβαιωθείτε ότι έχει δοθεί άδεια στο Beam Studio από τις ρυθμίσεις του προγράμματος περιήγησης ή του συστήματος.',
  },
  welcome_page: {
    follow_us: {
      subtitle: 'Πάρε έμπνευση, προσφορές, δωρεάν δώρα και συνδέσου με την κοινότητα της FLUX!',
      user_group: 'Ομάδα χρηστών',
    },
    help_center: {
      guides: 'Οδηγοί',
      guides_subtitle: 'Δείτε αναλυτικούς οδηγούς για όλα τα προϊόντα FLUX.',
      submit_request: 'Υποβολή αίτησης',
      subtitle: 'Οδηγοί, εγχειρίδια και πόροι υποστήριξης για όλα όσα σχετίζονται με τη FLUX.',
      visit_help_center: 'Επισκεφθείτε το Κέντρο βοήθειας',
    },
    member_center: 'Κέντρο Μελών',
    member_center_url: 'https://member.flux3dp.com/en-US/machine-register',
    new_project: 'Νέο έργο',
    not_login_placeholder: 'Λάβετε δωρεάν πιστώσεις AI από εμάς όταν εγγραφείτε για έναν λογαριασμό FLUX!',
    recent_files: 'Πρόσφατα αρχεία',
    shop: 'Κατάστημα',
    shop_products: 'Αγορά προϊόντων FLUX',
  },
  z_speed_limit_test: {
    alert_before: 'Πριν ξεκινήσει η χάραξη καμπύλης, το σύστημα θα πραγματοποιήσει δοκιμή φορτίου για να αποτρέψει την απώλεια βημάτων λόγω υπερβολικού βάρους.',
    alert_failed: 'Το βάρος του τρέχοντος αντικειμένου υπερβαίνει το όριο φορτίου για την τρέχουσα ταχύτητα του άξονα Ζ. Μειώστε την ταχύτητα του άξονα Ζ στον πίνακα ελέγχου του μηχανήματος ή αντικαταστήστε το αντικείμενο χάραξης πριν επαναλάβετε τη δοκιμή.',
    ignore: 'Αγνόηση',
    retest: 'Επανάληψη δοκιμής',
    testing: 'Εκτελείται δοκιμή φόρτωσης...',
  },
};

export default lang;
